import React, { Component } from "react";
import Icon, {
  IconBaseProps,
} from "@ad/anq-iconfont.macro/lib/components/BaseIcon";
export class NormalDetailFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M880 112h-736a32 32 0 0 0-32 32v736a32 32 0 0 0 32 32h736a32 32 0 0 0 32-32v-736a32 32 0 0 0-32-32z m-560 584a40 40 0 1 1 40-40 40 40 0 0 1-40 40z m0-144a40 40 0 1 1 40-40 40 40 0 0 1-40 40z m0-144a40 40 0 1 1 40-40 40 40 0 0 1-40 40z m424 272a8 8 0 0 1-8 8h-304a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h304a8 8 0 0 1 8 8z m0-144a8 8 0 0 1-8 8h-304a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h304a8 8 0 0 1 8 8z m0-144a8 8 0 0 1-8 8h-304a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h304a8 8 0 0 1 8 8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalFollowFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M812 112h-600a32 32 0 0 0-32 32v736a32 32 0 0 0 32 32h8c0.6 0 1.1 0 1.7 0a31.8 31.8 0 0 0 17.4-4.3l274.4-158.4 274.5 158.4 0.1 0.1 1.3 0.7 0.1 0c0.4 0.2 0.8 0.4 1.3 0.7l0.2 0 1.3 0.6 0.2 0.1c0.4 0.2 0.8 0.3 1.2 0.4a3.6 3.6 0 0 0 0.4 0.1l1.1 0.4 0.4 0.1 1 0.2 0.7 0.2 0.8 0.1 0.8 0.2 0.7 0.1c0.3 0.1 0.6 0.1 0.9 0.1l0.6 0.1 1 0 0.6 0 1 0h8.3a32 32 0 0 0 32-32v-735.9a32 32 0 0 0-32-32z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalPrivateFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M233.6 721.3c78.8 25.3 174.8 40.2 278.4 40.2s199.7-14.9 278.4-40.2a8 8 0 0 0 5.6-7.6v-6.8c0-131.5-91.4-242.6-213.8-273.1a164.5 164.5 0 1 0-140.4 0c-122.4 30.5-213.8 141.6-213.8 273.1v6.8a8 8 0 0 0 5.6 7.6z"></path>
      <path d="M859.3 684.9q0.7 11 0.7 22v6.8a71.8 71.8 0 0 1-50 68.5c-88 28.3-191 43.3-298 43.3s-210-15-298-43.3a71.8 71.8 0 0 1-50-68.5v-6.8q0-11 0.7-22c-78.9 23.2-127.2 54.4-127.2 88.6 0 71.8 212.4 130 474.5 130s474.5-58.2 474.5-130c0-34.2-48.3-65.4-127.2-88.6z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalSceneFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M854.5 233.3l-294.3-146.9a104 104 0 0 0-92.5-0.2l-297.8 147.2a104 104 0 0 0-57.9 93.2v370.8a104 104 0 0 0 57.9 93.2l297.8 147.2a104 104 0 0 0 92.5-0.2l294.3-146.9a104 104 0 0 0 57.5-93v-371.4a104 104 0 0 0-57.6-93z m-109.2 225l-105 102.3 24.7 144.7a16 16 0 0 1-23.2 16.8l-129.8-68.2-129.8 68.2a16 16 0 0 1-23.2-16.8l24.8-144.6-105-102.4a16 16 0 0 1 8.8-27.3l145.1-21.1 64.9-131.5a16 16 0 0 1 28.7 0l65 131.5 145.1 21.1a16 16 0 0 1 8.9 27.3z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandProductPromotion extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M929.3 932.8l-83.3-648.9a24 24 0 0 0-23.8-20.9l-108.4 0a200.9 200.9 0 0 0-401.8 0.1l-108.5 0a24 24 0 0 0-23.8 21l-83 648.9a24 24 0 0 0 23.8 27l785-0.2a24 24 0 0 0 23.8-27z m-507.5-758.2a129 129 0 0 1 220 88.4l-257.8 0.1a127.5 127.5 0 0 1 37.8-88.5z m-191.4 713.4l376.3-327.3-21 156.2a8 8 0 0 0 7.9 9h56.5a8 8 0 0 0 7.9-6.9l33.4-247.8a32 32 0 0 0-31.8-36.3h-256.4a8 8 0 0 0-8 8v56a8 8 0 0 0 8 8h155.7l-377.1 328 63.9-499.7 534.3-0.2 71 552.8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandProductPromotionFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M913.3 933.9l-67.3-648.5a24 24 0 0 0-23.8-20.9l-108.4 0a201 201 0 0 0-401.9 0l-108.6 0a24 24 0 0 0-23.8 21l-66.8 522c-2.8 22 23.1 35.7 39.7 21l352.8-312.1-66.1-73.4a16 16 0 0 1 11.9-26.7h237.6a24 24 0 0 1 23.8 27.2l-30.8 229.4a16 16 0 0 1-27.7 8.5l-67.9-75.3-353.8 313c-16.6 14.6-6.2 42 15.9 42l641.4-0.2a24 24 0 0 0 23.8-27z m-529.5-669.3a129 129 0 0 1 258-0.1z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandIntelligentBudgetFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M767.8 391.1c-24-118.7-129-208.1-254.8-208.1-126 0-231.1 89.7-254.9 208.7-108.2 16.8-191.1 110.4-191.1 223.3 0 116.8 88.6 212.9 202.2 224.8a32 32 0 0 0 28-11.6l213.1-259-88.6-63c-13.1-8.8-6.9-29.3 8.9-29.2l270.1-2a16 16 0 0 1 13.2 25l-251.9 315a16 16 0 0 0 12.5 26h260.7c124.6 0 228.1-102 227.8-226.6-0.3-114.1-85.1-208.3-195.2-223.3z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandIntelligentBudget extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M900.5 446.3a246.8 246.8 0 0 0-126.1-73.6 268.6 268.6 0 0 0-89.1-129.4c-49.3-39.3-111.7-60.9-175.7-60.9s-126.5 21.7-175.8 61.1a268.4 268.4 0 0 0-89.2 130.1 246.8 246.8 0 0 0-123.6 74.2 233.1 233.1 0 0 0-60 155.7c0 63.7 25.7 123.5 72.3 168.4 46.1 44.4 107.2 68.9 172.2 69.1h0.6a236.2 236.2 0 0 0 155.9-59.1l1.1-1 260.4-270.8a16 16 0 0 0-11.5-27.1h-236a8 8 0 0 0-8 8v56a8 8 0 0 0 8 8h104.4l-167.1 173.8a164.3 164.3 0 0 1-107.5 40.2c-95.3-0.1-172.8-74.3-172.8-165.5a161.2 161.2 0 0 1 41.6-107.6 175.3 175.3 0 0 1 104.5-55.8l24.8-3.8 5.1-24.5c9.1-43.6 33.8-83.3 69.7-112 36.6-29.3 83.1-45.4 130.9-45.4s94.2 16.1 130.8 45.2c35.9 28.6 60.6 68.2 69.8 111.7l5.2 25 25.3 3.4a175.3 175.3 0 0 1 106.7 55.1 161.1 161.1 0 0 1 42.6 108.7c0 91.2-77.6 165.5-173.1 165.5h-111.9a8 8 0 0 0-8 8v56a8 8 0 0 0 8 8h111.9c65.2 0 126.6-24.5 172.8-69.1 46.6-44.9 72.3-104.7 72.3-168.4 0-58-21.8-113.9-61.5-157.2z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandServiceCentreFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M924.8 338.4a447.4 447.4 0 0 0-413.2-274.4h-2a448.2 448.2 0 0 0-398 650v152a46 46 0 0 0 46 46h152.1a449.4 449.4 0 0 0 199.9 48h2.1a446.4 446.4 0 0 0 315.5-129.5 449.6 449.6 0 0 0 97.6-492.1z m-200.9 237.7a240.1 240.1 0 0 1-424.1-0.5h0a36 36 0 1 1 63.9-33.1h0a168 168 0 0 0 296.6-0.2h0a36 36 0 1 1 63.5 33.8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandImcFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M889.1 768l-110.8-183.7a72 72 0 1 0-123.3-4.4l-113.4 188.1-0.6 0a72 72 0 1 0 64.5 104h218a72 72 0 1 0 65.6-104z m-65.6 40h-218a72.5 72.5 0 0 0-6.7-11l109.1-180.8a71.9 71.9 0 0 0 10.1 0.8c1.7 0 3.4-0.1 5.1-0.2l108 179a72.7 72.7 0 0 0-7.6 12.2z"></path>
      <path d="M502 709.6l82.8-137.2a136 136 0 1 1 264.9 6.4l79.3 131.5a134.7 134.7 0 0 1 31 14.3v-580.6a32 32 0 0 0-32-32h-832a32 32 0 0 0-32 32v640a32 32 0 0 0 32 32h311.1a136.3 136.3 0 0 1 94.9-106.4z m-174-259.7c0 4.4-2.9 8-6.4 8h-147.2c-3.5 0-6.4-3.6-6.4-8v-48c0-4.4 2.9-8 6.4-8h147.2c3.5 0 6.4 3.6 6.4 8z m-152.8-120c-4 0-7.2-3.6-7.2-8v-48c0-4.4 3.2-8 7.2-8h345.6c4 0 7.2 3.6 7.2 8v48c0 4.4-3.2 8-7.2 8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalFeedback extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M896 112.5h-768a32 32 0 0 0-32 32v591.2a32 32 0 0 0 32 32h243.3l103.4 127.4a48 48 0 0 0 74.6 0l103.4-127.4h243.3a32 32 0 0 0 32-32v-591.2a32 32 0 0 0-32-32z m-40 583.2h-237.6l-21.6 26.6-84.8 104.4-84.8-104.4-21.6-26.6h-237.6v-511.2h688z"></path>
      <path d="M272 440a48 48 0 0 0 96 0 48 48 0 0 0-96 0z"></path>
      <path d="M464 440a48 48 0 0 0 96 0 48 48 0 0 0-96 0z"></path>
      <path d="M656 440a48 48 0 0 0 96 0 48 48 0 0 0-96 0z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalTransformFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M953.1 731.6l-287.6-199.1a16 16 0 0 0-25.1 13.1l0 111h-330.1s-159.2 3.9-231.6-103c-5-7.4-16.5-2.4-14.5 6.3a403.9 403.9 0 0 0 152.9 232.1 226 226 0 0 0 132.5 40.8h290.7l0 111.2a16 16 0 0 0 25.1 13.2l287.7-199.3a16 16 0 0 0 0-26.3z"></path>
      <path d="M70.9 292.4l287.6 199.1a16 16 0 0 0 25.1-13.1l0-111h330.1s159.2-3.9 231.6 103c5 7.4 16.5 2.4 14.5-6.3a403.9 403.9 0 0 0-152.9-232 226 226 0 0 0-132.5-40.9h-290.7l0-111.1a16 16 0 0 0-25.1-13.2l-287.7 199.2a16 16 0 0 0 0 26.3z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandStandardFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M975.8 429.4l-318.5-319.1c-82.1-82.1-215.8-82.1-298 0l-289 289a8 8 0 0 0 5.7 13.7h263.2a16 16 0 0 0 11.3-4.7l109-109a75 75 0 0 1 106.1 0l84.6 84.6-72.7 72.8c-10.1 10.1-2.9 27.3 11.3 27.3h364.3c28.5 0 42.8-34.4 22.7-54.6z"></path>
      <path d="M948 556h-263.2a16 16 0 0 0-11.3 4.7l-109 109a75 75 0 0 1-106.1 0l-84.6-84.6 72.7-72.8c10.1-10.1 2.9-27.3-11.3-27.3h-364.3c-28.5 0-42.8 34.4-22.7 54.6l318.5 319.1c82.1 82.1 215.8 82.1 298 0l289-289a8 8 0 0 0-5.7-13.7z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandStandard extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M966.4 456.9l-313.7-313.6a204.7 204.7 0 0 0-145.9-60.3c-55.1 0.1-107.7 22.7-146.7 61.6l-281.8 281.8a8 8 0 0 0 5.7 13.6h75.9a16 16 0 0 0 11.3-4.7l241.1-241.1a134 134 0 0 1 189.5 0l245.4 245.3h-146.2l-111.6-111.6a116.5 116.5 0 0 0-164.6 0l-63 63a8 8 0 0 0 5.7 13.6h75.9a16 16 0 0 0 11.3-4.7l21-21a44.4 44.4 0 0 1 62.8 0l61.6 61.7-43.2 43.8c-10 10.1-2.8 27.2 11.4 27.2h375.5c28.5 0 42.8-34.5 22.6-54.6z"></path>
      <path d="M940 584h-75.9a16 16 0 0 0-11.3 4.7l-241.1 241.1a134 134 0 0 1-189.5 0l-245.4-245.3h146.2l111.6 111.6a116.5 116.5 0 0 0 164.6 0l63-63a8 8 0 0 0-5.6-13.7h-76a16 16 0 0 0-11.3 4.7l-21 21a44.4 44.4 0 0 1-62.7 0l-61.7-61.7 43.2-43.8c10-10.1 2.8-27.2-11.4-27.2h-375.5c-28.5 0-42.8 34.5-22.6 54.6l313.7 313.7a204.6 204.6 0 0 0 145.9 60.4c55.1-0.1 107.7-22.7 146.7-61.7l281.8-281.8a8 8 0 0 0-5.7-13.6z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MaterialBulb extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M639.9 613.8l-35.9 20.8v117.4h-184v-117.4l-35.9-20.8a255.8 255.8 0 0 1-128.1-221.8c0-141.4 114.6-256 256-256s256 114.6 256 256a255.8 255.8 0 0 1-128.1 221.8z m-127.9-549.8c-181.1 0-328 146.9-328 328 0 121.4 66 227.4 164 284.1v115.9a32 32 0 0 0 32 32h264a32 32 0 0 0 32-32v-115.9c98-56.7 164-162.7 164-284.1 0-181.1-146.9-328-328-328z m120 824h-240a8 8 0 0 0-8 8v32a32 32 0 0 0 32 32h192a32 32 0 0 0 32-32v-32a8 8 0 0 0-8-8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandRechargeDecline extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M920.5 392.1h-130.5v-296.1a32 32 0 0 0-32-32h-492a32 32 0 0 0-32 32v296.1h-130.5c-33.5 0-51.7 39-30.3 64.7l408.8 489.3a39.4 39.4 0 0 0 60.5 0l408.3-489.3c21.4-25.7 3.2-64.7-30.3-64.7z m-408.3 477.9l-339-405.9h132.8v-328.1h412v328.1h132.9z"></path>
      <path d="M661.2 294.4h-54.4a7.9 7.9 0 0 0-7.1 4.4l-84.6 168.6h-3.3l-84.7-168.6a8 8 0 0 0-7.1-4.4h-55.6a7.5 7.5 0 0 0-3.8 1 8 8 0 0 0-3.2 10.8l103.8 191.4h-56.9a8 8 0 0 0-8 8v27a8 8 0 0 0 8 8h75.9v39h-75.9a8 8 0 0 0-8 8v27.1a8 8 0 0 0 8 8h75.9v63.3a8 8 0 0 0 8 8h49.8a8 8 0 0 0 8-8v-63.4h76.2a8 8 0 0 0 8-8v-27.1a8 8 0 0 0-8-8h-76.2v-39h76.2a8 8 0 0 0 8-8v-27a8 8 0 0 0-8-8h-57.5l103.6-191.5a8.6 8.6 0 0 0 1-3.8 8.2 8.2 0 0 0-8.1-7.8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandCommodityMonitor extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M763.3 570.2h-132.2a14.4 14.4 0 0 0-12.4 7.2l-50.5 87.2-72.6-199.3a14.4 14.4 0 0 0-13.5-9.4h-56.3a14.4 14.4 0 0 0-12.5 7.1l-61.9 107.2h-97.9a7.2 7.2 0 0 0-7.1 7.2v49.5a7.2 7.2 0 0 0 7.1 7.1h127.4a14.4 14.4 0 0 0 12.4-7.1l56.7-98 72.6 199.3a14.4 14.4 0 0 0 13.5 9.4h53.8a14.4 14.4 0 0 0 12.3-6.9l58.4-96.7h102.7a7.2 7.2 0 0 0 7.2-7.2v-49.4a7.2 7.2 0 0 0-7.2-7.2z"></path>
      <path d="M956.1 924.7l-73-672a32 32 0 0 0-31.8-28.6h-142.9c-18.5-91.3-99.2-160-196-160h0c-96.8 0-177.5 68.7-196 160h-143.7a32 32 0 0 0-31.8 28.6l-73.1 672a32 32 0 0 0 31.9 35.4h824.6a32 32 0 0 0 31.8-35.4z m-534.1-749.2a126.3 126.3 0 0 1 210.4 48.6h-240a125.9 125.9 0 0 1 29.6-48.6z m-277.8 712.6l64.4-592h103.8v80a8 8 0 0 0 8 8h57.4a8 8 0 0 0 8-8v-80h253.2v80a8 8 0 0 0 8 8h57.4a8 8 0 0 0 8-8v-80h103l64.3 592z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandCrowdDistribution extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M512 552.9c86 0 156-70 156-156s-70-156-156-156-156 70-156 156 70 156 156 156z m0-240a84 84 0 1 1-84 84 84.1 84.1 0 0 1 84-84z"></path>
      <path d="M487.3 829.7a35 35 0 0 0 49.3 0l207.2-207c128.2-128 128.2-335.2 0-462.9a328.1 328.1 0 0 0-463.7 0c-128.1 127.8-128.1 335.2 0 462.9z m-231.3-438.4a253.9 253.9 0 0 1 75-180.5l0 0 0 0a255.8 255.8 0 0 1 361.9 0l0.1 0 0 0.1a254.6 254.6 0 0 1-0.1 361l-180.9 180.7-181-180.8 0 0 0 0a253.9 253.9 0 0 1-75-180.5z"></path>
      <path d="M912.3 728.1c-22.9-15.9-59-31.4-97.4-42.7a16 16 0 0 0-15.8 4c-13.6 13.6-43.4 43.4-43.6 43.5a8 8 0 0 0 3.9 13.4q14.4 3.3 27.9 7.1c33.6 9.4 61.1 20.5 79.5 32.1 17.6 11.1 20.4 18.4 20.6 19.4-0.3 0.9-3 8.2-20.6 19.3-18.4 11.6-45.9 22.7-79.5 32.1-74 20.7-171.7 32-275.3 32s-201.3-11.4-275.3-32c-33.6-9.4-61.1-20.5-79.5-32.1-17.6-11.1-20.4-18.4-20.6-19.3 0.3-0.9 3-8.2 20.6-19.4 18.4-11.6 45.9-22.7 79.5-32.1q13.6-3.8 28.3-7.1a8 8 0 0 0 3.8-13.5c-0.1-0.1-29.9-30-43.5-43.5a15.9 15.9 0 0 0-15.8-4c-39.6 11.6-73.7 26.2-97.8 42.8-22 15.1-48.2 40.8-48.2 76.8s26.2 61.7 48.2 76.8c24 16.5 57.2 31 98.8 43.1 81 23.6 188.1 36.6 301.5 36.6s220.5-13 301.5-36.6c41.6-12.1 74.8-26.6 98.8-43.1 22-15.1 48.2-40.8 48.2-76.8s-26.2-61.7-48.2-76.8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandCustomerService extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M662.6 645.1a32 32 0 0 0-44 10.6c-23.5 38.5-63.6 61.5-107.3 61.4s-83.8-23-107.3-61.4a32 32 0 1 0-54.6 33.4 194.8 194.8 0 0 0 67.8 66.6 186.7 186.7 0 0 0 188.2 0 194.9 194.9 0 0 0 67.8-66.6 32 32 0 0 0-10.6-44z"></path>
      <path d="M978.3 556.7c0-259.6-209.1-470-467-470s-467 210.4-467 470c0 1.1 0 2.2 0 3.3v0.1a148 148 0 0 0 142 147.9 364.2 364.2 0 0 0 14.5 33.7v125.4c0 18.5 14.5 33.5 32.3 33.5h121.5a337.2 337.2 0 0 0 156.7 38.5h1c148.8-0.4 274.4-96.4 324.2-231.1a148 148 0 0 0 141.8-147.8c0-0.1 0-0.2 0-0.4 0-1 0-2.1 0-3.1z m-746.1-281.6a394.4 394.4 0 0 1 643.1 126.5q4.2 10 7.8 20.2a147.7 147.7 0 0 0-52.8-9.7h-10.5c-56.3-111.3-167.1-188.2-296.1-192.7-4.2-0.1-8.4-0.2-12.5-0.3-133.8 0-250.3 77.9-308.5 193h-10.4a147.8 147.8 0 0 0-52.8 9.7q3.7-10.2 7.9-20.2a396.9 396.9 0 0 1 84.8-126.5z m-115.9 285h0v0a76.1 76.1 0 0 1 58.7-73.9 376.9 376.9 0 0 0-8 145.6 76.1 76.1 0 0 1-50.7-71.7z m658.5 130.2a295.3 295.3 0 0 1-63 98.8c-53.2 55.3-124.2 85.8-199.7 86h-0.8a271.6 271.6 0 0 1-127.1-31.2l-13.9-7.3h-105.5v-109.7l-6.6-13.3a301.8 301.8 0 0 1-22.9-64.4 309.7 309.7 0 0 1-8-70.7 306.3 306.3 0 0 1 22.8-116.2 294.7 294.7 0 0 1 61.4-93.8 282.1 282.1 0 0 1 90.1-62.6 273.2 273.2 0 0 1 109.6-22.8c3.4 0 6.8 0.1 10.2 0.2 71.7 2.6 139.2 33 190 85.6 51.4 53.1 81.1 124 83.7 199.4a306.8 306.8 0 0 1-20.3 122z m80.9-58.5a378.7 378.7 0 0 0 3.4-65.6 372.6 372.6 0 0 0-11.5-80 76.1 76.1 0 0 1 58.7 73.8v0.2h0a76.1 76.1 0 0 1-50.6 71.6z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandShopUser extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M957.7 444.6l-116.5-310.7a35.2 35.2 0 0 0-33-22.9h-592.5a35.2 35.2 0 0 0-33 22.9l-116.4 310.7a150.2 150.2 0 0 0 74.2 161.3v322.2a32 32 0 0 0 32 32h219.5a32 32 0 0 0 32-32v-98a88 88 0 0 1 88-88h0a88 88 0 0 1 88 88v98a32 32 0 0 0 32 32h220a32 32 0 0 0 32-32v-322.5a150.2 150.2 0 0 0 73.7-161z m-285.7 443.5v-58a160 160 0 1 0-320 0v58h-139.5v-264h0.2a187.8 187.8 0 0 0 147.5-71.3 188.1 188.1 0 0 0 299.3-5.6 188 188 0 0 0 151.8 77h0.7v264z m199.5-364.6c-8.4 10.4-27 28.1-57.9 28.7l-2.3 0a114.6 114.6 0 0 1-53.3-12.9 117.8 117.8 0 0 1-40.5-34.7 72 72 0 0 0-116.1 0 117.6 117.6 0 0 1-40.4 34.7 116.2 116.2 0 0 1-144.4-31.2 72 72 0 0 0-112.8 0 115.7 115.7 0 0 1-91.1 44.1l-2.4 0c-30.9-0.6-49.5-18.2-57.8-28.7a78 78 0 0 1-16.5-59.8l105.2-280.7h541.6l105.2 280.7a78 78 0 0 1-16.5 59.8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandAdvancedAnalysis extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M249 863.5h528.4a8 8 0 0 1 8 8v56a8 8 0 0 1-8 8h-528.4a8 8 0 0 1-8-8v-56a8 8 0 0 1 8-8z"></path>
      <path d="M908.5 63.9h-793.1a32.1 32.1 0 0 0-32 32.2v607.5a32.2 32.2 0 0 0 32 32.4h793.1a32.2 32.2 0 0 0 32-32.4v-607.5a32.2 32.2 0 0 0-32-32.2z m-40 600.2h-713.2v-528.3h713.2z"></path>
      <path d="M328.1 359.9h49.2a7.4 7.4 0 0 1 7.4 7.5v185.1a7.4 7.4 0 0 1-7.4 7.4h-49.2a7.4 7.4 0 0 1-7.4-7.4v-185.1a7.4 7.4 0 0 1 7.4-7.5z"></path>
      <path d="M488.2 239.9h49a7.5 7.5 0 0 1 7.5 7.6v304.9a7.5 7.5 0 0 1-7.5 7.5h-49a7.5 7.5 0 0 1-7.5-7.5v-304.9a7.5 7.5 0 0 1 7.5-7.6z"></path>
      <path d="M648.2 295.9h49a7.5 7.5 0 0 1 7.5 7.6v248.9a7.5 7.5 0 0 1-7.5 7.5h-49a7.5 7.5 0 0 1-7.5-7.5v-248.9a7.5 7.5 0 0 1 7.5-7.6z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalPromoteDiagnosis extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M856 112.1h-96v107.8a32 32 0 0 1-32 32h-432a32 32 0 0 1-32-32v-107.8h-96a32 32 0 0 0-32 32v784a32 32 0 0 0 32 32h688a32 32 0 0 0 32-32v-784a32 32 0 0 0-32-32z m-180 524a8 8 0 0 1-8 8h-118v134a8 8 0 0 1-8 8h-60a8 8 0 0 1-8-8v-134h-118a8 8 0 0 1-8-8v-60a8 8 0 0 1 8-8h118v-134a8 8 0 0 1 8-8h60a8 8 0 0 1 8 8v134h118a8 8 0 0 1 8 8z"></path>
      <path d="M336 64h352a16 16 0 0 1 16 16v100a16 16 0 0 1-16 16h-352a16 16 0 0 1-16-16v-100a16 16 0 0 1 16-16z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalQuestionFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M928 104h-832a32 32 0 0 0-32 32v640a32 32 0 0 0 32 32h250.8l142.6 142.6a32 32 0 0 0 45.2 0l142.7-142.6h250.7a32 32 0 0 0 32-32v-640a32 32 0 0 0-32-32z m-416 635a40 40 0 1 1 40-40 40 40 0 0 1-40 40z m62.9-228.5a48.3 48.3 0 0 0-30.9 44.8v22.7a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-21.5a113.7 113.7 0 0 1 19.9-64.9 111.8 111.8 0 0 1 52.1-40.9c34-13.1 56-41.6 56-72.7 0-44.1-43.1-80-96-80s-96 35.9-96 80v7.6a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-7.6c0-39.3 17.2-76 48.4-103.3 30-26.3 69.6-40.7 111.6-40.7s81.6 14.5 111.6 40.7c31.2 27.3 48.4 64 48.4 103.3 0 57.8-38.1 109.8-97.1 132.5z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalCrowd extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M693.9 603.4h0c-22.7-16-126.3-61.6-127.2-82.4-2.1-17.2 13.3-44.9 24.6-65 21.6-39.2 44.2-82.8 44.8-137.7 2-110.7-82.9-208.1-195-206.3-112-1.7-196.9 95.7-194.9 206.3 0.6 54.9 23.2 98.5 44.9 137.7 11.3 20.2 26.7 47.8 24.5 65-1.4 12.8-27.2 26.1-39.3 33.4-77.1 50.9-202 81.5-212.3 207v118.6a32 32 0 0 0 32 32h690.4a32 32 0 0 0 32-32v-118.7c0-84.6-84.1-134.1-124.5-157.9z m52.5 157.9v78.7h-610.4v-78.7c0.6-54.3 89-95.3 131-119.3 45-26.2 114.1-53 120.1-112.2 9-75-68.9-135.4-68.8-211.5-1.4-71.8 50.4-135.7 122.9-134.3 72.6-1.3 124.3 62.5 123 134.3 0.2 80.8-89.4 145.9-65.6 226.9 18.2 58.9 109.9 88.1 158.8 120.2 29.1 14.3 94.8 62.3 89 95.9z"></path>
      <path d="M899.2 575.5c-28.2-27.2-143.9-93.2-150.8-111.3-0.7-5.9 3.3-13.6 7.9-24.8 90.1-151.4 18.2-324.1-136.1-319a263.8 263.8 0 0 1 58.5 87.7c31.5 19.1 46.4 49 46.1 87 0 87.9-61.7 119.1-45 192 15.4 37.3 23 37.8 66 68.1 25.5 17.4 93.3 63.5 105.6 74.2 41 33 37.6 69 36.6 111.1l-0.4 72h40.4a32 32 0 0 0 32-32v-84.9c0-43.1-20.4-84.1-60.8-120.1z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class GraphicCircleChartFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M952 462.4l-2.6-28.2a399 399 0 0 0-360.4-359.6l-28.4-2.6a7.9 7.9 0 0 0-8.7 7.9v384.1a8 8 0 0 0 8 8l384-1a8 8 0 0 0 8.1-8.6z m-88 55.6h-358v-358a8 8 0 0 0-8-8h-26a400.1 400.1 0 1 0 400.1 400v-26a8.2 8.2 0 0 0-8.1-8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandEquityCenter extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M930.4 263.1l4.4-50.1a32 32 0 0 0-29.1-34.7l-757.1-66.2c-1-0.1-1.9-0.1-2.8-0.1a32 32 0 0 0-31.9 29.2l-10.6 121.8h-7.3a32 32 0 0 0-32 32v188.7a8.1 8.1 0 0 0 7.4 8.1 96 96 0 0 1 0 191.4 8.1 8.1 0 0 0-7.4 8.1v188.7a32 32 0 0 0 32 32h832a32 32 0 0 0 32-32v-188.7a8.1 8.1 0 0 0-7.4-8.1 96 96 0 0 1 0-191.4 8.1 8.1 0 0 0 7.4-8.1v-188.7a32 32 0 0 0-29.6-31.9z m-748.2-75.8l677.4 59.3-1.4 16.4h-682.6z m705.8 240.2v8.2a168.1 168.1 0 0 0 0 303.6v100.7h-752v-100.7a168.4 168.4 0 0 0 82.8-86.4 168.2 168.2 0 0 0 0-130.8 168.4 168.4 0 0 0-82.8-86.4v-100.7h752z"></path>
      <path d="M456.8 562.2h-61.4a8 8 0 0 0-8 8v29.9a8 8 0 0 0 8 8h81.7v41.4h-81.7a8 8 0 0 0-8 8v29.9a8 8 0 0 0 8 8h81.7v68.1a8 8 0 0 0 8 8h54.3a8 8 0 0 0 8-8v-68.1h82a8 8 0 0 0 8-8v-29.9a8 8 0 0 0-8-8h-82v-41.5h82a8 8 0 0 0 8-8v-29.9a8 8 0 0 0-8-8h-62l83.7-146.6a8 8 0 0 0-7-12h-57.7a8 8 0 0 0-7.1 4.2l-65.1 122.2h-3.4l-65.1-122.2a8 8 0 0 0-7-4.2h-58.8a8 8 0 0 0-7 12z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandLockCost extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M480 654v118.5a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-118.5a54 54 0 1 0-64 0z"></path>
      <path d="M832 400h-40v-32c0-154.6-125.4-280-280-280h0c-154.6 0-280 125.4-280 280v32h-40a32 32 0 0 0-32 32v472a32 32 0 0 0 32 32h640a32 32 0 0 0 32-32v-472a32 32 0 0 0-32-32z m-528-32a208 208 0 1 1 416 0v32h-416z m488 496h-560v-392h560z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MoneyPriceFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M880.1 64h-584.2a8 8 0 0 0-8 8v56a8 8 0 0 0 8 8h544.2v688a8 8 0 0 0 8 8h56a8 8 0 0 0 8-8v-728a32 32 0 0 0-32-32z"></path>
      <path d="M752.1 184h-608a32.1 32.1 0 0 0-32 32v712a32.1 32.1 0 0 0 32 32h608a32.1 32.1 0 0 0 32-32v-712a32.1 32.1 0 0 0-32-32z m-137.3 186.9l-111.1 204.7h62a8 8 0 0 1 8 8v29.9a8 8 0 0 1-8 8h-82v41.5h82a8 8 0 0 1 8 8v30a8 8 0 0 1-8 8h-82v68.1a8 8 0 0 1-8 8h-54.4a8 8 0 0 1-8-8v-68.1h-81.7a8 8 0 0 1-8-8v-29.9a8 8 0 0 1 8-8h81.7v-41.5h-81.7a8 8 0 0 1-8-8v-29.9a8 8 0 0 1 8-8h61.4l-111.5-204.9a8.1 8.1 0 0 1 3.2-10.9 8.6 8.6 0 0 1 3.8-1h60.7a7.9 7.9 0 0 1 7.1 4.4l90.6 180h3.4l90.7-180a8 8 0 0 1 7.1-4.4h59.5a8 8 0 0 1 8 8 6.6 6.6 0 0 1-0.8 3.9z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalClickFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M879.6 490.7l-292.4 100-100.4 285.5c-14.6 41.7-73.1 43-89.6 2.1l-281.6-696.6c-15.8-39.1 23-78.1 62.2-62.4l704.1 281.6c41.3 16.5 39.8 75.4-2.3 89.8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalDealFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M880.1 64h-584.2a8 8 0 0 0-8 8v56a8 8 0 0 0 8 8h544.2v688a8 8 0 0 0 8 8h56a8 8 0 0 0 8-8v-728a32 32 0 0 0-32-32z"></path>
      <path d="M752.1 184h-608a32.1 32.1 0 0 0-32 32v712a32.1 32.1 0 0 0 32 32h608a32.1 32.1 0 0 0 32-32v-712a32.1 32.1 0 0 0-32-32z m-125.2 303.6l-222.5 222.5a8 8 0 0 1-11.3 0l-123.8-123.8a8 8 0 0 1 0-11.3l42.4-42.5a8 8 0 0 1 11.3 0l70.1 70.1a8 8 0 0 0 11.3 0l168.8-168.7a8 8 0 0 1 11.3 0l42.4 42.4a8 8 0 0 1 0 11.3z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandActivityCenter extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M540.7 316.8c-11.7-23.8-45.7-23.8-57.4-0.1l-34.5 69.9-77.1 11.2c-26.3 3.8-36.7 36.1-17.7 54.6l55.8 54.4-13.2 76.8c-4.5 26.1 22.9 46.1 46.5 33.7l69-36.2 69 36.2c23.5 12.3 50.9-7.6 46.4-33.7l-13.2-76.8 55.8-54.4c19-18.5 8.5-50.8-17.7-54.6l-77.1-11.2z m13.4 170.4l9.9 57.9-52-27.3-52 27.3 9.9-57.9-42-41 58.1-8.4 26-52.7 26 52.7 58.1 8.5z"></path>
      <path d="M880.2 169.6h-273.1v-24.9c0-18.1-14.3-32.7-32-32.7h-454.9a8 8 0 0 0-8 8v784a8 8 0 0 0 8 8h56a8 8 0 0 0 8-8v-137.8h251v25.1c0 18.1 14.3 32.7 32 32.7h413c17.7 0 32-14.7 32-32.7v-588.9c0-18.1-14.3-32.7-32-32.8z m-40 580.7h-333v-57.8h-323v-506.8h350.9v57.6h305.1z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandDataDownload extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M880.5 88h-615.9a8 8 0 0 0-8 8v56a8 8 0 0 0 8 8h575.9v592a8 8 0 0 0 8 8h56a8 8 0 0 0 8-8v-632a32 32 0 0 0-32-32z"></path>
      <path d="M752.4 216h-607.9a32 32 0 0 0-32 32v656a32 32 0 0 0 32 32h607.9a32 32 0 0 0 32-32v-656a32 32 0 0 0-32-32z m-40 648h-527.9v-576h527.9z"></path>
      <path d="M425.8 758.6a32 32 0 0 0 45.3 0l163.6-163.7a8 8 0 0 0-5.6-13.7h-67.9a8 8 0 0 0-5.7 2.4l-75.1 75.1v-266.7a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v266.7l-75.1-75.1a8 8 0 0 0-5.7-2.4h-67.8a8 8 0 0 0-5.7 13.7z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandOperationNote extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M760.4 864h-575.9v-592a8 8 0 0 0-8-8h-56a8 8 0 0 0-8 8v632a32 32 0 0 0 32 32h615.9a8 8 0 0 0 8-8v-56a8 8 0 0 0-8-8z"></path>
      <path d="M880.5 88h-607.9a32 32 0 0 0-32 32v656a32 32 0 0 0 32 32h607.9a32 32 0 0 0 32-32v-656a32 32 0 0 0-32-32z m-40 648h-527.9v-576h527.9z"></path>
      <path d="M547.9 579.4a159.6 159.6 0 0 0 86.5-25.4l81.8 81.8a8 8 0 0 0 11.3 0l36.7-36.8a8 8 0 0 0 0-11.3l-81.7-81.8a160 160 0 1 0-134.6 73.5z m-67.9-227.9a96 96 0 1 1 0 135.7 95.3 95.3 0 0 1 0-135.7z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandPrinter extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M336 590.7h352a8 8 0 0 1 8 8v48a8 8 0 0 1-8 8h-352a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8z"></path>
      <path d="M336 718.8h256a8 8 0 0 1 8 8v48a8 8 0 0 1-8 8h-256a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8z"></path>
      <path d="M928 209.6h-96v-113.6a32 32 0 0 0-32-32h-576a32 32 0 0 0-32 32v113.6h-96a32 32 0 0 0-32 32v400.1a32 32 0 0 0 32 32h96v254.3a32 32 0 0 0 32 32h576a32 32 0 0 0 32-32v-254.3h96a32 32 0 0 0 32-32v-400.1a32 32 0 0 0-32-32z m-664-73.6h496v73.6h-496z m496 752h-496v-368.1h496z m128-286.3h-56v-121.8a32 32 0 0 0-32-32h-576a32 32 0 0 0-32 32v121.8h-56v-320.1h752z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandWeeklyReports extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M880 184.1h-168v-64a8 8 0 0 0-8-8h-56a8 8 0 0 0-8 8v64h-256v-64a8 8 0 0 0-8-8h-56a8 8 0 0 0-8 8v64h-168a32 32 0 0 0-32 32v663.9a32 32 0 0 0 32 32h736a32 32 0 0 0 32-32v-664a32 32 0 0 0-32-31.9z m-40 655.9h-656v-584h128v48a8 8 0 0 0 8 8h56a8 8 0 0 0 8-8v-48h256v48a8 8 0 0 0 8 8h56a8 8 0 0 0 8-8v-48h128z"></path>
      <path d="M748.9 462l-117.2 117.3-109.1 109.2a8 8 0 0 1-11.3 0l-86.1-86.2-101.8 101.8a8 8 0 0 1-11.3 0l-36.8-36.8a8 8 0 0 1 0-11.3l144.3-144.3a8 8 0 0 1 11.3 0l86.1 86.2 183.8-184a8 8 0 0 1 11.3 0l36.8 36.8a8 8 0 0 1 0 11.3z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandDataManagement extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M833.1 422.5c-43-129.7-165.3-223.3-309.5-223.4-160.9 0-294.5 116.5-321.1 269.8-92.3 17.8-162 98.9-162 196.4h0c0 110.5 89.5 200 200 200h516c125.9 0 228-102.1 228-228h0c0-99-63.1-183.3-151.4-214.8z m33.7 325.1a155 155 0 0 1-110.3 45.7h-516a128 128 0 0 1-24.4-253.7l48.8-9.4 8.5-49a254.1 254.1 0 0 1 491.4-36.1l11 33.4 33.1 11.8a156 156 0 0 1 57.9 257.3z"></path>
      <path d="M746 519.3l-137.3-36.8a8 8 0 0 0-9.8 5.6l-12.4 46.4a8 8 0 0 0 5.6 9.8l25.4 6.8-114.3 66-52.1-90.1a8 8 0 0 0-11-3l-177 102.2a8 8 0 0 0-2.9 11l24 41.5a8 8 0 0 0 10.9 2.9l128.6-74.2 52 90.2a8 8 0 0 0 10.9 2.9l263.3-152a16 16 0 0 0-3.9-29.2z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandSalesReturn extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M928 112h-832a32 32 0 0 0-32 32v180a32 32 0 0 0 32 32h16.1v524a32 32 0 0 0 32 32h736a32 32 0 0 0 32-32v-524h15.9a32 32 0 0 0 32-32v-180a32 32 0 0 0-32-32z m-792 72h752v100h-752z m704.1 656h-656v-484h656z"></path>
      <path d="M320.6 547l152 125.5a8 8 0 0 0 13.1-6.2v-62.3a8 8 0 0 0-2.9-6.2l-37.8-31.2h137.8a68.1 68.1 0 0 1 68 69.1c-0.6 37.3-31.7 66.9-69 66.9h-181a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h180.5c72.8 0 133-58.4 133.5-131.2 0.4-73.1-59-132.8-132-132.8h-137.9l37.8-31.2a8 8 0 0 0 2.9-6.2v-62.2a8 8 0 0 0-13.1-6.2l-152 125.5a16 16 0 0 0 0.1 24.7z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalQrcode extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M888 832h-48a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8z m-142 0h-48a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8z m142-284h-48a8 8 0 0 0-8 8v134h-78v-134a8 8 0 0 0-8-8h-190a8 8 0 0 0-8 8v332a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-244h78v102a8 8 0 0 0 8 8h190a8 8 0 0 0 8-8v-190a8 8 0 0 0-8-8z m-194-210h56a8 8 0 0 0 8-8v-56a8 8 0 0 0-8-8h-56a8 8 0 0 0-8 8v56a8 8 0 0 0 8 8z m138 74h-220v-220h220z m32-284h-308a8 8 0 0 0-8 8v332a8 8 0 0 0 8 8h332a8 8 0 0 0 8-8v-308a32 32 0 0 0-32-32z m-590 630h56a8 8 0 0 0 8-8v-56a8 8 0 0 0-8-8h-56a8 8 0 0 0-8 8v56a8 8 0 0 0 8 8z m138 74h-220v-220h220z m56-284h-332a8 8 0 0 0-8 8v308a32 32 0 0 0 32 32h308a8 8 0 0 0 8-8v-332a8 8 0 0 0-8-8z m-194-210h56a8 8 0 0 0 8-8v-56a8 8 0 0 0-8-8h-56a8 8 0 0 0-8 8v56a8 8 0 0 0 8 8z m138 74h-220v-220h220z m56-284h-308a32 32 0 0 0-32 32v308a8 8 0 0 0 8 8h332a8 8 0 0 0 8-8v-332a8 8 0 0 0-8-8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateReturn extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M409.5 671h69.4a16 16 0 0 0 12.2-5.7l81.6-97.3 81.5 97.3a16 16 0 0 0 12.3 5.7h69.3a8 8 0 0 0 6.2-13.1l-122.4-145.9 122.4-145.9a8 8 0 0 0-6.2-13.1h-69.3a16 16 0 0 0-12.3 5.7l-81.5 97.3-81.6-97.3a16 16 0 0 0-12.3-5.7h-69.3a8 8 0 0 0-6.1 13.1l122.3 145.9-122.3 145.9a8 8 0 0 0 6.1 13.1z"></path>
      <path d="M928.1 160h-578.2a32 32 0 0 0-25.1 12.2l-252 320.6a32 32 0 0 0 0 39.6l252 319.4a32 32 0 0 0 25.1 12.2h578.2a32 32 0 0 0 32-32v-640a32 32 0 0 0-32-32z m-40 632h-518.8l-220.5-279.5 220.6-280.5h518.7z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalRanking extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M192 112a32 32 0 0 0-32 32v711.9c0 32.4 26.6 56.1 56 56.1a55.7 55.7 0 0 0 24.8-5.9l271.2-134.1 271.2 134.1a55.7 55.7 0 0 0 24.8 5.9c29.4 0 56-23.6 56-56.1v-711.9a32 32 0 0 0-32-32z m40 718.2v-646.2h560v369.1z m560 0l-198.8-98.4 198.8-98.3z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class FileImageFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M602 326v-188.2l188.2 188.2z m94 370h-368a8 8 0 0 1-6.3-12.9l99.8-127.2a8 8 0 0 1 12.6 0l41.1 52.4 77.8-99.2a8 8 0 0 1 12.6 0l136.5 174a7.9 7.9 0 0 1-6.1 12.9z m-296-294a40 40 0 1 1-40 40 40 40 0 0 1 40-40z m454.6-113.3l-215.2-215.3a32.2 32.2 0 0 0-22.7-9.4h-424.7a32 32 0 0 0-32 32v832a32 32 0 0 0 32 32h640a32 32 0 0 0 32-32v-616.7a31.9 31.9 0 0 0-9.4-22.6z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateDrag extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M286.6 218.6a58.7 58.7 0 0 0 117.4 0 58.7 58.7 0 0 0-117.4 0z"></path>
      <path d="M286.6 512a58.7 58.7 0 0 0 117.4 0 58.7 58.7 0 0 0-117.4 0z"></path>
      <path d="M286.6 805.3a58.7 58.7 0 0 0 117.4 0 58.7 58.7 0 0 0-117.4 0z"></path>
      <path d="M622.2 220a58.8 58.8 0 0 0 117.6 0 58.8 58.8 0 0 0-117.6 0z"></path>
      <path d="M622.4 512a58.7 58.7 0 0 0 117.4 0 58.7 58.7 0 0 0-117.4 0z"></path>
      <path d="M622.4 805.3a58.7 58.7 0 0 0 117.4 0 58.7 58.7 0 0 0-117.4 0z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateUp extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M859.9 770h-695.8a8 8 0 0 0-8.1 8v60a8 8 0 0 0 8.1 8h695.8a8 8 0 0 0 8.1-8v-60a8 8 0 0 0-8.1-8z"></path>
      <path d="M338.5 427.8a8 8 0 0 0 11.3 0l125.1-125.1v391.4a8 8 0 0 0 8 8h56a8 8 0 0 0 8-8v-391.7l125.3 125.4a8 8 0 0 0 11.3 0l39.6-39.6a8 8 0 0 0 0-11.4l-189.5-189.4a32 32 0 0 0-45.2 0l-189.5 189.5a8 8 0 0 0 0 11.3z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateDownward extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M859.9 178h-695.8a8 8 0 0 0-8.1 8v60a8 8 0 0 0 8.1 8h695.8a8 8 0 0 0 8.1-8v-60a8 8 0 0 0-8.1-8z"></path>
      <path d="M685.5 596.2a8 8 0 0 0-11.3 0l-125.1 125.1v-391.4a8 8 0 0 0-8-8h-56a8 8 0 0 0-8 8v391.7l-125.3-125.4a8 8 0 0 0-11.3 0l-39.6 39.6a8 8 0 0 0 0 11.3l189.5 189.5a32 32 0 0 0 45.2 0l189.5-189.5a8 8 0 0 0 0-11.3z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateCopy extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M713.3 570c0 97-1 194 0.5 290.9 0.6 36.2-13.4 49.5-48.9 49-88.2-1.3-176.4 0.8-264.5-1.4-17.8-0.5-38.9-9.9-52.2-22.1-44.5-40.8-87.2-83.8-128.2-128.2-11.4-12.4-20.2-32.5-20.4-49.1-1.6-146.1-0.3-292.2-1.3-438.3-0.3-34.1 12-47.3 46.3-47q211.6 1.6 423.2 0c34.9-0.3 46.3 14.4 45.9 47.8-1.2 99.4-0.4 199-0.4 298.4z m-357.6 112.4c63.2 0.2 69.9 6.7 70 68.4 0 30.9 0 61.8 0 93.8h220.5v-554.2h-381.8v392z m9.3 124v-64.2h-63.4z"></path>
      <path d="M775.4 109.6c46.9 0.1 51.8 5.2 51.8 52.2 0.1 210.5 0.1 420.5 0 631.3h-61.6v-618.7h-450.4v-64.8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalSave extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M893 293.3q-81-81.2-162.3-162.2c-13-12.9-28.8-19.2-48.3-19.1-175.1 0.5-350.2 0.3-525.2 0.3-33.7 0-44.4 10.6-44.4 44q0 177.1 0 354.3v249.5c0 38-0.2 76 0.1 114 0.2 25.4 12.5 37.4 38.1 37.9 8.2 0.2 16.4 0 24.6 0q347.3 0 694.7 0c30.6 0 42.2-11.4 42.2-41.6q0.1-261.1 0.1-522.1c0-20.8-4.3-39.8-19.6-55z m-507.7-107.2h254v100.7h-254z m454.7 644.6c0 2-0.4 4.1-0.7 7.4h-653v-652.6h134.8v17.2c0 38.5-0.2 77 0.1 115.5 0.2 21.5 12.2 33.7 33.5 33.8q157.9 0.3 315.7 0c21.3 0 33.4-12.3 33.6-33.6 0.4-35.8 0.1-71.7 0.1-110.2 4.8 3.8 8.1 5.9 10.7 8.5 39.3 39.1 78.6 78.2 117.5 117.8 4.1 4.2 7.4 11.4 7.4 17.2q0.6 239.5 0.3 479z"></path>
      <path d="M511.6 442.1c-78.8 0.9-142.8 65.3-143 143.8-0.1 78.9 65.4 144.3 144.3 144.1 79.1-0.2 144.3-65.9 143.7-144.6-0.6-79.2-66.4-144.3-145-143.3z m0.2 223.9c-43.2-0.4-79.1-36.8-79.1-80 0-43.8 36.9-80.3 80.8-79.9 43.2 0.4 79.2 36.8 79.1 80 0 43.8-37 80.3-80.8 79.9z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalUnlock extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M823.6 463.3c31.6 0 41.9 10.5 42 42.3q0 183.4 0 366.9c0 29-11.4 40.4-40.4 40.5h-629.9c-28.2 0-39.8-11.7-39.8-39.9q0-185.2 0-370.5c0-27.6 11.6-39.3 39-39.3 19.9 0 39.8 0 61.7 0q0-108.8 0-217.5c0.1-81.4 55-136.1 136.7-136.1q118.3-0.1 236.6 0c80 0.1 135.2 55.2 135.4 135 0 18.3-0.4 36.7 0.1 55 0.4 11.7-4.7 15.6-15.7 15.2-13.9-0.5-27.9-0.6-41.8 0-11.2 0.5-16-3.7-15.7-15.2 0.5-19.1 0.3-38.2 0.1-57.4-0.3-36.9-23.8-60.4-60.7-60.5q-121.3-0.2-242.6 0c-34.6 0.1-59.1 23.2-59.3 56.9-0.5 74.9-0.1 149.7-0.1 224.6z m-31 72.9h-563.7v303.7h563.7z"></path>
      <path d="M482.5 728.8c0-5.6 0.9-11.3-0.3-16.7-1.4-6.1-3.3-12.9-7.2-17.3-17.2-19.6-16.9-48.7 1.5-67a48.6 48.6 0 0 1 67.8-0.1c18.6 18.1 19.7 47.9 1.5 66.5-5.7 5.8-7.6 11.3-7.3 18.8 0.4 12.3-0.1 24.7 0.1 37 0.2 8.4-3 12.6-11.8 12.4-11.1-0.3-22.3-0.2-33.4 0-7.5 0.1-11-3.4-10.9-10.9s0-15.1 0-22.7z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalLock extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M766.4 240.7c-0.7-71.8-54.6-126.9-126.4-127.9q-126.3-1.7-252.7 0c-71.8 0.9-125.8 56.1-126.5 127.9l-0.3 223.4h-64.5a36 36 0 0 0-36 36v375.5c0 28.1 11.3 39.3 39.9 39.3q313.8 0.2 627.5 0c28.5 0 39.8-11.2 39.9-39.3q0.3-185.3 0-370.6c0-27.9-11.5-38.8-40.2-39.2-19.5-0.3-39-0.1-60.5-0.1z m-374.3-55.9q122.2-0.6 244.3 0c32.4 0.2 56.8 21.1 57.4 52.4 1.4 75 0.4 150.1 0.5 226.9h-361.6l0.1-219.7c0.8-36.6 23.1-59.4 59.3-59.6z m402 656.3h-560.6v-301.5h560.6z"></path>
      <path d="M484.9 738.1c-1.7 20.6 4.5 31.3 24 26.9 33.2 0.1 33.5 0.1 33.1-29.5-0.3-17.6 1-33.1 12.9-48.6 13.8-18 6.5-46-11.4-60.1a48.2 48.2 0 0 0-60.1 0.3c-17.7 14.3-24.9 42.5-10.8 60.3 12.9 16.2 13.7 32.9 12.3 50.7z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalGuide extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M512 64.2c-247.4 0-448 200.6-448 448s200.6 448 448 448 448-200.6 448-448-200.6-448-448-448z m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path>
      <path d="M684.7 304l-431.3 157c-27.4 10-28.3 48.4-1.4 59.6l182.1 76 75 181c11.2 27 49.6 26.1 59.6-1.3l157-431.3c9.3-25.5-15.5-50.3-41-41z m-148 373.1l-53.6-129.3-130.8-54.7 289.8-105.5z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandSmartHosting extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M852.4 394.4l-26 36.1a9.1 9.1 0 0 0 2 12.8 8.6 8.6 0 0 0 2.3 1.1 186 186 0 0 1 70.1 306.6c-33.7 33.9-79.4 52.9-127.2 54.7-3.2 0.1-6 0.1-10.6 0h-502.1c-2.4 0.1-4.2 0.1-5.9 0.2-0.9 0-3.2 0-5.2-0.2h-1a186 186 0 0 1-18.7-370.2l44.1-5.8c0.1 0 0.2-0.1 0.3-0.2l12.3-42.7a231.3 231.3 0 0 1 32.1-67.3 233.8 233.8 0 0 1 334.2-53.5c5.2 4 10.4 8.2 15.3 12.6a9.1 9.1 0 0 0 12.9-0.8c0.2-0.2 0.5-0.6 0.6-0.8l24.6-34.1a18.3 18.3 0 0 0-3.2-24.8 303.2 303.2 0 0 0-191.9-68.3c-137.6 0-253.6 92-290.3 217.7 0 0.1-0.1 0.2-0.3 0.2-124.4 16.8-220.2 123.2-220.2 252.2 0 137.7 109.4 249.9 246.1 254.3h0s5.7 0.1 8.3 0.1 5.4 0 8.1-0.1h497.8c2.6 0.1 5.4 0.1 8.1 0.1 140.6 0 254.4-113.9 254.4-254.4a254.3 254.3 0 0 0-148.5-231.4 18.3 18.3 0 0 0-22.5 5.9z"></path>
      <path d="M732.9 398.5h-53.5a36.2 36.2 0 0 0-29.5 15.2l-179.4 248.7-81.2-112.7a36.5 36.5 0 0 0-29.6-15.2h-53.5a9.1 9.1 0 0 0-9.1 9.2 8.8 8.8 0 0 0 1.7 5.3l142.2 197.2a36.3 36.3 0 0 0 59 0l240.2-333.2a9.1 9.1 0 0 0-2-12.8 9.6 9.6 0 0 0-5.3-1.7z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandOdinFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M696.8 414.6l-80.3-57.4a16.1 16.1 0 0 0-18.5-0.1l-86.5 60.3-86.5-60.3a15.9 15.9 0 0 0-18.4 0.1l-80.4 57.4a16.1 16.1 0 0 0-6.7 13v122.4a15.9 15.9 0 0 0 6.8 13.1l176.1 123.8a15.9 15.9 0 0 0 18.4 0l176-123.8a15.6 15.6 0 0 0 6.7-13.1v-122.4a15.9 15.9 0 0 0-6.7-13z"></path>
      <path d="M271.5 655.5a16 16 0 0 0 6-21.2 264.1 264.1 0 0 1 406.9-321.9 16 16 0 0 0 18.7 1.7l127.9-76.2a16 16 0 0 0 3.6-24.6c-80.4-86.9-195.4-141.3-323.1-141.3-243 0-440 197-440 440a438 438 0 0 0 29.1 157.5l-36 75.2c-6.8 14.3 9 28.8 22.7 20.6l46.4-27.7v0.1z"></path>
      <path d="M936.1 259.1l-184.3 109.8a16 16 0 0 0-6 21.1 264.1 264.1 0 0 1-406.6 322 16.1 16.1 0 0 0-18.7-1.7l-128.1 76.2a16 16 0 0 0-3.6 24.6c80.4 86.7 195.2 140.9 322.7 140.9 243 0 440-197 440-440a439.8 439.8 0 0 0-28.8-157l36-75.3c6.8-14.3-9-28.8-22.6-20.6z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateSortFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M752 488a8 8 0 0 0-8-8h-80a8 8 0 0 0-8 8v256a8 8 0 0 0 8 8h80a8 8 0 0 0 8-8z m-192 72a8 8 0 0 0-8-8h-80a8 8 0 0 0-8 8v184a8 8 0 0 0 8 8h80a8 8 0 0 0 8-8z m-192-280a8 8 0 0 0-8-8h-80a8 8 0 0 0-8 8v464a8 8 0 0 0 8 8h80a8 8 0 0 0 8-8z m512 632h-736a32 32 0 0 1-32-32v-736a32 32 0 0 1 32-32h736a32 32 0 0 1 32 32v736a32 32 0 0 1-32 32z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalButtonFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M946.5 716.6l-304.5-138.2c-21.6-9.8-43.7 12.4-33.9 34l133.7 292.6c11.1 24.2 48.7 16 48.7-11.1v-128.6h144.9c28 0 34.9-37.1 11.1-48.7z"></path>
      <path d="M542.6 642.2a97.1 97.1 0 0 1 6.6-93.1 98.8 98.8 0 0 1 34-32.3 97 97 0 0 1 88.5-4l262.1 119a286.9 286.9 0 0 0 26-119.8h0c0-159.1-128.9-288-288-288h-320c-159.1 0-288 128.9-288 288h0c0 159.1 128.9 288 288 288h262.8c-18.2-39.8-41.6-91.2-72-157.8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MoneyRiseFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M950.8 567.4l-408.8-489.3a39.4 39.4 0 0 0-60.5 0.1l-408.3 489.2c-21.4 25.7-3.2 64.7 30.3 64.7h160.5v296.1a32 32 0 0 0 32 32h432a32 32 0 0 0 32-32v-296.1h160.5c33.5 0 51.7-39.1 30.3-64.7z m-302.5-140.6h0l-87.7 161.1h45.7a10 10 0 0 1 10 10v21.3a10 10 0 0 1-10 10h-63.4v29.7h63.4a10 10 0 0 1 10 10v21.3a10 10 0 0 1-10 10h-63.4v51.8a10 10 0 0 1-10 10h-41.3a10 10 0 0 1-10-10v-51.8h-63.1a10 10 0 0 1-10-10v-21.3a10 10 0 0 1 10-10h63.1v-29.7h-63.1a10 10 0 0 1-10-10v-21.3a10 10 0 0 1 10-10h45.2l-88-161.1a10 10 0 0 1 8.8-14.8h46a9.9 9.9 0 0 1 8.9 5.5l72.9 144.3 73.2-144.3a10 10 0 0 1 8.9-5.5h45a10 10 0 0 1 10 10 8.9 8.9 0 0 1-1.1 4.8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MaterialPhoneFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M512 824a40 40 0 1 1 40-40 40 40 0 0 1-40 40z m288-760h-576a64 64 0 0 0-64 64v768a64 64 0 0 0 64 64h576a64 64 0 0 0 64-64v-768a64 64 0 0 0-64-64z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MaterialComputerFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M896 112h-768a64 64 0 0 0-64 64v528a64 64 0 0 0 64 64h260v64h-128a32 32 0 0 0-32 32v40a8 8 0 0 0 8 8h552a8 8 0 0 0 8-8v-40a32 32 0 0 0-32-32h-128v-64h260a64 64 0 0 0 64-64v-528a64 64 0 0 0-64-64z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalInvestEstimate extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M248.8 864h529a8 8 0 0 1 8 8v56a8 8 0 0 1-8 8h-529a8 8 0 0 1-8-8v-56a8 8 0 0 1 8-8z"></path>
      <path d="M869 135.1v528.9h-714v-528.9h714m40-72h-794a32.2 32.2 0 0 0-32 32.3v608.2a32.2 32.2 0 0 0 32 32.4h794a32.2 32.2 0 0 0 32-32.4v-608.2a32.2 32.2 0 0 0-32-32.3z"></path>
      <path d="M739.6 270.5l41.9 43a8 8 0 0 1-0.2 11.3l-205.1 199.6a8 8 0 0 1-10.9 0.2l-147-130.1-118.5 124a8 8 0 0 1-11.3 0.2l-43.4-41.4a8 8 0 0 1-0.3-11.3l163.7-171.4a8 8 0 0 1 11.1-0.4l148.8 131.7 159.9-155.6a8 8 0 0 1 11.3 0.2z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalSearchDataAnalysis extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M919.4 866.9l-150.5-150.5a374.5 374.5 0 0 0 85.6-238.9c0-207.7-168.3-376-376-376s-376 168.3-376 376 168.3 376 376 376a374.4 374.4 0 0 0 236.7-83.8l150.7 150.7a7.3 7.3 0 0 0 10.3 0l43.2-43.2a7.3 7.3 0 0 0 0-10.3z m-440.9-85.4c-167.9 0-304-136.1-304-304s136.1-304 304-304a303.5 303.5 0 0 1 244.1 122.8l-166.7 165.9-90-93.7a16 16 0 0 0-22.8-0.2l-172.2 171.1a16 16 0 0 0 0 22.6l31.1 31.2a16 16 0 0 0 22.6 0l128.9-127.9 90 93.7a16 16 0 0 0 22.8 0.2l194.8-194a303.1 303.1 0 0 1 21.4 112.3c0 167.9-136.1 304-304 304z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandSingleShopFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M917.2 415.3l-105.9-282.5a32 32 0 0 0-30-20.8h-538.7a32 32 0 0 0-30 20.8l-105.8 282.4c-16.9 82.8 45.1 161.6 129.7 163.3 1.1 0 2.3 0 3.4 0a170.8 170.8 0 0 0 134.1-64.9 171 171 0 0 0 272.1-5.1 170.8 170.8 0 0 0 138 70c1.1 0 2.3 0 3.4 0 84.6-1.7 146.6-80.5 129.7-163.2z"></path>
      <path d="M784.1 650.5a241.7 241.7 0 0 1-138-43 240.6 240.6 0 0 1-26.3 15.9 243.7 243.7 0 0 1-111.7 27.1 241.4 241.4 0 0 1-134.1-40.4 241.6 241.6 0 0 1-134.1 40.4c-1.6 0-3.2 0-4.8 0a206.1 206.1 0 0 1-62.3-10.9v240.4a32 32 0 0 0 32 32h616a32 32 0 0 0 32-32v-241a206.2 206.2 0 0 1-63.9 11.4c-1.6 0.1-3.2 0.1-4.8 0.1z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandUniteFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M693.3 408.7v-160.9a32 32 0 0 0-16.7-28l-149.2-81.9a32 32 0 0 0-30.8 0l-149.2 81.9a32 32 0 0 0-16.6 28v160.9a32 32 0 0 0 16.6 28.1l149.2 81.8a32 32 0 0 0 30.8 0l149.2-81.8a32 32 0 0 0 16.7-28.1z"></path>
      <path d="M458.1 587.3l-149.3-81.9a32 32 0 0 0-30.8 0l-149.2 81.9a32 32 0 0 0-16.6 28v160.9a32 32 0 0 0 16.6 28l149.2 81.9a32 32 0 0 0 30.8 0l149.2-81.9a32 32 0 0 0 16.6-28v-160.9a32 32 0 0 0-16.5-28z"></path>
      <path d="M895.6 587.3l-149.3-81.9a32 32 0 0 0-30.8 0l-149.2 81.9a32 32 0 0 0-16.6 28v160.9a32 32 0 0 0 16.6 28l149.2 81.9a32 32 0 0 0 30.8 0l149.3-81.9a32 32 0 0 0 16.6-28v-160.9a32 32 0 0 0-16.6-28z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateIndent extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M142.4 642.1l156.3-123.1a8.8 8.8 0 0 0 0-13.9l-156.3-123.2a8.9 8.9 0 0 0-14.4 6.9v246.3a8.9 8.9 0 0 0 14.4 7z m761.6 149.9h-784a8 8 0 0 0-8 8v56a8 8 0 0 0 8 8h784a8 8 0 0 0 8-8v-56a8 8 0 0 0-8-8z m0-632h-784a8 8 0 0 0-8 8v56a8 8 0 0 0 8 8h784a8 8 0 0 0 8-8v-56a8 8 0 0 0-8-8z m-504 486a8 8 0 0 0 8 8h480a8 8 0 0 0 8-8v-56a8 8 0 0 0-8-8h-480a8 8 0 0 0-8 8z m8-204h480a8 8 0 0 0 8-8v-56a8 8 0 0 0-8-8h-480a8 8 0 0 0-8 8v56a8 8 0 0 0 8 8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateOutdent extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M115.4 518.9l156.3 123.1a8.9 8.9 0 0 0 14.4-6.9v-246.2a8.9 8.9 0 0 0-14.4-6.9l-156.3 123a8.7 8.7 0 0 0 0 13.8z m788.6 273.1h-784a8 8 0 0 0-8 8v56a8 8 0 0 0 8 8h784a8 8 0 0 0 8-8v-56a8 8 0 0 0-8-8z m0-632h-784a8 8 0 0 0-8 8v56a8 8 0 0 0 8 8h784a8 8 0 0 0 8-8v-56a8 8 0 0 0-8-8z m-504 486a8 8 0 0 0 8 8h480a8 8 0 0 0 8-8v-56a8 8 0 0 0-8-8h-480a8 8 0 0 0-8 8z m8-204h480a8 8 0 0 0 8-8v-56a8 8 0 0 0-8-8h-480a8 8 0 0 0-8 8v56a8 8 0 0 0 8 8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class DirectionBack extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M629.8 362.1h-370l170-156.2a8 8 0 0 0 2.6-5.9v-90.1a8 8 0 0 0-13.3-5.9l-296.8 272.7a31.8 31.8 0 0 0 0 46.9l296.8 272.7a8 8 0 0 0 13.4-5.9v-90.1a8 8 0 0 0-2.6-5.9l-170-156.3h370.4c54 0 106.3 20.7 144.8 58.7a204 204 0 0 1-143.1 349.3h-272a8 8 0 0 0-8 8v60a8 8 0 0 0 8 8h272c154.3 0 279.4-124.8 280-279 0.6-154.5-127.6-281-282.2-281z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MaterialPushpinFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M878.3 392.1l-246.4-246.4a33.3 33.3 0 0 0-47 0l-161.1 161.2a322.9 322.9 0 0 0-36.8-2 329.6 329.6 0 0 0-206.5 72.3 33.3 33.3 0 0 0-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 0 0-4.6 9.8l-3.4 37.2a16 16 0 0 0 15.9 17.4 7.6 7.6 0 0 0 1.5-0.1l37.2-3.4a15.8 15.8 0 0 0 9.8-4.6l215.4-215.4 181.7 181.7a33.3 33.3 0 0 0 49.4-2.7 330.3 330.3 0 0 0 70.2-243.4l161.1-161.1a33.1 33.1 0 0 0 0-46.8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MaterialPushpin extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M666.2 549.3l-24.5 24.5 3.8 34.4a259.8 259.8 0 0 1-30.4 153.9l-353.1-353.3a254.8 254.8 0 0 1 40.3-17.9 258.6 258.6 0 0 1 84.7-14.1 254.5 254.5 0 0 1 28.9 1.6l34.4 3.8 24.5-24.5 133.7-133.7 191.5 191.5z m212.1-157.2l-246.4-246.4a33.3 33.3 0 0 0-47 0l-161.1 161.2a322.9 322.9 0 0 0-36.8-2 329.6 329.6 0 0 0-206.5 72.3 33.2 33.2 0 0 0-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 0 0-4.6 9.8l-3.4 37.2a16 16 0 0 0 15.9 17.4 7.6 7.6 0 0 0 1.5-0.1l37.2-3.4a15.8 15.8 0 0 0 9.8-4.6l215.4-215.4 181.7 181.7a33.3 33.3 0 0 0 49.4-2.7 330.3 330.3 0 0 0 70.2-243.4l161.1-161.1a33.1 33.1 0 0 0 0-46.8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class PromptError extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M925.5 759.9l-337.3-583.8a88 88 0 0 0-152.4 0l-337.3 583.8c-33.9 58.7 8.4 132 76.2 132h674.6c67.8 0 110.1-73.3 76.2-132z m-62.3 52a15.3 15.3 0 0 1-13.9 8h-674.6a16 16 0 0 1-13.9-24l337.4-583.8a16 16 0 0 1 27.7 0l337.3 583.8a15.3 15.3 0 0 1 0 16z"></path>
      <path d="M488 342.9h48a8 8 0 0 1 8 8.1v248a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-248a8 8 0 0 1 8-8z"></path>
      <path d="M460.8 719a48 48 0 0 0 96 0 48 48 0 0 0-96 0z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class PromptErrorFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M435.8 176.1l-337.3 583.8c-33.9 58.7 8.4 132 76.2 132h674.6c67.8 0 110.1-73.3 76.2-132l-337.3-583.8c-33.9-58.6-118.5-58.6-152.4 0z m44.2 174.9a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v248a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8z m28.8 416a48 48 0 1 1 48-48 48 48 0 0 1-48 48z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalBrandList extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M750 92.5h-476a32 32 0 0 0-26.7 14.4l-190 289a32 32 0 0 0 2.6 38.7l428 488.1a32 32 0 0 0 48.2 0l428-488.1a32 32 0 0 0 2.6-38.7l-190-289a32 32 0 0 0-26.7-14.4z m-615.9 317.5l161.5-245.5h432.8l61.5 93.5-277.7 320.3-189.9-222.4a8 8 0 0 0-12.8 0.8l-32 48.7a8 8 0 0 0 0.6 9.6l209.5 245.4a32 32 0 0 0 48.6 0.2l294.8-340.1 58.9 89.5-377.9 430.9z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalPlusSmart extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M965.7 587.6h-136v-136a8 8 0 0 0-8-8h-56a8 8 0 0 0-8 8v136h-136a8 8 0 0 0-8 8v56a8 8 0 0 0 8 8h136v136a8 8 0 0 0 8 8h56a8 8 0 0 0 8-8v-136h136a8 8 0 0 0 8-8v-56a8 8 0 0 0-8-8z"></path>
      <path d="M162.1 744.8a156 156 0 0 1 84-263.4l50.4-8.7 8.3-50.4a227.7 227.7 0 0 1 224.1-190.3h0.9a228.3 228.3 0 0 1 199.1 116.9 8 8 0 0 0 11 3l48.4-28a8 8 0 0 0 3-10.9c-51.5-91.4-149.3-153-261.5-153h-1.2c-148.4 0.6-271.3 108.8-294.8 250.5-107.2 18.6-188.8 112.1-188.7 224.6h0c0 125.9 102.1 228 228 228h373.5a8 8 0 0 0 8-8v-56a8 8 0 0 0-8-8h-372c-42.1 0-82.9-16.4-112.5-46.3z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalCrowdContrast extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M645.3 912.5h-41.3a8 8 0 0 1-8-8v-56a8 8 0 0 1 8-8h41.3a8 8 0 0 1 8 8v56a8 8 0 0 1-8 8z"></path>
      <path d="M772.1 912.5h-50.8a8 8 0 0 1-8-8v-56a8 8 0 0 1 8-8h50.8a8 8 0 0 1 8 8v56a8 8 0 0 1-8 8z"></path>
      <path d="M840.1 847.3v57.2a8 8 0 0 0 8 8h32a32 32 0 0 0 32-32v-4c0-9.5-0.3-25.8-1-38.2a8 8 0 0 0-9.2-7.5l-55 8.6a8 8 0 0 0-6.8 7.9z"></path>
      <path d="M394.5 576.1l6.9-2.6c23.8-8.8 28.4-40.5 8-55.7l-5.9-4.4a184.4 184.4 0 0 1-53.7-63.3 180.3 180.3 0 0 1-20.1-83.2 182.5 182.5 0 0 1 94.2-159.6 8 8 0 0 0 4.1-7v-62.1a8 8 0 0 0-10.9-7.4 254.2 254.2 0 0 0-98.8 400.8 392.5 392.5 0 0 0-133.8 117.6c-47.3 66.2-72.4 144.8-72.4 227.3v4a32 32 0 0 0 32 32h275.9a8 8 0 0 0 8-8v-56a8 8 0 0 0-8-8h-233.9a314.8 314.8 0 0 1 57-149.4c37.5-52.5 89.9-92.3 151.4-115z"></path>
      <path d="M484 64.1h56a8 8 0 0 1 8 8v880a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8v-880a8 8 0 0 1 8-8z"></path>
      <path d="M696.7 526.4l-40.7-35.1a8 8 0 0 0-11 0.5 184 184 0 0 1-24.2 21.6l-5.9 4.4c-20.4 15.2-15.8 46.9 8 55.7l6.9 2.6c8.5 3.1 16.8 6.6 25.1 10.4a8 8 0 0 0 9.9-2.6l33.2-46.8a8 8 0 0 0-1.3-10.7z"></path>
      <path d="M763.7 329a251.1 251.1 0 0 0-26.3-80.3 8 8 0 0 0-11.1-3.1l-48.3 28.5a8 8 0 0 0-3.1 10.5 179.6 179.6 0 0 1 17.3 53.3 8 8 0 0 0 8.8 6.6l55.7-6.5a8 8 0 0 0 7-9z"></path>
      <path d="M692.3 395.6a179.3 179.3 0 0 1-14.9 48.6 8 8 0 0 0 3.4 10.3l49 27.2a8 8 0 0 0 11.1-3.6 251 251 0 0 0 23-75 8 8 0 0 0-7.2-9.2l-55.8-5a8 8 0 0 0-8.6 6.7z"></path>
      <path d="M663.7 162.6l-1-0.8c-1.1-0.8-2.2-1.6-3.2-2.4l-2.8-1.9c-0.6-0.4-1.2-0.8-1.8-1.2a251.3 251.3 0 0 0-48-25.6 8 8 0 0 0-10.9 7.4v62.1a8 8 0 0 0 4.1 7 183.7 183.7 0 0 1 29.6 20.4 1 1 0 0 1 0-0.2q4.1 3.5 8 7.3a8 8 0 0 0 10.9 0l41.4-37.8a8 8 0 0 0 0.2-11.6 256.3 256.3 0 0 0-26.5-22.7z"></path>
      <path d="M743.4 564.5l-32.5 45.6a8 8 0 0 0 1.8 11 321.3 321.3 0 0 1 50.4 47 8 8 0 0 0 11.1 1l43.5-35.3a8 8 0 0 0 1-11.4 393 393 0 0 0-64-59.8 8 8 0 0 0-11.3 1.8z"></path>
      <path d="M851.7 682.7l-47.9 29a8 8 0 0 0-2.9 10.7 314.5 314.5 0 0 1 25.6 60.9 8 8 0 0 0 9.8 5.4l54-14.8a8 8 0 0 0 5.5-10 386.4 386.4 0 0 0-33-78.3 8 8 0 0 0-11.1-2.9z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandAdvertise extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M473.7 683.2l19.6 19.6c26.1 26.1 70.8 14.2 80.4-21.5l7.1-26.8 72.7-271.6 7.2-26.8c9.6-35.7-23.1-68.3-58.8-58.7l-26.8 7.1-271.6 72.7-26.7 7.2c-35.7 9.6-47.7 54.2-21.6 80.3l19.6 19.6 14.6 14.6-122.6 121.7a32 32 0 0 0 0 45.2l119.4 130.5a32 32 0 0 0 45.2 0l127.7-127.7z m-164.9 45.2l-74.2-85.2 100.1-99.1h0l45.3-45.2-59.9-59.9 271.6-72.7-72.7 271.6-59.8-59.8-45.3 45.2z"></path>
      <path d="M962.5 395.4l-240.2-295.8a42.2 42.2 0 0 0-32.8-15.6h-355.5a42.2 42.2 0 0 0-32.7 15.6l-239.8 294.4a42.3 42.3 0 0 0 1 54.6l78.7 89.9a8 8 0 0 0 11.7 0.4l39.7-39.7a8 8 0 0 0 0.3-10.9l-59.7-68.3 215-264h327.1l215.5 265.3-379.2 431.3-59.8-68.4a8 8 0 0 0-11.7-0.4l-39.7 39.7a8 8 0 0 0-0.4 10.9l79.8 91.2a42.2 42.2 0 0 0 63.5 0.1l418.2-475.7a42.3 42.3 0 0 0 1-54.6z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class FilePlanFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M928 250.4h-455l-110.5-105.7h0a32 32 0 0 0-10.8-6.7l-0.1 0a32 32 0 0 0-11-1.9h-244.6a32 32 0 0 0-32 32v687.9a32 32 0 0 0 32 32h832a32 32 0 0 0 32-32v-573.6a32 32 0 0 0-32-32z m-96 232a7.8 7.8 0 0 1-7.7 8h-624.6a7.8 7.8 0 0 1-7.7-8v-56a7.8 7.8 0 0 1 7.7-8h624.6a7.8 7.8 0 0 1 7.7 8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class FilePlanGroup extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M928 250.4h-355l-110.3-105.5a32 32 0 0 0-22.1-8.9h-216.3a32 32 0 0 0-32 32v579.9a32 32 0 0 0 32 32h703.7a32 32 0 0 0 32-32v-465.5a32 32 0 0 0-32-32z m-40 457.5h-623.7v-499.9h160.2l119.6 114.4h343.9z"></path>
      <path d="M824 835.9h-687.7v-563.9a8 8 0 0 0-8-8h-56a8 8 0 0 0-8 8v603.9a32 32 0 0 0 32 32h727.7a8 8 0 0 0 8-8v-56a8 8 0 0 0-8-8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalPlusCircle extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M696 480H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"></path>
      <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalMinusCircle extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M696 480H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"></path>
      <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalPoweroff extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M705.6 124.9c-5.3-2.7-11.6 1.2-11.6 7.2v64.2c0 5.5 2.9 10.6 7.5 13.6 22.4 14.1 43.2 30.7 62.2 49.8 32.7 32.8 58.4 70.9 76.3 113.3 18.5 43.9 27.9 90.5 27.9 138.7 0 48.1-9.4 94.8-27.9 138.7-17.9 42.4-43.6 80.5-76.3 113.3s-70.8 58.5-113.2 76.4c-43.8 18.6-90.5 28-138.5 28s-94.7-9.4-138.5-28c-42.4-17.9-80.5-43.6-113.2-76.4-32.7-32.8-58.4-70.9-76.3-113.3-18.5-43.9-27.9-90.5-27.9-138.7 0-48.1 9.4-94.8 27.9-138.7 17.9-42.4 43.6-80.5 76.3-113.3 19-19 39.8-35.6 62.2-49.8 4.7-2.9 7.5-8.1 7.5-13.6V132c0-6-6.3-9.8-11.6-7.2C178.5 195.2 82 339.3 80 506.3 77.2 745.1 272.5 943.5 511.2 944c239 0.5 432.8-193.3 432.8-432.4 0-169.2-97-315.7-238.4-386.7z"></path>
      <path d="M480 560h64c4.4 0 8-3.6 8-8V88c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalSync extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M168 504.2c1-43.7 10-86.1 26.9-126 17.3-41 42.1-77.7 73.7-109.4S337 212.3 378 195c42.4-17.9 87.4-27 133.9-27s91.5 9.1 133.8 27c40.9 17.3 77.7 42.1 109.3 73.8 9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47c-5.3 4.1-3.5 12.5 3 14.1l175.7 43c5 1.2 9.9-2.6 9.9-7.7l0.8-180.9c0-6.7-7.7-10.5-12.9-6.3l-56.4 44.1C765.8 155.1 646.2 92 511.8 92 282.7 92 96.3 275.6 92 503.8c-0.1 4.5 3.5 8.2 8 8.2h60c4.4 0 7.9-3.5 8-7.8z m756 7.8h-60c-4.4 0-7.9 3.5-8 7.8-1 43.7-10 86.1-26.9 126-17.3 41-42.1 77.8-73.7 109.4S687 811.7 646 829c-42.4 17.9-87.4 27-133.9 27s-91.5-9.1-133.9-27c-40.9-17.3-77.7-42.1-109.3-73.8-9.9-9.9-19.2-20.4-27.8-31.4l60.2-47c5.3-4.1 3.5-12.5-3-14.1l-175.7-43c-5-1.2-9.9 2.6-9.9 7.7l-0.7 181c0 6.7 7.7 10.5 12.9 6.3l56.4-44.1C258.2 868.9 377.8 932 512.2 932c229.2 0 415.5-183.7 419.8-411.8 0.1-4.5-3.5-8.2-8-8.2z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalReload extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M909.1 209.3l-56.4 44.1C775.8 155.1 656.2 92 521.9 92 290 92 102.3 279.5 102 511.5 101.7 743.7 289.8 932 521.9 932c181.3 0 335.8-115 394.6-276.1 1.5-4.2-0.7-8.9-4.9-10.3l-56.7-19.5c-4.1-1.4-8.6 0.7-10.1 4.8-1.8 5-3.8 10-5.9 14.9-17.3 41-42.1 77.8-73.7 109.4-31.6 31.6-68.4 56.4-109.3 73.8-42.3 17.9-87.4 27-133.8 27-46.5 0-91.5-9.1-133.8-27-40.9-17.3-77.7-42.1-109.3-73.8-31.6-31.6-56.4-68.4-73.7-109.4-17.9-42.4-27-87.4-27-133.9s9.1-91.5 27-133.9c17.3-41 42.1-77.8 73.7-109.4s68.4-56.4 109.3-73.8c42.3-17.9 87.4-27 133.8-27 46.5 0 91.5 9.1 133.8 27 40.9 17.3 77.7 42.1 109.3 73.8 9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47c-5.3 4.1-3.5 12.5 3 14.1l175.6 43c5 1.2 9.9-2.6 9.9-7.7l0.8-180.9c-0.1-6.6-7.8-10.3-13-6.2z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalLoading extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M899.8 347.7c-21.3-50.3-51.7-95.4-90.4-134.1-38.7-38.7-83.9-69.2-134.1-90.4C623.2 101.2 568 90 511 90h-2c-6.1 0-10 6.7-6.9 12l33.5 58c2.6 4.4 7.1 7.4 12.2 7.9 78.5 8.3 151.2 42.8 207.8 99.4C821 332.7 857 419.6 857 512s-36 179.3-101.3 244.7c-65 65-151.3 100.9-243.1 101.3-91 0.4-178.8-35.2-243.7-98.9C201.9 693.5 165 605.6 165 512c0-35 5.2-69.2 15.1-101.8 1.3-4.2 0.8-8.8-1.4-12.7l-36.6-63.4c-3.2-5.6-11.5-5.2-14.2 0.7-2 4.3-3.9 8.6-5.7 12.9C100.2 399.8 89 455 89 512s11.2 112.2 33.2 164.3c21.3 50.3 51.7 95.4 90.4 134.1 38.7 38.7 83.9 69.2 134.1 90.4 52 22 107.3 33.2 164.3 33.2s112.2-11.2 164.3-33.2c50.3-21.3 95.4-51.7 134.1-90.4 38.7-38.7 69.2-83.9 90.4-134.1C921.8 624.2 933 569 933 512s-11.2-112.2-33.2-164.3z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalPlayCircle extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path>
      <path d="M719.4 499.1l-296.1-215c-10.6-7.7-25.3-0.2-25.3 12.9v430c0 13.1 14.8 20.5 25.3 12.9l296.1-215c8.8-6.4 8.8-19.4 0-25.8z m-257.6 134V390.9L628.5 512 461.8 633.1z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalFullscreen extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M290 236.4l43.9-43.9c4.7-4.7 1.9-12.8-4.7-13.6L169 160c-5.1-0.6-9.5 3.7-8.9 8.9L179 329.1c0.8 6.6 8.9 9.4 13.6 4.7l43.7-43.7L370 423.7c3.1 3.1 8.2 3.1 11.3 0l42.4-42.3c3.1-3.1 3.1-8.2 0-11.3L290 236.4z m352.7 187.3c3.1 3.1 8.2 3.1 11.3 0l133.7-133.6 43.7 43.7c4.7 4.7 12.8 1.9 13.6-4.7L863.9 169c0.6-5.1-3.7-9.5-8.9-8.9L694.8 179c-6.6 0.8-9.4 8.9-4.7 13.6l43.9 43.9L600.3 370c-3.1 3.1-3.1 8.2 0 11.3l42.4 42.4zM845 694.9c-0.8-6.6-8.9-9.4-13.6-4.7l-43.7 43.7L654 600.3c-3.1-3.1-8.2-3.1-11.3 0l-42.4 42.3c-3.1 3.1-3.1 8.2 0 11.3L734 787.6l-43.9 43.9c-4.7 4.7-1.9 12.8 4.7 13.6L855 864c5.1 0.6 9.5-3.7 8.9-8.9L845 694.9z m-463.7-94.6c-3.1-3.1-8.2-3.1-11.3 0L236.3 733.9l-43.7-43.7c-4.7-4.7-12.8-1.9-13.6 4.7L160.1 855c-0.6 5.1 3.7 9.5 8.9 8.9L329.2 845c6.6-0.8 9.4-8.9 4.7-13.6L290 787.6 423.7 654c3.1-3.1 3.1-8.2 0-11.3l-42.4-42.4z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalFullscreenExit extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M391 240.9c-0.8-6.6-8.9-9.4-13.6-4.7l-43.7 43.7L200 146.3c-3.1-3.1-8.2-3.1-11.3 0l-42.4 42.3c-3.1 3.1-3.1 8.2 0 11.3L280 333.6l-43.9 43.9c-4.7 4.7-1.9 12.8 4.7 13.6L401 410c5.1 0.6 9.5-3.7 8.9-8.9L391 240.9z m10.1 373.2L240.8 633c-6.6 0.8-9.4 8.9-4.7 13.6l43.9 43.9L146.3 824c-3.1 3.1-3.1 8.2 0 11.3l42.4 42.3c3.1 3.1 8.2 3.1 11.3 0L333.7 744l43.7 43.7c4.7 4.7 12.8 1.9 13.6-4.7l18.9-160.1c0.6-5.1-3.7-9.4-8.8-8.8z m221.8-204.2L783.2 391c6.6-0.8 9.4-8.9 4.7-13.6L744 333.6 877.7 200c3.1-3.1 3.1-8.2 0-11.3l-42.4-42.3c-3.1-3.1-8.2-3.1-11.3 0L690.3 279.9l-43.7-43.7c-4.7-4.7-12.8-1.9-13.6 4.7L614.1 401c-0.6 5.2 3.7 9.5 8.8 8.9zM744 690.4l43.9-43.9c4.7-4.7 1.9-12.8-4.7-13.6L623 614c-5.1-0.6-9.5 3.7-8.9 8.9L633 783.1c0.8 6.6 8.9 9.4 13.6 4.7l43.7-43.7L824 877.7c3.1 3.1 8.2 3.1 11.3 0l42.4-42.3c3.1-3.1 3.1-8.2 0-11.3L744 690.4z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalUpload extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M400 317.7h73.9V656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V317.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 163c-3.2-4.1-9.4-4.1-12.6 0l-112 141.7c-4.1 5.3-0.4 13 6.3 13z"></path>
      <path d="M878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalDownload extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M331.75 745.82l132.93 132.85 42.43 42.4a8 8 0 0 0 11.31 0l42.43-42.4 132.94-132.85a8 8 0 0 0 0-11.31l-42.43-42.4a8 8 0 0 0-11.31 0l-89.28 89.23V462.51a8 8 0 0 0-8-8h-60a8 8 0 0 0-8 8v318.83l-89.28-89.23a8 8 0 0 0-11.32 0l-42.42 42.4a8 8 0 0 0 0 11.31z"></path>
      <path d="M811.4 346.32c-45.8-126.77-162.5-216.91-299.2-216.91s-253.4 90-299.2 216.8C127.3 369.82 64 451.77 64 549.15c0 88.38 52 163.94 125.59 194.85a8 8 0 0 0 8.78-1.72l51-51a8 8 0 0 0-4.33-13.54c-26.55-4.22-51-17.38-70.18-38.07-23.5-25.39-36-59.6-34.9-95.07A133.09 133.09 0 0 1 166.2 469c16.7-22.35 40.1-38.61 66.1-45.85l37.9-10.39 13.9-38.41a256.19 256.19 0 0 1 35.7-66.53 251.29 251.29 0 0 1 52.4-52.36c41.1-30.32 89.5-46.38 140-46.38s98.9 16.06 140 46.38a251.3 251.3 0 0 1 52.4 52.36 257.81 257.81 0 0 1 35.7 66.53l13.8 38.3 37.8 10.5c54.2 15.32 92.1 67.05 92.1 126 0 34.74-12.9 67.48-36.3 92-18.93 19.87-42.91 32.52-68.9 36.62a8 8 0 0 0-4.42 13.55l51.08 51a8 8 0 0 0 8.77 1.72C907.93 713.21 960 637.6 960 549.15c0-97.27-63.1-179.15-148.6-202.83z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalBack extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M793.6 202H288.5c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h407.9L221.8 752.5c-3.1 3.1-3.1 8.2 0 11.3l42.4 42.4c3.1 3.1 8.2 3.1 11.3 0l474-474v406.9c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V234c0.1-17.7-14.3-32-31.9-32z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalSwap extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M847.9 592H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h605.2L612.9 851c-4.1 5.2-0.4 13 6.3 13h72.5c4.9 0 9.5-2.2 12.6-6.1l168.8-214.1c16.5-21 1.6-51.8-25.2-51.8zM872 356H266.8l144.3-183c4.1-5.2 0.4-13-6.3-13h-72.5c-4.9 0-9.5 2.2-12.6 6.1L150.9 380.2c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalPlusSquare extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"></path>
      <path d="M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32z m-40 728H184V184h656v656z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalMinusSquare extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"></path>
      <path d="M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32z m-40 728H184V184h656v656z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalBorder extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32z m-40 728H184V184h656v656z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalCheckSquare extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M433.1 657.7c12.7 17.7 39 17.7 51.7 0l210.6-292c3.8-5.3 0-12.7-6.5-12.7H642c-10.2 0-19.9 4.9-25.9 13.3L459 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H315c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8z"></path>
      <path d="M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32z m-40 728H184V184h656v656z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalDetail extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32z m-40 728H184V184h656v656z"></path>
      <path d="M492 400h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z m0 144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z m0 144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zM340 368c0 22.1 17.9 40 40 40s40-17.9 40-40-17.9-40-40-40-40 17.9-40 40zM340 512c0 22.1 17.9 40 40 40s40-17.9 40-40-17.9-40-40-40-40 17.9-40 40zM340 656c0 22.1 17.9 40 40 40s40-17.9 40-40-17.9-40-40-40-40 17.9-40 40z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalWorking extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M310.9 419.8L420.7 512l-109.8 92.2c-1.8 1.5-2.9 3.8-2.9 6.1V673c0 6.8 7.9 10.5 13.1 6.1l192-161c3.8-3.2 3.8-9.1 0-12.3l-192-160.9c-5.2-4.4-13.1-0.7-13.1 6.1v62.7c0 2.4 1 4.6 2.9 6.1zM523.5 681h185c4.1 0 7.5-3.6 7.5-8v-48c0-4.4-3.4-8-7.5-8h-185c-4.1 0-7.5 3.6-7.5 8v48c0 4.4 3.4 8 7.5 8z"></path>
      <path d="M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32z m-40 728H184V184h656v656z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalControl extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32z m-40 728H184V184h656v656z"></path>
      <path d="M340 683v77c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-77c-10.1 3.3-20.8 5-32 5s-21.9-1.8-32-5z m64-198V264c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v221c10.1-3.3 20.8-5 32-5s21.9 1.8 32 5z"></path>
      <path d="M340 683c10.1 3.3 20.8 5 32 5s21.9-1.8 32-5c41.8-13.5 72-52.7 72-99s-30.2-85.5-72-99c-10.1-3.3-20.8-5-32-5s-21.9 1.8-32 5c-41.8 13.5-72 52.7-72 99s30.2 85.5 72 99z m0.1-115.7c0.3-0.6 0.7-1.2 1-1.8v-0.1l1.2-1.8c0.1-0.2 0.2-0.3 0.3-0.5 0.3-0.5 0.7-0.9 1-1.4 0.1-0.1 0.2-0.3 0.3-0.4 0.5-0.6 0.9-1.1 1.4-1.6l0.3-0.3 1.2-1.2 0.4-0.4c0.5-0.5 1-0.9 1.6-1.4s1.1-0.9 1.7-1.3c0.2-0.1 0.3-0.2 0.5-0.3 0.5-0.3 0.9-0.7 1.4-1 0.1-0.1 0.3-0.2 0.4-0.3 0.6-0.4 1.2-0.7 1.9-1.1 0.1-0.1 0.3-0.1 0.4-0.2 0.5-0.3 1-0.5 1.6-0.8l0.6-0.3c0.7-0.3 1.3-0.6 2-0.8 0.7-0.3 1.4-0.5 2.1-0.7 0.2-0.1 0.4-0.1 0.6-0.2 0.6-0.2 1.1-0.3 1.7-0.4 0.2 0 0.3-0.1 0.5-0.1 0.7-0.2 1.5-0.3 2.2-0.4 0.2 0 0.3 0 0.5-0.1 0.6-0.1 1.2-0.1 1.8-0.2h0.6c0.8 0 1.5-0.1 2.3-0.1s1.5 0 2.3 0.1h0.6c0.6 0 1.2 0.1 1.8 0.2 0.2 0 0.3 0 0.5 0.1 0.7 0.1 1.5 0.2 2.2 0.4 0.2 0 0.3 0.1 0.5 0.1 0.6 0.1 1.2 0.3 1.7 0.4 0.2 0.1 0.4 0.1 0.6 0.2 0.7 0.2 1.4 0.4 2.1 0.7 0.7 0.2 1.3 0.5 2 0.8l0.6 0.3c0.5 0.2 1.1 0.5 1.6 0.8 0.1 0.1 0.3 0.1 0.4 0.2 0.6 0.3 1.3 0.7 1.9 1.1 0.1 0.1 0.3 0.2 0.4 0.3 0.5 0.3 1 0.6 1.4 1 0.2 0.1 0.3 0.2 0.5 0.3 0.6 0.4 1.2 0.9 1.7 1.3s1.1 0.9 1.6 1.4l0.4 0.4 1.2 1.2 0.3 0.3c0.5 0.5 1 1.1 1.4 1.6 0.1 0.1 0.2 0.3 0.3 0.4 0.4 0.4 0.7 0.9 1 1.4 0.1 0.2 0.2 0.3 0.3 0.5l1.2 1.8s0 0.1 0.1 0.1c0.4 0.6 0.7 1.2 1 1.8 2.6 5 4.1 10.7 4.1 16.7s-1.5 11.7-4.1 16.7c-0.3 0.6-0.7 1.2-1 1.8 0 0 0 0.1-0.1 0.1l-1.2 1.8c-0.1 0.2-0.2 0.3-0.3 0.5-0.3 0.5-0.7 0.9-1 1.4-0.1 0.1-0.2 0.3-0.3 0.4-0.5 0.6-0.9 1.1-1.4 1.6l-0.3 0.3-1.2 1.2-0.4 0.4c-0.5 0.5-1 0.9-1.6 1.4s-1.1 0.9-1.7 1.3c-0.2 0.1-0.3 0.2-0.5 0.3-0.5 0.3-0.9 0.7-1.4 1-0.1 0.1-0.3 0.2-0.4 0.3-0.6 0.4-1.2 0.7-1.9 1.1-0.1 0.1-0.3 0.1-0.4 0.2-0.5 0.3-1 0.5-1.6 0.8l-0.6 0.3c-0.7 0.3-1.3 0.6-2 0.8-0.7 0.3-1.4 0.5-2.1 0.7-0.2 0.1-0.4 0.1-0.6 0.2-0.6 0.2-1.1 0.3-1.7 0.4-0.2 0-0.3 0.1-0.5 0.1-0.7 0.2-1.5 0.3-2.2 0.4-0.2 0-0.3 0-0.5 0.1-0.6 0.1-1.2 0.1-1.8 0.2h-0.6c-0.8 0-1.5 0.1-2.3 0.1s-1.5 0-2.3-0.1h-0.6c-0.6 0-1.2-0.1-1.8-0.2-0.2 0-0.3 0-0.5-0.1-0.7-0.1-1.5-0.2-2.2-0.4-0.2 0-0.3-0.1-0.5-0.1-0.6-0.1-1.2-0.3-1.7-0.4-0.2-0.1-0.4-0.1-0.6-0.2-0.7-0.2-1.4-0.4-2.1-0.7-0.7-0.2-1.3-0.5-2-0.8l-0.6-0.3c-0.5-0.2-1.1-0.5-1.6-0.8-0.1-0.1-0.3-0.1-0.4-0.2-0.6-0.3-1.3-0.7-1.9-1.1-0.1-0.1-0.3-0.2-0.4-0.3-0.5-0.3-1-0.6-1.4-1-0.2-0.1-0.3-0.2-0.5-0.3-0.6-0.4-1.2-0.9-1.7-1.3s-1.1-0.9-1.6-1.4l-0.4-0.4-1.2-1.2-0.3-0.3c-0.5-0.5-1-1.1-1.4-1.6-0.1-0.1-0.2-0.3-0.3-0.4-0.4-0.4-0.7-0.9-1-1.4-0.1-0.2-0.2-0.3-0.3-0.5l-1.2-1.8v-0.1c-0.4-0.6-0.7-1.2-1-1.8-2.6-5-4.1-10.7-4.1-16.7s1.5-11.7 4.1-16.7zM620 539v221c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V539c-10.1 3.3-20.8 5-32 5s-21.9-1.8-32-5z m64-198v-77c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v77c10.1-3.3 20.8-5 32-5s21.9 1.8 32 5z"></path>
      <path d="M620 539c10.1 3.3 20.8 5 32 5s21.9-1.8 32-5c41.8-13.5 72-52.7 72-99s-30.2-85.5-72-99c-10.1-3.3-20.8-5-32-5s-21.9 1.8-32 5c-41.8 13.5-72 52.7-72 99s30.2 85.5 72 99z m0.1-115.7c0.3-0.6 0.7-1.2 1-1.8v-0.1l1.2-1.8c0.1-0.2 0.2-0.3 0.3-0.5 0.3-0.5 0.7-0.9 1-1.4 0.1-0.1 0.2-0.3 0.3-0.4 0.5-0.6 0.9-1.1 1.4-1.6l0.3-0.3 1.2-1.2 0.4-0.4c0.5-0.5 1-0.9 1.6-1.4s1.1-0.9 1.7-1.3c0.2-0.1 0.3-0.2 0.5-0.3 0.5-0.3 0.9-0.7 1.4-1 0.1-0.1 0.3-0.2 0.4-0.3 0.6-0.4 1.2-0.7 1.9-1.1 0.1-0.1 0.3-0.1 0.4-0.2 0.5-0.3 1-0.5 1.6-0.8l0.6-0.3c0.7-0.3 1.3-0.6 2-0.8 0.7-0.3 1.4-0.5 2.1-0.7 0.2-0.1 0.4-0.1 0.6-0.2 0.6-0.2 1.1-0.3 1.7-0.4 0.2 0 0.3-0.1 0.5-0.1 0.7-0.2 1.5-0.3 2.2-0.4 0.2 0 0.3 0 0.5-0.1 0.6-0.1 1.2-0.1 1.8-0.2h0.6c0.8 0 1.5-0.1 2.3-0.1s1.5 0 2.3 0.1h0.6c0.6 0 1.2 0.1 1.8 0.2 0.2 0 0.3 0 0.5 0.1 0.7 0.1 1.5 0.2 2.2 0.4 0.2 0 0.3 0.1 0.5 0.1 0.6 0.1 1.2 0.3 1.7 0.4 0.2 0.1 0.4 0.1 0.6 0.2 0.7 0.2 1.4 0.4 2.1 0.7 0.7 0.2 1.3 0.5 2 0.8l0.6 0.3c0.5 0.2 1.1 0.5 1.6 0.8 0.1 0.1 0.3 0.1 0.4 0.2 0.6 0.3 1.3 0.7 1.9 1.1 0.1 0.1 0.3 0.2 0.4 0.3 0.5 0.3 1 0.6 1.4 1 0.2 0.1 0.3 0.2 0.5 0.3 0.6 0.4 1.2 0.9 1.7 1.3s1.1 0.9 1.6 1.4l0.4 0.4 1.2 1.2 0.3 0.3c0.5 0.5 1 1.1 1.4 1.6 0.1 0.1 0.2 0.3 0.3 0.4 0.4 0.4 0.7 0.9 1 1.4 0.1 0.2 0.2 0.3 0.3 0.5l1.2 1.8v0.1c0.4 0.6 0.7 1.2 1 1.8 2.6 5 4.1 10.7 4.1 16.7s-1.5 11.7-4.1 16.7c-0.3 0.6-0.7 1.2-1 1.8v0.1l-1.2 1.8c-0.1 0.2-0.2 0.3-0.3 0.5-0.3 0.5-0.7 0.9-1 1.4-0.1 0.1-0.2 0.3-0.3 0.4-0.5 0.6-0.9 1.1-1.4 1.6l-0.3 0.3-1.2 1.2-0.4 0.4c-0.5 0.5-1 0.9-1.6 1.4s-1.1 0.9-1.7 1.3c-0.2 0.1-0.3 0.2-0.5 0.3-0.5 0.3-0.9 0.7-1.4 1-0.1 0.1-0.3 0.2-0.4 0.3-0.6 0.4-1.2 0.7-1.9 1.1-0.1 0.1-0.3 0.1-0.4 0.2-0.5 0.3-1 0.5-1.6 0.8l-0.6 0.3c-0.7 0.3-1.3 0.6-2 0.8-0.7 0.3-1.4 0.5-2.1 0.7-0.2 0.1-0.4 0.1-0.6 0.2-0.6 0.2-1.1 0.3-1.7 0.4-0.2 0-0.3 0.1-0.5 0.1-0.7 0.2-1.5 0.3-2.2 0.4-0.2 0-0.3 0-0.5 0.1-0.6 0.1-1.2 0.1-1.8 0.2h-0.6c-0.8 0-1.5 0.1-2.3 0.1s-1.5 0-2.3-0.1h-0.6c-0.6 0-1.2-0.1-1.8-0.2-0.2 0-0.3 0-0.5-0.1-0.7-0.1-1.5-0.2-2.2-0.4-0.2 0-0.3-0.1-0.5-0.1-0.6-0.1-1.2-0.3-1.7-0.4-0.2-0.1-0.4-0.1-0.6-0.2-0.7-0.2-1.4-0.4-2.1-0.7-0.7-0.2-1.3-0.5-2-0.8l-0.6-0.3c-0.5-0.2-1.1-0.5-1.6-0.8-0.1-0.1-0.3-0.1-0.4-0.2-0.6-0.3-1.3-0.7-1.9-1.1-0.1-0.1-0.3-0.2-0.4-0.3-0.5-0.3-1-0.6-1.4-1-0.2-0.1-0.3-0.2-0.5-0.3-0.6-0.4-1.2-0.9-1.7-1.3s-1.1-0.9-1.6-1.4l-0.4-0.4-1.2-1.2-0.3-0.3c-0.5-0.5-1-1.1-1.4-1.6-0.1-0.1-0.2-0.3-0.3-0.4-0.4-0.4-0.7-0.9-1-1.4-0.1-0.2-0.2-0.3-0.3-0.5l-1.2-1.8v-0.1c-0.4-0.6-0.7-1.2-1-1.8-2.6-5-4.1-10.7-4.1-16.7s1.5-11.7 4.1-16.7z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalImport extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M888.3 757.4h-53.8c-4.2 0-7.7 3.5-7.7 7.7v61.8H197.1V197.1h629.8v61.8c0 4.2 3.5 7.7 7.7 7.7h53.8c4.2 0 7.7-3.4 7.7-7.7V158.7c0-17-13.7-30.7-30.7-30.7H158.7c-17 0-30.7 13.7-30.7 30.7v706.6c0 17 13.7 30.7 30.7 30.7h706.6c17 0 30.7-13.7 30.7-30.7V765.1c0-4.3-3.5-7.7-7.7-7.7z"></path>
      <path d="M902 476H588v-76c0-6.7-7.8-10.5-13-6.3l-141.9 112c-4.1 3.2-4.1 9.4 0 12.6l141.9 112c5.3 4.2 13 0.4 13-6.3v-76h314c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalEdit extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M904 512h-56c-4.4 0-8 3.6-8 8v320H184V184h320c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V520c0-4.4-3.6-8-8-8z"></path>
      <path d="M355.9 534.9L354 653.8c-0.1 8.9 7.1 16.2 16 16.2h0.4l118-2.9c2-0.1 4-0.9 5.4-2.3l415.9-415c3.1-3.1 3.1-8.2 0-11.3L785.4 114.3c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1 0.8-5.7 2.3l-415.8 415c-1.4 1.5-2.3 3.5-2.3 5.6z m63.5 23.6L779.7 199l45.2 45.1-360.5 359.7-45.7 1.1 0.7-46.4z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalCalendar extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32z m-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalDelete extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zM864 256H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalLike extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 0 0-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4-20.5-21.5-48.1-33.4-77.9-33.4-52 0-98 35-111.8 85.1l-85.9 311H144c-17.7 0-32 14.3-32 32v364c0 17.7 14.3 32 32 32h601.3c9.2 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7-0.2-12.6-2-25.1-5.6-37.1zM184 852V568h81v284h-81z m636.4-353l-21.9 19 13.9 25.4c4.6 8.4 6.9 17.6 6.9 27.3 0 16.5-7.2 32.2-19.6 43l-21.9 19 13.9 25.4c4.6 8.4 6.9 17.6 6.9 27.3 0 16.5-7.2 32.2-19.6 43l-21.9 19 13.9 25.4c4.6 8.4 6.9 17.6 6.9 27.3 0 22.4-13.2 42.6-33.6 51.8H329V564.8l99.5-360.5c5.2-18.9 22.5-32.2 42.2-32.3 7.6 0 15.1 2.2 21.1 6.7 9.9 7.4 15.2 18.6 14.6 30.5l-9.6 198.4h314.4C829 418.5 840 436.9 840 456c0 16.5-7.2 32.1-19.6 43z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalUnlike extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M885.9 490.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4-8.3-3.6-17.2-5.4-26.5-5.4H144c-17.7 0-32 14.3-32 32v364c0 17.7 14.3 32 32 32h129.3l85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zM184 456V172h81v284h-81z m627.2 160.4H496.8l9.6 198.4c0.6 11.9-4.7 23.1-14.6 30.5-6.1 4.5-13.6 6.8-21.1 6.7-19.6-0.1-36.9-13.4-42.2-32.3L329 459.2V172h415.4c20.4 9.2 33.6 29.4 33.6 51.8 0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19c12.5 10.8 19.6 26.5 19.6 43 0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19c12.5 10.8 19.6 26.5 19.6 43 0 9.7-2.3 18.9-6.9 27.3l-14 25.5 21.9 19c12.5 10.8 19.6 26.5 19.6 43 0 19.1-11 37.5-28.8 48.4z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalHeart extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M923 283.6c-13.4-31.1-32.6-58.9-56.9-82.8-24.3-23.8-52.5-42.4-84-55.5-32.5-13.5-66.9-20.3-102.4-20.3-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5-24.4 23.9-43.5 51.7-56.9 82.8-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3 0.1-35.3-7-69.6-20.9-101.9zM512 814.8S156 586.7 156 385.5C156 283.6 240.3 201 344.3 201c73.1 0 136.5 40.8 167.7 100.4C543.2 241.8 606.6 201 679.7 201c104 0 188.3 82.6 188.3 184.5 0 201.2-356 429.3-356 429.3z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalSetting extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M924.8 625.7l-65.5-56c3.1-19 4.7-38.4 4.7-57.8s-1.6-38.8-4.7-57.8l65.5-56c10.1-8.6 13.8-22.6 9.3-35.2l-0.9-2.6c-18.1-50.5-44.9-96.9-79.7-137.9l-1.8-2.1c-8.6-10.1-22.5-13.9-35.1-9.5l-81.3 28.9c-30-24.6-63.5-44-99.7-57.6l-15.7-85c-2.4-13.1-12.7-23.3-25.8-25.7l-2.7-0.5c-52.1-9.4-106.9-9.4-159 0l-2.7 0.5c-13.1 2.4-23.4 12.6-25.8 25.7l-15.8 85.4c-35.9 13.6-69.2 32.9-99 57.4l-81.9-29.1c-12.5-4.4-26.5-0.7-35.1 9.5l-1.8 2.1c-34.8 41.1-61.6 87.5-79.7 137.9l-0.9 2.6c-4.5 12.5-0.8 26.5 9.3 35.2l66.3 56.6c-3.1 18.8-4.6 38-4.6 57.1 0 19.2 1.5 38.4 4.6 57.1L99 625.5c-10.1 8.6-13.8 22.6-9.3 35.2l0.9 2.6c18.1 50.4 44.9 96.9 79.7 137.9l1.8 2.1c8.6 10.1 22.5 13.9 35.1 9.5l81.9-29.1c29.8 24.5 63.1 43.9 99 57.4l15.8 85.4c2.4 13.1 12.7 23.3 25.8 25.7l2.7 0.5c26.1 4.7 52.8 7.1 79.5 7.1s53.5-2.4 79.5-7.1l2.7-0.5c13.1-2.4 23.4-12.6 25.8-25.7l15.7-85c36.2-13.6 69.7-32.9 99.7-57.6l81.3 28.9c12.5 4.4 26.5 0.7 35.1-9.5l1.8-2.1c34.8-41.1 61.6-87.5 79.7-137.9l0.9-2.6c4.5-12.3 0.8-26.3-9.3-35zM788.3 465.9c2.5 15.1 3.8 30.6 3.8 46.1s-1.3 31-3.8 46.1l-6.6 40.1 74.7 63.9c-11.3 26.1-25.6 50.7-42.6 73.6L721 702.8l-31.4 25.8c-23.9 19.6-50.5 35-79.3 45.8l-38.1 14.3-17.9 97c-28.1 3.2-56.8 3.2-85 0l-17.9-97.2-37.8-14.5c-28.5-10.8-55-26.2-78.7-45.7l-31.4-25.9-93.4 33.2c-17-22.9-31.2-47.6-42.6-73.6l75.5-64.5-6.5-40c-2.4-14.9-3.7-30.3-3.7-45.5 0-15.3 1.2-30.6 3.7-45.5l6.5-40-75.5-64.5c11.3-26.1 25.6-50.7 42.6-73.6l93.4 33.2 31.4-25.9c23.7-19.5 50.2-34.9 78.7-45.7l37.9-14.3 17.9-97.2c28.1-3.2 56.8-3.2 85 0l17.9 97 38.1 14.3c28.7 10.8 55.4 26.2 79.3 45.8l31.4 25.8 92.8-32.9c17 22.9 31.2 47.6 42.6 73.6L781.8 426l6.5 39.9z"></path>
      <path d="M512 326c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176z m79.2 255.2C570 602.3 541.9 614 512 614c-29.9 0-58-11.7-79.2-32.8C411.7 560 400 531.9 400 502c0-29.9 11.7-58 32.8-79.2C454 401.6 482.1 390 512 390c29.9 0 58 11.6 79.2 32.8C612.3 444 624 472.1 624 502c0 29.9-11.7 58-32.8 79.2z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalStar extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3-12.3 12.7-12.1 32.9 0.6 45.3l183.7 179.1-43.4 252.9c-1.2 6.9-0.1 14.1 3.2 20.3 8.2 15.6 27.6 21.7 43.2 13.4L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM664.8 561.6l36.1 210.3L512 672.7 323.1 772l36.1-210.3-152.8-149L417.6 382 512 190.7 606.4 382l211.2 30.7-152.8 148.9z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalDashboard extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M924.8 385.6c-22.6-53.4-54.9-101.3-96-142.4s-89-73.4-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2c-53.4 22.6-101.3 54.9-142.4 96s-73.4 89-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM761.4 836H262.6C184.5 765.5 140 665.6 140 560c0-99.4 38.7-192.8 109-263 70.3-70.3 163.7-109 263-109 99.4 0 192.8 38.7 263 109 70.3 70.3 109 163.7 109 263 0 105.6-44.5 205.5-122.6 276z"></path>
      <path d="M623.5 421.5c-3.1-3.1-8.2-3.1-11.3 0L527.7 506c-18.7-5-39.4-0.2-54.1 14.5-21.9 21.9-21.9 57.3 0 79.2s57.3 21.9 79.2 0c14.7-14.7 19.5-35.4 14.5-54.1l84.5-84.5c3.1-3.1 3.1-8.2 0-11.3l-28.3-28.3zM490 320h44c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8h-44c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8z m260 218v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8z m12.7-197.2l-31.1-31.1c-3.1-3.1-8.2-3.1-11.3 0l-56.6 56.6c-3.1 3.1-3.1 8.2 0 11.3l31.1 31.1c3.1 3.1 8.2 3.1 11.3 0l56.6-56.6c3.1-3.1 3.1-8.2 0-11.3z m-458.6-31.1c-3.1-3.1-8.2-3.1-11.3 0l-31.1 31.1c-3.1 3.1-3.1 8.2 0 11.3l56.6 56.6c3.1 3.1 8.2 3.1 11.3 0l31.1-31.1c3.1-3.1 3.1-8.2 0-11.3l-56.6-56.6zM262 530h-80c-4.4 0-8 3.6-8 8v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalUnite extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M903.7 703.1c-42.5-24.6-94.3-18-129.2 12.8l-68.4-40.6V523.6c0-15.7-8.4-30.3-22-38.1l-136-78.3v-87.1c44.2-15 76-56.8 76-106.1 0-61.9-50.1-112-112-112s-112 50.1-112 112c0 49.3 31.8 91.1 76 106.1v87.1l-136 78.3c-13.6 7.8-22 22.4-22 38.1v151.6l-69 40.7c-34.9-30.8-86.8-37.4-129.2-12.8-53.5 31-71.7 99.4-41 152.9 30.8 53.5 98.9 71.9 152.2 41 42.5-24.6 62.7-73 53.6-118.8l64.7-38.3 140.6 81c6.8 3.9 14.4 5.9 22 5.9s15.2-2 22-5.9L674.5 740l64.1 38.2c-9.1 45.7 11.2 94.2 53.6 118.8 53.3 30.9 121.5 12.6 152.2-41 30.8-53.6 12.6-122-40.7-152.9zM199.3 841.6c-22.8 13.2-52.1 5.4-65.2-17.6-13.2-22.9-5.4-52.3 17.5-65.5 22.8-13.2 52.1-5.4 65.2 17.6 13.2 22.9 5.4 52.3-17.5 65.5zM464 214c0-26.5 21.5-48 48-48s48 21.5 48 48-21.5 48-48 48-48-21.5-48-48z m170 466.2l-122 70.3-122-70.3V539.8l122-70.3 122 70.3v140.4zM889.3 824c-13.2 22.9-42.4 30.8-65.2 17.6s-30.7-42.6-17.5-65.5 42.4-30.8 65.2-17.6c22.9 13.2 30.7 42.5 17.5 65.5z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalAlert extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M484.01 169.42h55.97c4.42 0 8-3.58 8-7.99V65.49c0-4.42-3.58-7.99-8-7.99h-55.97c-4.42 0-8 3.58-8 7.99v95.93c0.01 4.42 3.59 8 8 8zM260.5 285.16l39.58-39.57c3.12-3.12 3.12-8.18 0-11.31l-67.85-67.83c-3.12-3.12-8.19-3.12-11.31 0l-39.58 39.57c-3.12 3.12-3.12 8.18 0 11.31l67.85 67.83c3.12 3.12 8.18 3.12 11.31 0zM842.66 206.02l-39.58-39.57c-3.12-3.12-8.19-3.12-11.31 0l-67.85 67.83c-3.12 3.12-3.12 8.18 0 11.31l39.58 39.57c3.12 3.12 8.19 3.12 11.31 0l67.85-67.83c3.12-3.12 3.12-8.19 0-11.31zM850.3 854.5H173.7c-7.57 0-13.7 6.13-13.7 13.7v44.6c0 7.57 6.13 13.7 13.7 13.7h676.6c7.57 0 13.7-6.13 13.7-13.7v-44.6c0-7.57-6.13-13.7-13.7-13.7zM514 205.5c-161.27 0-292 130.67-292 291.86V779.5c0 17.67 14.33 32 32 32h520c17.67 0 32-14.33 32-32V497.36c0-161.19-130.73-291.86-292-291.86z m220 534H294V499.38c0-121.22 99.18-222.1 220.4-221.88 121.32 0.22 219.6 98.63 219.6 220v242z"></path>
      <path d="M430 539.34h-56c-4.42 0-8 3.58-8 8v192h72v-192c0-4.41-3.58-8-8-8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalMail extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M928 188H96c-17.7 0-32 14.3-32 32v584c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V220c0-17.7-14.3-32-32-32z m-116.2 72L512 433.1 212.1 260h599.7zM136 764V303.8l48 27.7L436 477l60 34.6c9.9 5.7 22.1 5.7 32 0l60-34.6 252-145.5 48-27.7V764H136z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalMailOpen extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M940.6 306.8l6.6 3.8c-2-1.5-4.2-2.8-6.6-3.8z m-863.8 3.8l6.6-3.8c-2.4 1-4.6 2.3-6.6 3.8z"></path>
      <path d="M947.2 310.6l-6.6-3.8-40-23.2-60.6-35.2L588 103l-60-34.6c-9.9-5.7-22.1-5.7-32 0L436 103 184 248.4l-60.6 35.1-40 23.2-6.6 3.8c-7.8 6-12.8 15.2-12.8 25.7v543c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32v-543c0-10.5-5-19.7-12.8-25.6z m-739.5 11.9l1-0.6 30.8-17.8L512 146.8l266.1 153.6 6.5 3.8 27.7 16 12.1 7.5-8.1 4.7-1 0.6-74.8 43.2L512 508.1 283.5 376.2 208.7 333l-1-0.6-8.5-4.9 8.5-5zM888 839.2H136V378.7l48 27.8L436 552l60 34.6c9.9 5.7 22.1 5.7 32 0l60-34.6 252-145.5 48-27.8v460.5z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalRadio extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M407.5 716.4c7.4 4.3 15.7 6.4 24 6.4s16.6-2.1 24-6.4l220.2-127.1c14.8-8.5 24-24.5 24-41.6s-9.2-33-24-41.6l-220.2-127c-14.8-8.5-33.2-8.5-48 0s-24 24.5-24 41.6v254.2c0 17 9.2 33 24 41.5z m40-268l172.2 99.4-172.2 99.4V448.4z"></path>
      <path d="M959.8 762.5v-492c0.3-1.8 0.5-3.6 0.5-5.5 0-16.8-12.9-30.5-29.3-31.9v-0.1H670.7l71.5-71.1c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0L580.2 233h-136L328.5 116.7c-6.2-6.2-16.4-6.2-22.6 0l-22.6 22.6c-6.2 6.2-6.2 16.4 0 22.6l70.4 71.1H95.8c-17.7 0-32 14.3-32 32v567c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32v-69.5z m-72 29.5h-752V305h752v487z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalPlus extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M848 474H550V160c0-5.3-2.7-8-8-8h-60c-5.3 0-8 2.7-8 8v314H176c-5.3 0-8 2.7-8 8v60c0 5.3 2.7 8 8 8h298v314c0 5.3 2.7 8 8 8h60c5.3 0 8-2.7 8-8V550h298c5.3 0 8-2.7 8-8v-60c0-5.3-2.7-8-8-8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalClose extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M563.8 512l262.5-312.9c4.4-5.2 0.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9c-4.4 5.2-0.7 13.1 6.1 13.1h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalCheck extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474c-6.1-7.7-15.3-12.2-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1 0.4-12.8-6.3-12.8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalPause extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M304 176h80v672h-80V176z m408 0h-64c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalSearch extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6c3.2 3.2 8.4 3.2 11.6 0l43.6-43.5c3.2-3.2 3.2-8.4 0-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalUser extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M858.5 763.6c-18.9-44.8-46.1-85-80.6-119.5s-74.7-61.6-119.5-80.6c-0.4-0.2-0.8-0.3-1.2-0.5C719.5 518 760 444.7 760 362c0-137-111-248-248-248S264 225 264 362c0 82.7 40.5 156 102.8 201.1-0.4 0.2-0.8 0.3-1.2 0.5-44.8 18.9-85 46-119.5 80.6-34.5 34.5-61.6 74.7-80.6 119.5C146.9 807.5 137 854 136 901.8c-0.1 4.5 3.5 8.2 8 8.2h60c4.4 0 7.9-3.5 8-7.8 2-77.2 33-149.5 87.8-204.3 56.7-56.7 132-87.9 212.2-87.9s155.5 31.2 212.2 87.9C779 752.7 810 825 812 902.2c0.1 4.4 3.6 7.8 8 7.8h60c4.5 0 8.1-3.7 8-8.2-1-47.8-10.9-94.3-29.5-138.2zM512 534c-45.9 0-89.1-17.9-121.6-50.4S340 407.9 340 362s17.9-89.1 50.4-121.6S466.1 190 512 190s89.1 17.9 121.6 50.4S684 316.1 684 362s-17.9 89.1-50.4 121.6S557.9 534 512 534z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalTop extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M535.6 327.4c-12.5-12.5-32.8-12.5-45.2 0l-218 218c-3.1 3.1-3.1 8.2 0 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l153.8-153.8v391.6c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V442.7l153.1 153.1c3.1 3.1 8.2 3.1 11.3 0l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3L535.6 327.4zM859.9 178H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalCancelTop extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M535.6 696.6c-12.5 12.5-32.8 12.5-45.2 0L300.9 507.1c-3.1-3.1-3.1-8.2 0-11.3l39.6-39.6c3.1-3.1 8.2-3.1 11.3 0l125.3 125.3V189.9c0-4.4 3.6-8 8-8h56c4.4 0 8 3.6 8 8v391.4l125.1-125.1c3.1-3.1 8.2-3.1 11.3 0l39.6 39.6c3.1 3.1 3.1 8.2 0 11.3L535.6 696.6zM859.9 846H164.1c-4.5 0-8.1-3.6-8.1-8v-60c0-4.4 3.6-8 8.1-8h695.8c4.5 0 8.1 3.6 8.1 8v60c0 4.4-3.6 8-8.1 8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalReplacePicture extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M306.5 271.1c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80z m0 112c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zM292.1 464c-3.1-3.1-8.2-3.1-11.3 0L146 598.9V224h732v320.2c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V184c0-17.7-14.3-32-32-32H106c-17.7 0-32 14.3-32 32v636.4c0 17.7 14.3 32 32 32h408c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H146v-73.9l140.5-140.6L410.7 690c3.1 3.1 8.2 3.1 11.3 0l42.4-42.5 187.1-187.2 58.9 58.9c3.1 3.1 8.2 3.1 11.3 0l42.4-42.5c3.1-3.1 3.1-8.2 0-11.3L661.9 363.1c-0.1-0.1-0.2-0.1-0.2-0.2l-4.5-4.5c-3.1-3.1-8.2-3.1-11.3 0L416.3 588.1m525.2 111.8h-132V567.8c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v132.1h-132c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h132V904c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V771.9h132c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalEllipsis extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M208 512m-72 0a72 72 0 1 0 144 0 72 72 0 1 0-144 0Z"></path>
      <path d="M512 512m-72 0a72 72 0 1 0 144 0 72 72 0 1 0-144 0Z"></path>
      <path d="M816 512m-72 0a72 72 0 1 0 144 0 72 72 0 1 0-144 0Z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalMore extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M512 208m-72 0a72 72 0 1 0 144 0 72 72 0 1 0-144 0Z"></path>
      <path d="M512 512m-72 0a72 72 0 1 0 144 0 72 72 0 1 0-144 0Z"></path>
      <path d="M512 816m-72 0a72 72 0 1 0 144 0 72 72 0 1 0-144 0Z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalEye extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3-7.7 16.2-7.7 35.2 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258s279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766z"></path>
      <path d="M508 336c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176z m0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalEyeClose extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M942.3 486.4l-0.1-0.1-0.1-0.1c-36.4-76.7-80-138.7-130.7-186L760.7 351c43.7 40.2 81.5 93.7 114.1 160.9C791.5 684.2 673.4 766 512 766c-51.3 0-98.3-8.3-141.2-25.1l-54.7 54.7C374.6 823.8 439.8 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0.1-51.3z m-64-332.2l-42.4-42.4c-3.1-3.1-8.2-3.1-11.3 0L707.8 228.5C649.4 200.2 584.2 186 512 186c-192.2 0-335.4 100.5-430.2 300.3v0.1c-7.7 16.2-7.7 35.2 0 51.5 36.4 76.7 80 138.7 130.7 186.1L111.8 824.5c-3.1 3.1-3.1 8.2 0 11.3l42.4 42.4c3.1 3.1 8.2 3.1 11.3 0l712.8-712.8c3.1-3 3.1-8.1 0-11.2zM398.9 537.4c-1.9-8.2-2.9-16.7-2.9-25.4 0-61.9 50.1-112 112-112 8.7 0 17.3 1 25.4 2.9L398.9 537.4z m184.5-184.5C560.5 342.1 535 336 508 336c-97.2 0-176 78.8-176 176 0 27 6.1 52.5 16.9 75.4L263.3 673c-43.7-40.2-81.5-93.7-114.1-160.9C232.6 339.8 350.7 258 512 258c51.3 0 98.3 8.3 141.2 25.1l-69.8 69.8z"></path>
      <path d="M508 624c-6.4 0-12.7-0.5-18.8-1.6l-51.1 51.1c21.4 9.3 45.1 14.4 69.9 14.4 97.2 0 176-78.8 176-176 0-24.8-5.1-48.5-14.4-69.9l-51.1 51.1c1 6.1 1.6 12.4 1.6 18.8C620 573.9 569.9 624 508 624z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalTreaty extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M832.3 622.3H548v-65.5c99.5-17.1 175.1-103.7 175.1-208.1 0-116.6-94.5-211.1-211.1-211.1s-211.1 94.5-211.1 211.1c0 104.3 75.7 191 175.1 208.1v65.5H191.7c-16.1 0-29.5 11.9-31.7 27.4v204.6c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V649.8c-2.2-15.5-15.6-27.5-31.7-27.5zM416.8 444c-25.4-25.5-39.4-59.2-39.4-95.2s14.1-69.7 39.4-95.2c25.5-25.5 59.2-39.4 95.2-39.4s69.7 13.9 95.2 39.4 39.4 59.3 39.4 95.2-13.9 69.7-39.4 95.2c-25.5 25.4-59.2 39.4-95.2 39.4-35.9 0-69.7-14.1-95.2-39.4z m375.5 370.3H231.7v-120h560.6v120z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalShare extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M752 664c-28.5 0-54.8 10-75.4 26.7L469.4 540.8c1.7-9.3 2.6-19 2.6-28.8s-0.9-19.4-2.6-28.8l207.2-149.9C697.2 350 723.5 360 752 360c66.2 0 120-53.8 120-120s-53.8-120-120-120-120 53.8-120 120c0 11.6 1.6 22.7 4.7 33.3L439.9 415.8C410.7 377.1 364.3 352 312 352c-88.4 0-160 71.6-160 160s71.6 160 160 160c52.3 0 98.7-25.1 127.9-63.8l196.8 142.5c-3.1 10.6-4.7 21.8-4.7 33.3 0 66.2 53.8 120 120 120s120-53.8 120-120-53.8-120-120-120z m0-476c28.7 0 52 23.3 52 52s-23.3 52-52 52-52-23.3-52-52 23.3-52 52-52zM312 600c-48.5 0-88-39.5-88-88s39.5-88 88-88 88 39.5 88 88-39.5 88-88 88z m440 236c-28.7 0-52-23.3-52-52s23.3-52 52-52 52 23.3 52 52-23.3 52-52 52z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalFileEdit extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M320.3 711.6v48c0 4.4 3.4 8 7.7 8h368.1c4.2 0 7.7-3.6 7.7-8v-48c0-4.4-3.4-8-7.7-8H328c-4.2 0-7.7 3.6-7.7 8z m590.3-604.3l-42.4-42.4c-3.1-3.1-8.2-3.1-11.3 0L515 407.1c-3.1 3.1-3.1 8.2 0 11.3l42.4 42.4c3.1 3.1 8.2 3.1 11.3 0l341.9-342.2c3.1-3.1 3.1-8.1 0-11.3zM504.4 575.6H328c-4.2 0-7.7 3.6-7.7 8v48c0 4.4 3.4 8 7.7 8h176.4c4.2 0 7.7-3.6 7.7-8v-48c0-4.4-3.5-8-7.7-8z"></path>
      <path d="M856.3 487.6h-55.9c-4.4 0-8 3.6-8 8v368H232.9v-704h319.7c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H192.9c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h639.4c17.7 0 32-14.3 32-32v-408c0-4.4-3.6-8-8-8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalPlusCircleFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalPlayCircleFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m144.1 454.9L437.7 677.8c-1.4 1-3 1.5-4.7 1.5-4.4 0-8-3.6-8-8V353.7c0-1.7 0.5-3.3 1.5-4.7 2.6-3.6 7.6-4.4 11.2-1.8L656.1 506c0.7 0.5 1.3 1.1 1.8 1.8 2.6 3.5 1.8 8.5-1.8 11.1z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalPauseCircleFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m-80 600c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304z m224 0c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalTimeCircleFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m176.5 585.7l-28.6 39c-2.6 3.6-7.6 4.3-11.2 1.7L483.3 569.8c-2.1-1.5-3.3-3.9-3.3-6.5V288c0-4.4 3.6-8 8-8h48.1c4.4 0 8 3.6 8 8v247.5l142.6 103.1c3.6 2.5 4.4 7.5 1.8 11.1z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalCheckSquareFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM695.5 365.7l-210.6 292c-12.7 17.7-39 17.7-51.7 0L308.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H689c6.5 0 10.3 7.4 6.5 12.7z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalLikeFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 0 0-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4-20.5-21.5-48.1-33.4-77.9-33.4-52 0-98 35-111.8 85.1l-85.9 311h-0.3v428h472.3c9.2 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7-0.2-12.6-2-25.1-5.6-37.1zM112 528v364c0 17.7 14.3 32 32 32h65V496h-65c-17.7 0-32 14.3-32 32z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalUnlikeFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M885.9 490.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4-8.3-3.6-17.2-5.4-26.5-5.4H273v428h0.3l85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zM112 132v364c0 17.7 14.3 32 32 32h65V100h-65c-17.7 0-32 14.3-32 32z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalHeartFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M923 283.6c-13.4-31.1-32.6-58.9-56.9-82.8-24.3-23.8-52.5-42.4-84-55.5-32.5-13.5-66.9-20.3-102.4-20.3-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5-24.4 23.9-43.5 51.7-56.9 82.8-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3 0.1-35.3-7-69.6-20.9-101.9z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalSettingFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M512.5 390.6c-29.9 0-57.9 11.6-79.1 32.8-21.1 21.2-32.8 49.2-32.8 79.1 0 29.9 11.7 57.9 32.8 79.1 21.2 21.1 49.2 32.8 79.1 32.8 29.9 0 57.9-11.7 79.1-32.8 21.1-21.2 32.8-49.2 32.8-79.1s-11.7-57.9-32.8-79.1c-21.2-21.2-49.2-32.8-79.1-32.8z"></path>
      <path d="M924.8 626.1l-65.4-55.9c3.1-19 4.7-38.4 4.7-57.7s-1.6-38.8-4.7-57.7l65.4-55.9c10.1-8.6 13.8-22.6 9.3-35.2l-0.9-2.6c-18.1-50.4-44.8-96.8-79.6-137.7l-1.8-2.1c-8.6-10.1-22.5-13.9-35.1-9.5l-81.2 28.9c-30-24.6-63.4-44-99.6-57.5l-15.7-84.9c-2.4-13.1-12.7-23.3-25.8-25.7l-2.7-0.5c-52-9.4-106.8-9.4-158.8 0l-2.7 0.5c-13.1 2.4-23.4 12.6-25.8 25.7l-15.8 85.3c-35.9 13.6-69.1 32.9-98.9 57.3l-81.8-29.1c-12.5-4.4-26.5-0.7-35.1 9.5l-1.8 2.1c-34.8 41.1-61.5 87.4-79.6 137.7l-0.9 2.6c-4.5 12.5-0.8 26.5 9.3 35.2l66.2 56.5c-3.1 18.8-4.6 38-4.6 57 0 19.2 1.5 38.4 4.6 57l-66 56.5c-10.1 8.6-13.8 22.6-9.3 35.2l0.9 2.6c18.1 50.3 44.8 96.8 79.6 137.7l1.8 2.1c8.6 10.1 22.5 13.9 35.1 9.5l81.8-29.1c29.8 24.5 63 43.9 98.9 57.3l15.8 85.3c2.4 13.1 12.7 23.3 25.8 25.7l2.7 0.5c26.1 4.7 52.7 7.1 79.4 7.1 26.7 0 53.4-2.4 79.4-7.1l2.7-0.5c13.1-2.4 23.4-12.6 25.8-25.7l15.7-84.9c36.2-13.6 69.6-32.9 99.6-57.5l81.2 28.9c12.5 4.4 26.5 0.7 35.1-9.5l1.8-2.1c34.8-41.1 61.5-87.4 79.6-137.7l0.9-2.6c4.3-12.4 0.6-26.3-9.5-35z m-412.3 52.2c-97.1 0-175.8-78.7-175.8-175.8s78.7-175.8 175.8-175.8 175.8 78.7 175.8 175.8-78.7 175.8-175.8 175.8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalStarFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3-12.3 12.7-12.1 32.9 0.6 45.3l183.7 179.1-43.4 252.9c-1.2 6.9-0.1 14.1 3.2 20.3 8.2 15.6 27.6 21.7 43.2 13.4L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalMailFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M928 188H96c-17.7 0-32 14.3-32 32v585c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V220c0-17.7-14.3-32-32-32zM825.5 304.3L529.8 475c-11 6.4-24.7 6.4-35.7 0L198.5 304.3c-7.9-4.6-4.7-16.7 4.5-16.7h618c9.2 0.1 12.4 12.2 4.5 16.7z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalMailOpenFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M64 293.7v0z m883 15.5v-0.2l-2.2-1.3c-0.6-0.3-1.1-0.7-1.7-1L588 102l-60-34.6c-9.9-5.7-22.1-5.7-32 0L436 102 82.7 305.9C71.7 310.9 64 322 64 335v545c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V335c0-10.6-5.1-19.9-13-25.8zM529.8 532c-11 6.4-24.7 6.4-35.7 0L180.3 351.6c-5.4-3-5.4-10.8-0.1-13.9l313.9-180.3c11-6.4 24.7-6.4 35.7 0l314.5 180.3c5.5 3 5.5 11 0 14L529.8 532z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalBulbFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M510 186.28c-161.31 0-292.09 130.71-292.09 291.96 0 118.48 70.6 220.47 172.05 266.24v69.15c0 4.42 3.58 8 8 8h224.07c4.42 0 8-3.58 8-8v-69.15c101.45-45.77 172.05-147.76 172.05-266.24 0.01-161.25-130.77-291.96-292.08-291.96zM622.03 862.44H397.97c-4.42 0-8 3.58-8 8v55.99c0 4.42 3.58 8 8 8h224.07c4.42 0 8-3.58 8-8v-55.99c0-4.42-3.59-8-8.01-8zM481.99 150.41h56.02c4.42 0 8-3.58 8-8V46.43c0-4.42-3.58-8-8-8h-56.02c-4.42 0-8 3.58-8 8v95.99c0 4.41 3.58 7.99 8 7.99zM246.97 266.22a8.015 8.015 0 0 0 11.32 0l39.61-39.59a7.985 7.985 0 0 0 0-11.31L230 147.45a8.015 8.015 0 0 0-11.32 0l-39.61 39.59c-3.12 3.12-3.12 8.19 0 11.31l67.9 67.87zM174.03 442.24H78c-4.42 0-8 3.58-8 8v55.99c0 4.42 3.58 8 8 8h96.03c4.42 0 8-3.58 8-8v-55.99c0-4.42-3.58-8-8-8zM942 442.24h-96.03c-4.42 0-8 3.58-8 8v55.99c0 4.42 3.58 8 8 8H942c4.42 0 8-3.58 8-8v-55.99c0-4.42-3.58-8-8-8zM761.71 266.22a8.015 8.015 0 0 0 11.32 0l67.9-67.87c3.12-3.12 3.12-8.19 0-11.31l-39.61-39.59c-3.12-3.12-8.19-3.12-11.32 0l-67.9 67.87a7.985 7.985 0 0 0 0 11.31l39.61 39.59z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalOrderFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M779.3 584.1H241.9c-16.1 0-25.1 17-15.1 28.6L495.4 924c7.7 8.9 22.5 8.9 30.3 0l268.7-311.3c10-11.6 1-28.6-15.1-28.6z m-537.4-144h537.4c16.1 0 25.1-17 15.1-28.6L525.7 100.2c-7.7-8.9-22.5-8.9-30.3 0L226.8 411.5c-10 11.6-1 28.6 15.1 28.6z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalFilterFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V642H349v196z m531.1-684H143.9c-24.5 0-39.8 26.7-27.5 48l221.3 376h348.8l221.3-376c12.1-21.3-3.2-48-27.7-48z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalEyeFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M396 512c0 61.9 50.1 112 112 112s112-50.1 112-112-50.1-112-112-112-112 50.1-112 112z"></path>
      <path d="M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3-7.7 16.2-7.7 35.2 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM508 688c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class DirectionLeft extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M413.39 512l305.88 267.33a8.005 8.005 0 0 1 2.74 6.02v90.63c0 6.87-8.09 10.55-13.26 6.02L312.94 536.09c-14.59-12.75-14.59-35.44 0-48.19l395.79-345.91c5.17-4.52 13.26-0.85 13.26 6.02v90.63c0 2.31-1 4.5-2.74 6.02L413.39 512z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class DirectionRight extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M610.61 512L304.74 779.33a8.005 8.005 0 0 0-2.74 6.02v90.63c0 6.87 8.09 10.55 13.26 6.02l395.79-345.91c14.59-12.75 14.59-35.44 0-48.19L315.26 141.99c-5.17-4.52-13.26-0.85-13.26 6.02v90.63c0 2.31 1 4.5 2.74 6.02L610.61 512z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class DirectionUp extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M512 413.39l267.33 305.88a8.005 8.005 0 0 0 6.02 2.74h90.63c6.87 0 10.55-8.09 6.02-13.26L536.09 312.94c-12.75-14.59-35.44-14.59-48.19 0l-345.91 395.8c-4.52 5.17-0.85 13.26 6.02 13.26h90.63c2.31 0 4.5-1 6.02-2.74L512 413.39z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class DirectionDown extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M512 610.61L244.67 304.74a8.005 8.005 0 0 0-6.02-2.74h-90.63c-6.87 0-10.55 8.09-6.02 13.26l345.91 395.79c12.75 14.59 35.44 14.59 48.19 0l345.91-395.79c4.52-5.17 0.85-13.26-6.02-13.26h-90.63c-2.31 0-4.5 1-6.02 2.74L512 610.61z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class DirectionArrowLeft extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M536.39 882.01L159.33 535.47c-13.78-12.66-13.78-34.27 0-46.94l377.05-346.54c4.92-4.52 12.61-0.85 12.61 6.02v90.63c0 2.31-0.95 4.5-2.6 6.02L296.88 474h570.11c4.42 0 8.01 3.58 8.01 8.01V542c0 4.42-3.58 8.01-8.01 8.01H296.88L546.4 779.33c1.65 1.52 2.6 3.72 2.6 6.03v90.63c0 6.87-7.69 10.54-12.61 6.02z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class DirectionArrowRight extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M487.61 882.01l377.05-346.54c13.78-12.66 13.78-34.27 0-46.94L487.61 141.99c-4.92-4.52-12.61-0.85-12.61 6.02v90.63c0 2.31 0.95 4.5 2.6 6.02L727.12 474H157.01c-4.42 0-8.01 3.58-8.01 8.01V542c0 4.42 3.58 8.01 8.01 8.01h570.11L477.6 779.33c-1.65 1.52-2.6 3.72-2.6 6.03v90.63c0 6.87 7.69 10.54 12.61 6.02z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class DirectionDoubleleft extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M272.9 512l265.4-339.1c4.1-5.2 0.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3c-9.1 11.6-9.1 27.9 0 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512z"></path>
      <path d="M576.9 512l265.4-339.1c4.1-5.2 0.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3c-9.1 11.6-9.1 27.9 0 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class DirectionDoubleright extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1c-4.1 5.2-0.4 12.9 6.3 12.9h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z"></path>
      <path d="M837.2 492.3L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1c-4.1 5.2-0.4 12.9 6.3 12.9h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class DirectionCaretLeftFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M689 165.1L308.2 493.5c-10.9 9.4-10.9 27.5 0 37L689 858.9c14.2 12.2 35 1.2 35-18.5V183.6c0-19.7-20.8-30.7-35-18.5z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class DirectionCaretRightFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M715.8 493.5L335 165.1c-14.2-12.2-35-1.2-35 18.5v656.8c0 19.7 20.8 30.7 35 18.5l380.8-328.4c10.9-9.4 10.9-27.6 0-37z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class DirectionCaretUpFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class DirectionCaretDownFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class DirectionUpFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M796.73 448.07L530.23 120.5c-9.22-11.34-27.24-11.34-36.47 0L227.27 448.07c-8.02 9.86-0.39 23.93 12.98 23.93H412v430.36c0 5.33 4.32 9.64 9.64 9.64h180.71c5.33 0 9.65-4.32 9.65-9.64V472h171.75c13.37 0 21-14.07 12.98-23.93z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class DirectionDownFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M227.27 575.93l266.5 327.57c9.22 11.34 27.24 11.34 36.47 0l266.49-327.57c8.02-9.86 0.39-23.93-12.98-23.93H612V121.64c0-5.33-4.32-9.64-9.64-9.64H421.65c-5.33 0-9.65 4.32-9.65 9.64V552H240.25c-13.37 0-21 14.07-12.98 23.93z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class DirectionPromoteFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M939.9 635.4l-69.8-495.2c-2.9-20.6-24.4-33-43.7-25.2L363 302.3c-24.7 10-27.1 44-4 57.4l155.6 89.9C484.4 509 436.3 598.8 400 644.7c-83.4 105.6-237.4 169-310.9 194.5-8.3 2.9-6.5 15.2 2.3 15.5 92.1 3.7 307.6 4 418.6-64.1 111.6-68.5 179.9-153.5 219.2-217.2l163 94.1c23.1 13.4 51.4-5.7 47.7-32.1z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class PromptCheckCircle extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8c12.7 17.7 39 17.7 51.7 0l210.6-292c3.9-5.3 0.1-12.7-6.4-12.7z"></path>
      <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class PromptCloseCircle extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M685.4 354.8c0-4.4-3.6-8-8-8l-66 0.3L512 465.6l-99.3-118.4-66.1-0.3c-4.4 0-8 3.5-8 8 0 1.9 0.7 3.7 1.9 5.2l130.1 155L340.5 670c-1.2 1.5-1.9 3.3-1.9 5.2 0 4.4 3.6 8 8 8l66.1-0.3L512 564.4l99.3 118.4 66 0.3c4.4 0 8-3.5 8-8 0-1.9-0.7-3.7-1.9-5.2L553.5 515l130.1-155c1.2-1.4 1.8-3.3 1.8-5.2z"></path>
      <path d="M512 65C264.6 65 64 265.6 64 513s200.6 448 448 448 448-200.6 448-448S759.4 65 512 65z m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class PromptInfoCircle extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path>
      <path d="M464 336c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48zM536 448h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class PromptQuestionCircle extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path>
      <path d="M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7c0-19.7 12.4-37.7 30.9-44.8 59-22.7 97.1-74.7 97.1-132.5 0.1-39.3-17.1-76-48.3-103.3zM472 732c0 22.1 17.9 40 40 40s40-17.9 40-40-17.9-40-40-40-40 17.9-40 40z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class PromptWarningCircle extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path>
      <path d="M464 688c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48zM488 576h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class PromptCheckCircleFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m193.5 301.7l-210.6 292c-12.7 17.7-39 17.7-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class PromptCloseCircleFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m165.4 618.2l-66-0.3L512 563.4l-99.3 118.4-66.1 0.3c-4.4 0-8-3.5-8-8 0-1.9 0.7-3.7 1.9-5.2l130.1-155L340.5 359c-1.2-1.5-1.9-3.3-1.9-5.2 0-4.4 3.6-8 8-8l66.1 0.3L512 464.6l99.3-118.4 66-0.3c4.4 0 8 3.5 8 8 0 1.9-0.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class PromptWarningCircleFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296z m32 440c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class PromptQuestionCircleFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m0 708c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z m62.9-219.5c-18.5 7.1-30.9 25.1-30.9 44.8V620c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-21.5c0-23.1 6.7-45.9 19.9-64.9 12.9-18.6 30.9-32.8 52.1-40.9 34-13.1 56-41.6 56-72.7 0-44.1-43.1-80-96-80s-96 35.9-96 80v7.6c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V420c0-39.3 17.2-76 48.4-103.3C430.4 290.4 470 276 512 276s81.6 14.5 111.6 40.7C654.8 344 672 380.7 672 420c0 57.8-38.1 109.8-97.1 132.5z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class PromptInfoCircleFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272z m-32-344c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class FileImageLibrary extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M321 603c48.6 0 88-39.4 88-88s-39.4-88-88-88-88 39.4-88 88 39.4 88 88 88z m0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z"></path>
      <path d="M925 313.5h-13V207.6c0-18.3-14.3-33.1-32-33.1H521l-117.3-60.2c-1.5-1.4-3.5-2.3-5.5-2.3H144c-17.7 0-32 14.8-32 33.1v168.4H98.9c-18.8 0-33.5 16.1-31.9 34.8l42.3 535c1.5 16.5 15.3 29.2 31.9 29.2h300l0.3 0.3 0.3-0.3h440.8c16.6 0 30.4-12.7 31.9-29.2l42.3-535c1.8-18.7-13-34.8-31.8-34.8z m-741-127h188.5L492.1 249H840v64.5H184v-127z m18.4 654l89.1-105.7 89.1 105.7H202.4z m643.3 0H502.6L675.1 636l170.8 202.3-0.2 2.2z m7.4-92.9L681.2 543.8c-3.2-3.8-9-3.8-12.2 0L441.6 813.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L173.1 775.8l-30.9-390.3h739.5l-28.6 362.1z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class FilePlan extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M192 426.4v56c0 4.4 3.4 8 7.7 8h624.6c4.2 0 7.7-3.6 7.7-8v-56c0-4.4-3.4-8-7.7-8H199.7c-4.3 0-7.7 3.6-7.7 8z"></path>
      <path d="M928 250.4H473L362.5 144.7c-3.1-2.9-6.8-5.2-10.8-6.7h-0.1c-3.5-1.3-7.2-1.9-11-1.9H96c-17.7 0-32 14.3-32 32v688c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V282.4c0-17.7-14.3-32-32-32zM888 816H136V208h188.5l119.6 114.4H888V816z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class FileImage extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32z m-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792z m0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2z"></path>
      <path d="M304 456c48.6 0 88-39.4 88-88s-39.4-88-88-88-88 39.4-88 88 39.4 88 88 88z m0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class FileEmpty extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326z m1.8 562H232V136h302v216c0 23.2 18.8 42 42 42h216v494z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class FileText extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326z m1.8 562H232V136h302v216c0 23.2 18.8 42 42 42h216v494z"></path>
      <path d="M504 618H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM312 490v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class FileMenu extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M320.6 312.1v-48c0-4.4 3.4-8 7.7-8h368.6c4.2 0 7.7 3.6 7.7 8v48c0 4.4-3.4 8-7.7 8H328.2c-4.2 0-7.6-3.6-7.6-8z m-0.1 128v-48c0-4.4 2.9-8 6.4-8h243.2c3.5 0 6.4 3.6 6.4 8v48c0 4.4-2.9 8-6.4 8H327c-3.6 0-6.5-3.6-6.5-8z m184.4 136H328.2c-4.2 0-7.7-3.6-7.7-8v-48c0-4.4 3.4-8 7.7-8h176.6c4.2 0 7.7 3.6 7.7 8v48c0 4.4-3.4 8-7.6 8z"></path>
      <path d="M865.3 904.1V115.5c-2.2-15.5-15.6-27.4-31.7-27.4H192.9c-16.1 0-29.5 11.9-31.7 27.4v788.6c0 17.7 14.3 32 32 32h640c17.7 0 32.1-14.4 32.1-32z m-71.7-40H233v-704h560.6v704z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class FileDone extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8z m-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296z m376 116c-119.3 0-216 96.7-216 216s96.7 216 216 216 216-96.7 216-216-96.7-216-216-216z m107.5 323.5C750.8 868.2 712.6 884 672 884s-78.8-15.8-107.5-44.5S520 772.6 520 732s15.8-78.8 44.5-107.5S631.4 580 672 580s78.8 15.8 107.5 44.5S824 691.4 824 732s-15.8 78.8-44.5 107.5z"></path>
      <path d="M761 656h-44.3c-2.6 0-5 1.2-6.5 3.3l-63.5 87.8-23.1-31.9c-1.5-2.1-3.9-3.3-6.5-3.3H573c-6.5 0-10.3 7.4-6.5 12.7l73.8 102.1c3.2 4.4 9.7 4.4 12.9 0l114.2-158c3.9-5.3 0.1-12.7-6.4-12.7z"></path>
      <path d="M440 852H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class FileQuestion extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M321 308.5h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H321c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z m184 64H321c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"></path>
      <path d="M833 76.5H193c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h300.8c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H233v-704h560v326.2c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108.5c0-17.7-14.3-32-32-32z"></path>
      <path d="M687.7 522.8c-80.3-0.9-145.9 59.7-145.9 134.8 0 7.1 5.8 12.4 12.8 12.4H597c7.1 0 12.8-5.5 12.8-12.3 0-36.9 33.8-67.5 75.9-67.5s75.9 30.6 75.9 67.4c0 33.1-27.5 61.8-64.5 66.6-25.2 3.7-45.1 26.6-45.4 52.5v41.9c0 7.2 5.9 13.1 13.1 13.1h41.9c7.2 0 13.1-5.9 13.1-13.1v-16c0-7.8 5.2-15 12.7-17.4 58.3-18.8 98.1-70.7 97.2-129.4-1.1-72.7-64.5-132-142-133zM645.7 903.7c0 22.1 17.9 40 40 40s40-17.9 40-40-17.9-40-40-40-40 17.9-40 40z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class FileAudit extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M296 250c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296z m184 144H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"></path>
      <path d="M432 852H208V148h560v320c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"></path>
      <path d="M872 764H728v-36.6c46.3-13.8 80-56.6 80-107.4 0-61.9-50.1-112-112-112s-112 50.1-112 112c0 50.7 33.7 93.6 80 107.4V764H520c-8.8 0-16 7.2-16 16v152c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16V780c0-8.8-7.2-16-16-16zM646 620c0-27.6 22.4-50 50-50s50 22.4 50 50-22.4 50-50 50-50-22.4-50-50z m180 266H566v-60h260v60z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class FileTextFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM320 482c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320z m0 136c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class FileDataFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6z m-78.2 207.2L549.1 723.2c-3.1 3.1-8.2 3.1-11.3 0L410.2 594.8 298.4 705.9c-3.2 3.1-8.2 3.1-11.3 0l-39.5-39.7c-3.1-3.1-3.1-8.2 0-11.3l157.3-156.2c3.1-3.1 8.2-3.1 11.3 0l127.4 128.2 182-181.9c3.1-3.1 8.2-3.1 11.3 0l39.6 39.6c3 3.1 3 8.2-0.1 11.3zM602 326V137.8L790.2 326H602z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MaterialEarth extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M854.4 800.9c0.2-0.3 0.5-0.6 0.7-0.9C920.6 722.1 960 621.7 960 512s-39.4-210.1-104.8-288c-0.2-0.3-0.5-0.5-0.7-0.8-1.1-1.3-2.1-2.5-3.2-3.7-0.4-0.5-0.8-0.9-1.2-1.4-1.4-1.6-2.7-3.1-4.1-4.7l-0.1-0.1c-1.5-1.7-3.1-3.4-4.6-5.1l-0.1-0.1c-3.2-3.4-6.4-6.8-9.7-10.1l-0.1-0.1-4.8-4.8-0.3-0.3c-1.5-1.5-3-2.9-4.5-4.3-0.5-0.5-1-1-1.6-1.5-1-1-2-1.9-3-2.8-0.3-0.3-0.7-0.6-1-1C736.4 109.2 629.5 64 512 64s-224.4 45.2-304.3 119.2c-0.3 0.3-0.7 0.6-1 1-1 0.9-2 1.9-3 2.9-0.5 0.5-1 1-1.6 1.5-1.5 1.4-3 2.9-4.5 4.3l-0.3 0.3-4.8 4.8-0.1 0.1c-3.3 3.3-6.5 6.7-9.7 10.1l-0.1 0.1c-1.6 1.7-3.1 3.4-4.6 5.1l-0.1 0.1c-1.4 1.5-2.8 3.1-4.1 4.7-0.4 0.5-0.8 0.9-1.2 1.4-1.1 1.2-2.1 2.5-3.2 3.7-0.2 0.3-0.5 0.5-0.7 0.8C103.4 301.9 64 402.3 64 512s39.4 210.1 104.8 288c0.2 0.3 0.5 0.6 0.7 0.9 1 1.2 2.1 2.5 3.1 3.7 0.4 0.5 0.8 0.9 1.2 1.4 1.4 1.6 2.7 3.1 4.1 4.7 0 0.1 0.1 0.1 0.1 0.2 1.5 1.7 3 3.4 4.6 5l0.1 0.1c3.2 3.4 6.4 6.8 9.6 10.1l0.1 0.1c1.6 1.6 3.1 3.2 4.7 4.7l0.3 0.3c3.3 3.3 6.7 6.5 10.1 9.6 80.1 74 187 119.2 304.5 119.2s224.4-45.2 304.3-119.2c3.4-3.1 6.7-6.3 10-9.6l0.3-0.3c1.6-1.6 3.2-3.1 4.7-4.7l0.1-0.1c3.3-3.3 6.5-6.7 9.6-10.1l0.1-0.1c1.5-1.7 3.1-3.3 4.6-5 0-0.1 0.1-0.1 0.1-0.2 1.4-1.5 2.8-3.1 4.1-4.7 0.4-0.5 0.8-0.9 1.2-1.4 1.2-1.3 2.3-2.5 3.3-3.7z m4.1-142.6c-13.8 32.6-32 62.8-54.2 90.2-24.9-21.5-52.2-40.3-81.5-55.9 11.6-46.9 18.8-98.4 20.7-152.6H887c-3 40.9-12.6 80.6-28.5 118.3zM887 484H743.5c-1.9-54.2-9.1-105.7-20.7-152.6 29.3-15.6 56.6-34.4 81.5-55.9 22.2 27.4 40.4 57.6 54.2 90.2C874.4 403.4 884 443.1 887 484zM658.3 165.5c39.7 16.8 75.8 40 107.6 69.2-18.5 15.8-38.4 29.7-59.4 41.8-15.7-45-35.8-84.1-59.2-115.4 3.7 1.4 7.4 2.9 11 4.4z m-90.6 700.6c-9.2 7.2-18.4 12.7-27.7 16.4V697c39.9 2.8 78.6 11.6 115.7 26.2-8.3 24.6-17.9 47.3-29 67.8-17.4 32.4-37.8 58.3-59 75.1z m59-633.1c11 20.6 20.7 43.3 29 67.8-37.1 14.6-75.8 23.4-115.7 26.2V141.6c9.2 3.7 18.5 9.1 27.7 16.4 21.2 16.7 41.6 42.6 59 75zM540 640.9V540h147.5c-1.6 44.2-7.1 87.1-16.3 127.8l-0.3 1.2c-41.1-15.6-85.1-25.3-130.9-28.1z m0-156.9V383.1c45.8-2.8 89.8-12.5 130.9-28.1l0.3 1.2c9.2 40.7 14.7 83.5 16.3 127.8H540z m-56 56v100.9c-45.8 2.8-89.8 12.5-130.9 28.1l-0.3-1.2c-9.2-40.7-14.7-83.5-16.3-127.8H484z m-147.5-56c1.6-44.2 7.1-87.1 16.3-127.8l0.3-1.2c41.1 15.6 85 25.3 130.9 28.1V484H336.5zM484 697v185.4c-9.2-3.7-18.5-9.1-27.7-16.4-21.2-16.7-41.7-42.7-59.1-75.1-11-20.6-20.7-43.3-29-67.8 37.2-14.6 75.9-23.3 115.8-26.1z m0-370c-39.9-2.8-78.6-11.6-115.7-26.2 8.3-24.6 17.9-47.3 29-67.8 17.4-32.4 37.8-58.4 59.1-75.1 9.2-7.2 18.4-12.7 27.7-16.4V327h-0.1zM365.7 165.5c3.7-1.5 7.3-3 11-4.4-23.4 31.3-43.5 70.4-59.2 115.4-21-12-40.9-26-59.4-41.8 31.8-29.2 67.9-52.4 107.6-69.2zM165.5 365.7c13.8-32.6 32-62.8 54.2-90.2 24.9 21.5 52.2 40.3 81.5 55.9-11.6 46.9-18.8 98.4-20.7 152.6H137c3-40.9 12.6-80.6 28.5-118.3zM137 540h143.5c1.9 54.2 9.1 105.7 20.7 152.6-29.3 15.6-56.6 34.4-81.5 55.9-22.2-27.4-40.4-57.6-54.2-90.2C149.6 620.6 140 580.9 137 540z m228.7 318.5c-39.7-16.8-75.8-40-107.6-69.2 18.5-15.8 38.4-29.7 59.4-41.8 15.7 45 35.8 84.1 59.2 115.4-3.7-1.4-7.4-2.9-11-4.4z m292.6 0c-3.7 1.5-7.3 3-11 4.4 23.4-31.3 43.5-70.4 59.2-115.4 21 12 40.9 26 59.4 41.8-31.8 29.2-67.9 52.4-107.6 69.2z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MaterialBook extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32z m-307.9 72h124v209.9L633.8 360 572 395.4l0.1-211.4zM840 840H184V184h324.1v296.9c0 3.3 1 6.6 3 9.3 5.1 7.2 15.1 8.9 22.3 3.7l100-59.9 97.2 59.4c2.7 2 10 3.1 13.4 3.1 8.8 0 16-7.2 16-16V184h80v656z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MaterialShopping extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M880 320H712v-56c0-110.46-89.54-200-200-200s-200 89.54-200 200v56H144a32 32 0 0 0-32 32v536a32 32 0 0 0 32 32h736a32 32 0 0 0 32-32V352a32 32 0 0 0-32-32z m-496-56a128 128 0 0 1 256 0v56H384z m456 584H184V392h128v112a8 8 0 0 0 8 8h56a8 8 0 0 0 8-8V392h256v112a8 8 0 0 0 8 8h56a8 8 0 0 0 8-8V392h128z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MaterialUnit extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M880 112H648.4c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8H840v656H184V184h191.6c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32z"></path>
      <path d="M512 423.7c-90.5 0-164.7-71.1-169.7-160.4-0.2-4.2-3.8-7.5-8-7.5h-60.1c-4.6 0-8.2 3.8-8 8.4C268.8 326 294 383.7 338 427.7c46.5 46.5 108.2 72 173.9 72 65 0 127.2-25.6 173.4-71.5 44.3-44 69.8-102 72.4-164 0.2-4.6-3.4-8.4-8-8.4h-60.1c-4.2 0-7.7 3.3-8 7.5-4.9 89.3-79.1 160.4-169.6 160.4z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MaterialShop extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7c0 24.4 4.8 48.1 14.4 70.4 4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h676c17.7 0 32-14.3 32-32V535c6.1-9.1 11.3-18.8 15.6-28.9 9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zM214 184h596v88H214v-88z m362 656.1H448V736h128v104.1z m234 0H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1 0.2-0.1 0.4-0.1 0.6 0 11.9 8.9 24.8 16.3 38.7 22.1 22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1 0.2-0.1 0.4-0.1 0.6 0 11.9 8.9 24.8 16.3 38.7 22.1 22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c3-1.3 6-2.6 9-4v242.2h-0.4z m30-404.4c0 59.8-49 108.3-109.3 108.3-40.8 0-76.4-22.1-95.2-54.9-2.9-5-8.1-8.1-13.9-8.1h-0.6c-5.7 0-11 3.1-13.9 8.1-18.7 32.8-54.3 54.9-95.1 54.9-40.7 0-76.2-22-95-54.7-3-5.1-8.4-8.3-14.3-8.3s-11.4 3.2-14.3 8.3C369.5 522 334 544 293.3 544 233 544 184 495.5 184 435.7v-91.2c0-0.3 0.2-0.5 0.5-0.5h655c0.3 0 0.5 0.2 0.5 0.5v91.2z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MaterialGift extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M880 310H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v200c0 4.4 3.6 8 8 8h40v344c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V550h40c4.4 0 8-3.6 8-8V342c0-17.7-14.3-32-32-32z m-334-74c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70h-70v-70z m-138-70c38.6 0 70 31.4 70 70v70h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70zM180 482V378h298v104H180z m48 68h250v308H228V550z m568 308H546V550h250v308z m48-376H546V378h298v104z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MaterialBrand extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M971.1 432.7L745.8 112.3c-1.3-1.7-3.4-2.7-5.5-2.7H283.8c-2.1 0-4.2 1-5.5 2.7L52.9 432.7c-2.1 2.7-2.1 6.5 0.2 9.2L506.7 952c1.3 1.5 3.3 2.3 5.3 2.3s3.9-0.9 5.3-2.3l453.6-510.1c2.3-2.6 2.3-6.5 0.2-9.2zM423.5 190h174.4l82.4 220.2H344.7L423.5 190z m-110.8 0h52.7l-80 220.3H152.6L312.7 190zM158.2 465.8h128.5l135.2 296.5-263.7-296.5z m354.7 364.6l-164-364.6h330.3L512.9 830.4z m94.6-73.3l131.9-291.3h127.1l-259 291.3z m263.3-346.9H738.4L655.9 190h55.4l159.5 220.2z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MaterialService extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M877 417.5h-28.5c-1.4-41.4-10.2-81.6-26.3-119.7-17-40.1-41.2-76.1-72.2-107-30.9-30.9-66.9-55.2-107-72.2-41.5-17.6-85.6-26.5-131-26.5s-89.5 8.9-131.1 26.5c-40.1 17-76.1 41.2-107 72.2s-55.2 66.9-72.1 107c-16.1 38.1-24.9 78.3-26.3 119.7H147c-28.7 0-52 23.3-52 52v208c0 28.7 23.3 52 52 52h128c28.7 0 52-23.3 52-52v-208c0-28.7-23.3-52-52-52h-23.5c2.8-65.4 29.6-126.4 76.1-173 49.2-49.2 114.7-76.4 184.4-76.4s135.1 27.1 184.4 76.4c46.6 46.6 73.3 107.6 76.1 173H749c-28.7 0-52 23.3-52 52v208c0 28.7 23.3 52 52 52h21.2c-19.1 59.4-70 104.7-132.5 115.6-1.9-11.5-5.6-22.6-11-32.9-18.7-35.9-56.2-60.5-99.4-60.5-22.7 0-43.8 6.8-61.5 18.4-22.8 14.9-39.7 37.9-46.9 64.7-2.5 9.2-3.8 18.9-3.8 28.9 0 61.8 50.2 112 112 112 39.9 0 74.9-21 94.8-52.4 60-3.3 116.8-28.5 159.7-71.1 34.3-34.1 57.3-76.5 67.2-122.7H877c28.7 0 52-23.3 52-52v-208c0-28.7-23.4-52-52-52z m-622 72v168h-88v-168h88z m289.2 419c-4.1 1.6-8.4 2.6-12.8 3-1.4 0.1-2.8 0.2-4.3 0.2-15.4 0-29.1-7.3-37.9-18.6-6.3-8.1-10.1-18.3-10.1-29.4 0-21.3 14-39.4 33.3-45.7 4.7-1.5 9.6-2.3 14.7-2.3 14.5 0 27.5 6.5 36.4 16.7 2.9 3.3 5.3 7 7.2 11.1 2.9 6.2 4.5 13 4.5 20.2 0 20.4-12.9 37.9-31 44.8zM853 670.1l0.1-0.9-0.1 0.9z m0.5-5.6c0-0.5 0.1-0.9 0.1-1.4-0.1 0.5-0.1 0.9-0.1 1.4z m3.5-7h-88v-168h88v168z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MaterialBell extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M816 768h-24V428c0-141.1-104.3-257.7-240-277.1V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.9c-135.7 19.4-240 136-240 277.1v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48zM304 768V428c0-55.6 21.6-107.8 60.9-147.1S456.4 220 512 220s107.8 21.6 147.1 60.9S720 372.4 720 428v340H304z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MaterialPlan extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M910.2 64.4c-7.1-0.5-13.8 1.5-19.3 5.2-1.2 0.3-2.4 0.7-3.6 1.3L107.4 431c-0.2 0.1-0.3 0.1-0.4 0.2-11.6 5.4-20.1 16.8-21.1 30.4-1 13.3 5.3 25.4 15.5 32.6 1.1 1 2.4 1.9 3.7 2.7l289.1 161.7v267c0 0.7 0.1 1.4 0.1 2.1-0.1 0.9-0.1 1.9-0.1 2.8 0 16.4 13.3 29.7 29.7 29.7 10.5 0 19.8-5.5 25-13.8l145.2-175.9L795 882.8c0.8 0.5 1.7 1 2.6 1.4l4.1 2.3c1.2 0.7 2.5 0.7 3.6 0.3 1.2 0.2 2.4 0.4 3.6 0.5 16.4 1.2 30.8-10.8 32.5-27.1 0-0.1 0-0.2 0.1-0.4l96.3-761.1c0.1-0.6 0.2-1.3 0.2-1.9 1.3-16.6-11.2-31.1-27.8-32.4z m-419 561.4l354.4-403.1-71.1 561.5-283.3-158.4zM208.9 467.9l538.7-248.8-324.2 368.7-214.5-119.9z m261.3 333.3V701.1l56.5 31.6-56.5 68.5z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MaterialFlag extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32zM184 568V232h368v336H184z m656 145H504v-73h112c4.4 0 8-3.6 8-8V377h216v336z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MaterialCamera extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M928 232H728l-32.4-98.8C691 120.5 679 112 665.4 112H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 232H96c-17.7 0-32 14.3-32 32v568c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V264c0-17.7-14.3-32-32-32z m-40 560H136V304h210.7l17.1-47.8 22.9-72.2h250.5l22.9 72.2 17.1 47.8H888v488z"></path>
      <path d="M512 361.8c-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160-71.6-160-160-160z m0 256c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MaterialRocket extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1c-9.7 11.5-15.1 26.1-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8 11.3 14 26.2 24.6 43.1 30.6 23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64 16.9-6 31.8-16.5 43.1-30.5 13.8-17.2 21.4-38.8 21.4-60.8 0-8.4-1.1-16.4-3.1-23.8L864 736zM762.3 621.4c9.4 14.6 17 30.3 22.5 46.6H700V558.7c24.8 16.2 46.1 37.5 62.3 62.7zM388 483.1V318.8l124-147 124 147V668H388V483.1zM239.2 668c5.5-16.3 13.1-32 22.5-46.6 16.3-25.2 37.5-46.5 62.3-62.7V668h-84.8z m388.9 116.2c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5s-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5c-1 0.1-2.1 0.2-3.3 0.2-4.9 0-9.6-1.3-13.8-3.7-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-0.1 10.2-5.5 19.6-14.2 24.5z"></path>
      <path d="M464 400c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MaterialWrench extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M876.6 239.5c-0.5-0.9-1.2-1.8-2-2.5-5-5-13.1-5-18.1 0L684.2 409.3l-67.9-67.9L788.7 169c0.8-0.8 1.4-1.6 2-2.5 3.6-6.1 1.6-13.9-4.5-17.5-98.2-58-226.8-44.7-311.3 39.7-67 67-89.2 162-66.5 247.4l-293 293c-3 3-2.8 7.9 0.3 11l169.7 169.7c3.1 3.1 8.1 3.3 11 0.3l292.9-292.9c85.5 22.8 180.5 0.7 247.6-66.4 84.4-84.5 97.7-213.1 39.7-311.3zM786 499.8c-58.1 58.1-145.3 69.3-214.6 33.6l-8.8 8.8-0.1-0.1-274 274.1-79.2-79.2 230.1-230.1s0 0.1 0.1 0.1l52.8-52.8c-35.7-69.3-24.5-156.5 33.6-214.6 39.2-39.2 92.1-57.3 144-53.5L537 318.9c-12.5 12.5-12.5 32.8 0 45.3l124.5 124.5c12.5 12.5 32.8 12.5 45.3 0l132.8-132.8c3.7 51.8-14.4 104.8-53.6 143.9z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MaterialShoppingFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M880 312H712v-56c0-110.46-89.54-200-200-200s-200 89.54-200 200v56H144c-17.67 0-32 14.33-32 32v536c0 17.67 14.33 32 32 32h736c17.67 0 32-14.33 32-32V344c0-17.67-14.33-32-32-32zM384 496c0 4.42-3.58 8-8 8h-56c-4.42 0-8-3.58-8-8V384h72v112z m0-240c0-70.69 57.31-128 128-128s128 57.31 128 128v56H384v-56z m328 240c0 4.42-3.58 8-8 8h-56c-4.42 0-8-3.58-8-8V384h72v112z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MaterialShopFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7c0 24.4 4.8 48.1 14.4 70.4 4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h274V736h128v176h274c17.7 0 32-14.3 32-32V535c6.1-9.1 11.3-18.8 15.6-28.9 9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9z m-72 568H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1 0.2-0.1 0.4-0.1 0.6 0 11.9 8.9 24.8 16.3 38.7 22.1 22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1 0.2-0.1 0.4-0.1 0.6 0 11.9 8.9 24.8 16.3 38.7 22.1 22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c3-1.3 6-2.6 9-4v242.2h-0.4z m0-568.1H214v-88h596v88z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MaterialBellFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M816 768h-24V428c0-141.1-104.3-257.8-240-277.2V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.8C336.3 170.2 232 286.9 232 428v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MaterialRocketFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1c-9.7 11.5-15.1 26.1-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8 11.3 14 26.2 24.6 43.1 30.6 23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64 16.9-6 31.8-16.5 43.1-30.5 13.8-17.2 21.4-38.8 21.4-60.8 0-8.4-1.1-16.4-3.1-23.8L864 736zM512 352c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48z m116.1 432.2c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5s-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5c-1 0.1-2.1 0.2-3.3 0.2-4.9 0-9.6-1.3-13.8-3.7-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-0.1 10.2-5.5 19.6-14.2 24.5z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MaterialCameraFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M416 521.8c0 53 43 96 96 96s96-43 96-96-43-96-96-96-96 43-96 96z"></path>
      <path d="M928 232H728l-32.4-98.8C691 120.5 679 112 665.4 112H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 232H96c-17.7 0-32 14.3-32 32v568c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V264c0-17.7-14.3-32-32-32zM512 681.8c-88.4 0-160-71.6-160-160s71.6-160 160-160 160 71.6 160 160-71.6 160-160 160z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MaterialVideoFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM328 352c0 4.4-3.6 8-8 8H208c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h112c4.4 0 8 3.6 8 8v48z m560 273l-104-59.8V458.9L888 399v226z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MaterialSeckillFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M147.9 348c22.5-42.4 52.3-79.9 88.7-111.6 36.3-31.6 77.4-55.9 122.4-72.2-23.6-28.5-58.4-47.7-98.2-50.4-77.1-5.4-144 52.8-149.4 130-2.7 39.7 11.5 76.8 36.5 104.2z m727.2 1.4c25.4-26.8 40.3-63.6 38.3-103.4-3.9-77.2-69.7-136.7-146.9-132.8-39.8 2-74.9 20.5-99 48.5 44.7 17.2 85.4 42.3 121.2 74.6 35.6 32.3 64.7 70.3 86.4 113.1zM512 207.4c-198.8 0-360 161.2-360 360s161.2 360 360 360 360-161.2 360-360-161.2-360-360-360z m162.1 451l-28.6 39c-2.6 3.6-7.6 4.3-11.2 1.7L483.4 589.3c-2.1-1.5-3.3-3.9-3.3-6.5l-0.2-195.3c0-4.4 3.6-8 8-8H536c4.4 0 8 3.6 8 8l0.2 167.5 128.1 92.4c3.6 2.4 4.4 7.4 1.8 11z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandMagic extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M658.5 351.6v-276h-48.2C508 84.2 420.5 144.5 373.7 230.2 327 144.5 239.4 84.3 137.2 75.6H88.9v595.2H338V947h298.2c164.7 0 298.2-133.5 298.2-298.2-0.1-157-121.6-285.8-275.9-297.2zM410 422.8h176.6v176.1H410V422.8z m59.6-203.6c31.5-34.1 72.3-57.5 117-67.4v198.9H410.7c4.7-48.9 25.2-95 58.9-131.5zM160.9 598.8v-447c44.7 9.9 85.5 33.2 117 67.4 36.5 39.5 57.5 90.1 59.8 143.6-0.1 3.3-0.2 6.6-0.2 9.9v226.1H160.9z m635.1 210c-42.7 42.7-99.5 66.2-159.9 66.2H410V670.8h248.5v-247c51.9 5.1 100.1 27.7 137.5 65.1 42.7 42.7 66.2 99.5 66.2 159.9S838.7 766 796 808.8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandSmart extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M166.3 464.3c16.7-21.3 40.1-42.8 66.1-49.7l41.9-5.9 13.9-42.6c8.6-22.8 14.6-42.1 29.7-61.4 14.9-19.2 34.6-41.9 54.4-55.9 41.1-28.9 89.5-46.2 140-46.2s98.9 15.3 140 44.2c17.8 12.5 33.8 27.3 47.7 44.1 0.1 0.1 0.2 0.2 0.2 0.3l0.1 0.1c1.5 1.6 3.6 4.6 5.9 4.6 2.2 0 4.2-2.9 5.7-4.4h0.1l42.5-42.5v-0.1c1.5-1.5 2.3-3.5 2.3-5.6 0-2.2-0.9-4.3-2.4-5.7l0.3 0.4-1.7-2c-58.6-67-144.7-109.4-240.7-109.4-136.7 0-249.4 97.8-295.1 218.6-85.7 22.5-153 118.6-153 211.4 0 110.5 89.5 210 199.9 210h40.1c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H264c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-66.8-34.9-100.6 0.9-26.3 9.9-67.1 26.2-88z"></path>
      <path d="M595 684c35.3 0 64-28.7 64-64s-28.7-64-64-64c-23.7 0-44.3 12.9-55.4 32h-74.1c-11.1-19.1-31.7-32-55.4-32-35.4 0-64 28.7-64 64s28.6 64 64 64c23.7 0 44.4-12.9 55.4-32h74.1c11.1 19.1 31.8 32 55.4 32z m166.7-118.6h-0.2 0.2zM645.1 371.8h-77.8c-11.1-18.9-31.7-31.5-55.1-31.5-35.4 0-64 28.6-64 64s28.6 64 64 64c23.9 0 44.7-13.1 55.7-32.5h57.4l125.1 125.1c3 3 7 4.7 11.2 4.8h78.9c11.1 19.1 31.7 32 55.4 32 35.3 0 64-28.7 64-64s-28.7-64-64-64c-23.7 0-44.3 12.9-55.4 32h-58.9L656.5 376.6c-2.9-3-6.9-4.8-11.4-4.8z m1.4 475.4h-0.2 0.2zM895.9 641.8c-23.5 0-44 12.7-55.1 31.5H763c-4.4 0-8.4 1.8-11.3 4.7L626.5 803.2h-58.9c-11.1-19.1-31.7-32-55.4-32-35.4 0-64 28.7-64 64s28.6 64 64 64c23.7 0 44.3-12.9 55.4-32h78.9c4.4 0 8.4-1.8 11.2-4.8l125.1-125.1h57.4c11 19.4 31.8 32.5 55.7 32.5 35.3 0 64-28.7 64-64s-28.6-64-64-64z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandTrademark extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path>
      <path d="M599.5 549.3c34.8-12.8 78.4-49 78.4-119.2 0-71.2-45.5-131.1-144.2-131.1H378c-4.4 0-8 3.6-8 8v410c0 4.4 3.6 8 8 8h54.5c4.4 0 8-3.6 8-8V561.2h88.7l74.6 159.2c1.3 2.8 4.1 4.6 7.2 4.6h62c1.2 0 2.4-0.3 3.5-0.8 4-2 5.6-6.7 3.6-10.7l-80.6-164.2zM522 505h-81.5V357h83.4c48 0 80.9 25.3 80.9 75.5 0 46.9-29.8 72.5-82.8 72.5z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MoneyYuan extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path>
      <path d="M671.6 299h-59.5c-3 0-5.8 1.7-7.1 4.4l-90.6 180H511l-90.6-180c-1.4-2.7-4.1-4.4-7.1-4.4h-60.7c-1.3 0-2.6 0.3-3.8 1-3.9 2.1-5.3 7-3.2 10.9L457 515.7h-61.4c-4.4 0-8 3.6-8 8v29.9c0 4.4 3.6 8 8 8h81.7V603h-81.7c-4.4 0-8 3.6-8 8v29.9c0 4.4 3.6 8 8 8h81.7V717c0 4.4 3.6 8 8 8h54.3c4.4 0 8-3.6 8-8v-68.1h82c4.4 0 8-3.6 8-8V611c0-4.4-3.6-8-8-8h-82v-41.5h82c4.4 0 8-3.6 8-8v-29.9c0-4.4-3.6-8-8-8h-62l111.1-204.8c0.6-1.2 1-2.5 1-3.8-0.1-4.4-3.7-8-8.1-8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MoneyDollar extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path>
      <path d="M559.7 488.8l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2 0.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-0.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-0.2-31.7c78.3-6.9 134.3-48.8 134.3-124-0.1-69.4-44.2-100.4-109-116.4z m-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1 0.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MoneyTransaction extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M668.6 320c0-4.4-3.6-8-8-8h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8c-1.4-2.7-4.1-4.4-7.1-4.4h-55.7c-1.3 0-2.6 0.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c0.5-1.1 0.9-2.4 0.9-3.7z"></path>
      <path d="M157.9 504.2c1-45.1 10.3-88.7 27.7-129.9 17.8-42.1 43.3-80 75.8-112.5s70.3-58.1 112.4-75.9c43.6-18.4 89.9-27.8 137.6-27.8 47.8 0 94.1 9.3 137.6 27.8 42.1 17.8 79.9 43.4 112.4 75.9 10 10 19.3 20.5 27.9 31.4l-50 39.1c-5.3 4.1-3.5 12.5 3 14.1l156.8 38.3c5 1.2 9.9-2.6 9.9-7.7l0.8-161.5c0-6.7-7.7-10.5-12.9-6.3l-47.8 37.4C770.7 146.3 648.6 82 511.5 82 277 82 86.3 270.1 82 503.8c-0.1 4.5 3.5 8.2 8 8.2h60c4.3 0 7.8-3.5 7.9-7.8zM934 512h-60c-4.3 0-7.9 3.5-8 7.8-1 45.1-10.3 88.7-27.7 129.9-17.8 42.1-43.3 80-75.8 112.5s-70.3 58.1-112.4 75.9c-43.6 18.4-89.9 27.8-137.6 27.8s-94.1-9.3-137.6-27.8c-42.1-17.8-79.9-43.4-112.4-75.9-10-10-19.3-20.5-27.9-31.4l49.9-39.1c5.3-4.1 3.5-12.5-3-14.1l-156.8-38.3c-5-1.2-9.9 2.6-9.9 7.7l-0.8 161.7c0 6.7 7.7 10.5 12.9 6.3l47.8-37.4C253.3 877.7 375.4 942 512.5 942 747 942 937.7 753.9 942 520.2c0.1-4.5-3.5-8.2-8-8.2z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MoneyCollect extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M911.5 700.7c-1.5-4.2-6.1-6.3-10.3-4.8L840 718.2V180c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-0.9-0.3-1.8-0.5-2.7-0.5-4.4 0-8 3.6-8 8V763c0 3.3 2.1 6.3 5.3 7.5L501 910.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-0.2-1.9-0.5-2.8zM512 837.5l-256-93.1V184h512v560.4l-256 93.1z"></path>
      <path d="M660.6 312h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8c-1.4-2.7-4.1-4.4-7.1-4.4h-55.7c-1.3 0-2.6 0.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c0.6-1.2 1-2.5 1-3.8-0.1-4.3-3.7-7.9-8.1-7.9z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MoneyCash extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M928 159.7H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32v-640c0-17.7-14.3-32-32-32z m-40 632H136v-560h752v560z"></path>
      <path d="M667.6 298.7h-59.5c-3 0-5.8 1.7-7.1 4.4l-90.6 180H507l-90.6-180c-1.4-2.7-4.1-4.4-7.1-4.4h-60.7c-1.3 0-2.6 0.3-3.8 1-3.9 2.1-5.3 7-3.2 10.9L453 515.4h-61.4c-4.4 0-8 3.6-8 8v29.9c0 4.4 3.6 8 8 8h81.7v41.4h-81.7c-4.4 0-8 3.6-8 8v29.9c0 4.4 3.6 8 8 8h81.7v68.1c0 4.4 3.6 8 8 8h54.3c4.4 0 8-3.6 8-8v-68.1h82c4.4 0 8-3.6 8-8v-29.9c0-4.4-3.6-8-8-8h-82v-41.5h82c4.4 0 8-3.6 8-8v-29.9c0-4.4-3.6-8-8-8h-62l111.1-204.8c0.6-1.2 1-2.5 1-3.8-0.1-4.4-3.7-8-8.1-8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MoneyCreditCard extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32z m-792 72h752v120H136V232z m752 560H136V440h752v352z"></path>
      <path d="M651 728h165c4.4 0 8-3.6 8-8v-72c0-4.4-3.6-8-8-8H651c-4.4 0-8 3.6-8 8v72c0 4.4 3.6 8 8 8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MoneyRedEnvelope extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M440.6 462.6c-1.4-2.8-4.3-4.6-7.5-4.6h-48.8c-1.3 0-2.6 0.4-3.9 1-4.1 2.2-5.6 7.3-3.4 11.4l87.4 161.1h-45.4c-4.6 0-8.4 3.8-8.4 8.4v25.1c0 4.6 3.8 8.4 8.4 8.4h63v28.6h-63c-4.6 0-8.4 3.8-8.4 8.4v25.1c0 4.6 3.8 8.4 8.4 8.4h63v49.9c0 4.6 3.8 8.4 8.4 8.4h43.7c4.6 0 8.4-3.8 8.4-8.4v-49.9h63.3c4.7 0 8.4-3.8 8.2-8.5v-25c0-4.6-3.8-8.4-8.4-8.4h-63.3v-28.6h63.3c4.6 0 8.4-3.8 8.4-8.4v-25.1c0-4.6-3.8-8.4-8.4-8.4h-45.9l87.2-161c0.7-1.2 1-2.6 1-4 0-4.6-3.8-8.4-8.4-8.4h-47.8c-3.1 0-6 1.8-7.5 4.6l-71.9 141.9-71.7-142z"></path>
      <path d="M832 64h-640c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32v-832c0-17.7-14.3-32-32-32z m-40 824h-560v-694.9l260.3 204.1c11.6 9.1 27.9 9.1 39.5 0l260.2-204.1v694.9z m0-751.3h-31.7l-248.3 194.6-248.3-194.6h-31.7v-0.7h560v0.7z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MoneyRedEnvelopeFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M832 64h-640c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32v-832c0-17.7-14.3-32-32-32z m-185 406.4l-87.2 161h45.9c4.6 0 8.4 3.8 8.4 8.4v25.1c0 4.6-3.8 8.4-8.4 8.4h-63.3v28.6h63.3c4.6 0 8.4 3.8 8.4 8.4v25c0.2 4.6-3.6 8.5-8.2 8.5h-63.3v49.9c0 4.6-3.8 8.4-8.4 8.4h-43.7c-4.6 0-8.4-3.8-8.4-8.4v-49.9h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h63v-28.6h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h45.4l-87.5-161c-2.2-4.1-0.7-9.1 3.4-11.4 1.3-0.6 2.6-1 3.9-1h48.8c3.2 0 6.1 1.8 7.5 4.6l71.9 141.8 71.9-141.9c1.5-2.8 4.3-4.6 7.5-4.6h47.8c4.6 0 8.4 3.8 8.4 8.4-0.1 1.5-0.5 2.9-1.1 4.1z m-134.4-147.4l-223.6-175h446l-222.4 175z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MoneyTicketFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M928 188H96c-17.7 0-32 14.3-32 32v196.5c53 0 96 43 96 96s-43 96-96 96V805c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V608.5c-53 0-96-43-96-96s43-96 96-96V220c0-17.7-14.3-32-32-32zM678.5 320.8L567.4 515.6h62c4.4 0 8 3.6 8 8v29.9c0 4.4-3.6 8-8 8h-82V603h82c4.4 0 8 3.6 8 8v29.9c0 4.4-3.6 8-8 8h-82V717c0 4.4-3.6 8-8 8h-54.3c-4.4 0-8-3.6-8-8v-68.1h-81.7c-4.4 0-8-3.6-8-8V611c0-4.4 3.6-8 8-8h81.7v-41.4h-81.7c-4.4 0-8-3.6-8-8v-29.9c0-4.4 3.6-8 8-8h61.4L345.4 320.9c-2.1-3.9-0.7-8.8 3.2-10.9 1.2-0.7 2.5-1 3.8-1h60.7c3 0 5.7 1.7 7.1 4.4l90.6 170h3.4l90.6-170c1.3-2.7 4.1-4.4 7.1-4.4h59.5c4.4 0 8 3.6 8.1 8 0 1.3-0.4 2.6-1 3.8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MoneySaleFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M852 160H172c-17.7 0-32 14.3-32 32v714c0 3.9 3.9 6.6 7.5 5.3l353.7-119.6c7-2.5 14.6-2.5 21.6 0l353.7 119.6c3.7 1.3 7.5-1.4 7.5-5.3V192c0-17.7-14.3-32-32-32zM456.3 469.7c-2.5 10.7-6.3 20.7-11.3 30h0.4l-1.1 1.1c-2.5 4.3-4.9 8.2-7.2 11.7-15.9 24.2-30.6 46.7-44.2 67.6-5.9 8.9-11.7 17.9-17.5 26.9-5.8 9.1-11.3 17.5-16.4 25.3-5.2 7.8-9.8 14.8-13.8 21-4 6.2-7.1 10.8-9.1 13.8-2 2.8-4.7 4.2-7.9 4.2h-45.4l74.4-114.5c-1.5 0-3 0.1-4.5 0.2s-3 0.2-4.5 0.2c-15.4 0-29.8-2.9-43.3-8.7-13.5-5.8-25.2-13.7-35.1-23.8-10-10.1-17.8-21.9-23.6-35.3-5.8-13.5-8.7-27.8-8.7-42.9 0-15.9 3.1-30.7 9.3-44.6 6.2-13.9 14.6-25.8 25.3-35.9 10.7-10.1 23.2-17.8 37.4-23.2 14.2-5.4 29.4-7.6 45.5-6.6 13.6 0.8 26.4 3.9 38.4 9.5 12 5.5 22.5 12.8 31.7 21.7 9.2 8.9 16.7 19.3 22.5 31.2 5.8 11.8 9.3 24.4 10.6 37.8 1.2 11.4 0.6 22.6-1.9 33.3z m77.4 205c-5.5 5.5-12.2 8.3-20 8.3-7.8 0-14.5-2.8-20-8.3s-8.3-12.2-8.3-20c0-7.8 2.8-14.5 8.3-20 5.5-5.5 12.2-8.3 20-8.3s14.5 2.8 20 8.3c5.5 5.5 8.3 12.2 8.3 20 0 7.8-2.7 14.4-8.3 20z m254-205c-2.5 10.7-6.3 20.7-11.3 30h0.4l-1.1 1.1c-2.5 4.3-4.9 8.2-7.2 11.7-15.9 24.2-30.6 46.7-44.2 67.6-5.8 8.8-11.6 17.8-17.4 26.8-5.8 9.1-11.3 17.5-16.4 25.3-5.2 7.8-9.8 14.8-13.8 21-4 6.2-7.1 10.8-9.1 13.8-2 2.8-4.7 4.2-7.9 4.2h-45.3l74.4-114.5c-1.5 0-3 0.1-4.5 0.2s-3 0.2-4.5 0.2c-15.4 0-29.8-2.9-43.3-8.7-13.5-5.8-25.2-13.7-35.1-23.8-10-10.1-17.8-21.9-23.6-35.3-5.8-13.5-8.7-27.8-8.7-42.9 0-15.9 3.1-30.7 9.3-44.6 6.2-13.9 14.6-25.8 25.3-35.9 10.7-10.1 23.2-17.8 37.4-23.2 14.2-5.4 29.4-7.6 45.5-6.6 13.6 0.8 26.4 3.9 38.3 9.5 12 5.5 22.5 12.8 31.7 21.7 9.2 8.9 16.7 19.3 22.5 31.2 5.8 11.8 9.3 24.4 10.6 37.8 1.1 11.5 0.5 22.7-2 33.4z m-391.3-71.4c-6.2-6.2-13.4-11-21.7-14.6-8.3-3.5-17.1-5.3-26.5-5.3-9.6 0-18.5 1.8-26.6 5.3-8.2 3.5-15.4 8.4-21.7 14.6-6.3 6.2-11.2 13.5-14.7 21.8s-5.3 17.2-5.3 26.5c0 9.4 1.8 18.2 5.3 26.5s8.4 15.6 14.7 21.8c6.3 6.2 13.5 11 21.7 14.6 8.2 3.5 17.1 5.3 26.6 5.3 11.1 0 21.4-2.5 30.8-7.4 9.5-4.9 17.3-11.6 23.6-19.9l5.3-8.7c5.5-9.9 8.3-20.6 8.3-32.2 0-9.4-1.8-18.2-5.3-26.5s-8.4-15.6-14.5-21.8z m331.4 0c-6.2-6.2-13.4-11-21.7-14.6-8.3-3.5-17.1-5.3-26.5-5.3-9.6 0-18.5 1.8-26.6 5.3-8.2 3.5-15.4 8.4-21.7 14.6s-11.2 13.5-14.7 21.8-5.3 17.2-5.3 26.5c0 9.4 1.8 18.2 5.3 26.5s8.4 15.6 14.7 21.8c6.3 6.2 13.5 11 21.7 14.6 8.2 3.5 17.1 5.3 26.6 5.3 11.1 0 21.3-2.5 30.8-7.4s17.3-11.6 23.6-19.9l5.3-8.7c5.5-9.9 8.3-20.6 8.3-32.2 0-9.4-1.8-18.2-5.3-26.5s-8.4-15.6-14.5-21.8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class GraphicLineChart extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"></path>
      <path d="M305.8 637.7c3.1 3.1 8.1 3.1 11.3 0l138.3-137.6L583 628.5c3.1 3.1 8.2 3.1 11.3 0l275.4-275.3c3.1-3.1 3.1-8.2 0-11.3l-39.6-39.6c-3.1-3.1-8.2-3.1-11.3 0l-230 229.9L461.4 404c-3.1-3.1-8.2-3.1-11.3 0L266.3 586.7c-3.1 3.1-3.1 8.2 0 11.3l39.5 39.7z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class GraphicAreaChartFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"></path>
      <path d="M272 728h536c4.4 0 8-3.6 8-8V284c0-7.2-8.7-10.7-13.7-5.7L592 488.6l-125.4-124c-3.1-3.1-8.2-3.1-11.3 0l-189 189.6c-1.5 1.5-2.3 3.5-2.3 5.6V720c0 4.4 3.6 8 8 8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class ExpressionSmile extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M288 421c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48zM640 421c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48z"></path>
      <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884s-99-9.8-144.8-29.2c-44.3-18.7-84.1-45.6-118.3-79.8s-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8c18.7-44.3 45.6-84.1 79.8-118.3s74-61 118.3-79.8C413 149.8 461.7 140 512 140s99 9.8 144.8 29.2c44.3 18.7 84.1 45.6 118.3 79.8s61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8c-18.7 44.3-45.6 84.1-79.8 118.2z"></path>
      <path d="M664 533h-48.1c-4.2 0-7.8 3.2-8.1 7.4C604 589.9 562.5 629 512 629s-92.1-39.1-95.8-88.6c-0.3-4.2-3.9-7.4-8.1-7.4H360c-4.6 0-8.2 3.8-8 8.4 4.4 84.3 74.5 151.6 160 151.6s155.6-67.3 160-151.6c0.2-4.6-3.4-8.4-8-8.4z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class ExpressionMeh extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M288 421c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48zM640 421c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48z"></path>
      <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884s-99-9.8-144.8-29.2c-44.3-18.7-84.1-45.6-118.3-79.8s-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8c18.7-44.3 45.6-84.1 79.8-118.3s74-61 118.3-79.8C413 149.8 461.7 140 512 140s99 9.8 144.8 29.2c44.3 18.7 84.1 45.6 118.3 79.8s61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8c-18.7 44.3-45.6 84.1-79.8 118.2z"></path>
      <path d="M664 565H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class ExpressionFrown extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M288 421c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48zM640 421c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48z"></path>
      <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884s-99-9.8-144.8-29.2c-44.3-18.7-84.1-45.6-118.3-79.8s-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8c18.7-44.3 45.6-84.1 79.8-118.3s74-61 118.3-79.8C413 149.8 461.7 140 512 140s99 9.8 144.8 29.2c44.3 18.7 84.1 45.6 118.3 79.8s61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8c-18.7 44.3-45.6 84.1-79.8 118.2z"></path>
      <path d="M512 533c-85.5 0-155.6 67.3-160 151.6-0.2 4.6 3.4 8.4 8 8.4h48.1c4.2 0 7.8-3.2 8.1-7.4C420 636.1 461.5 597 512 597s92.1 39.1 95.8 88.6c0.3 4.2 3.9 7.4 8.1 7.4H664c4.6 0 8.2-3.8 8-8.4-4.4-84.3-74.5-151.6-160-151.6z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class ExpressionSmileFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421c0-26.5 21.5-48 48-48s48 21.5 48 48-21.5 48-48 48-48-21.5-48-48z m224 272c-85.5 0-155.6-67.3-160-151.6-0.2-4.6 3.4-8.4 8-8.4h48.1c4.2 0 7.8 3.2 8.1 7.4C420 589.9 461.5 629 512 629s92.1-39.1 95.8-88.6c0.3-4.2 3.9-7.4 8.1-7.4H664c4.6 0 8.2 3.8 8 8.4-4.4 84.3-74.5 151.6-160 151.6z m176-224c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class ExpressionMehFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421c0-26.5 21.5-48 48-48s48 21.5 48 48-21.5 48-48 48-48-21.5-48-48z m384 200c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h304c4.4 0 8 3.6 8 8v48z m16-152c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class ExpressionFrownFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421c0-26.5 21.5-48 48-48s48 21.5 48 48-21.5 48-48 48-48-21.5-48-48z m376 272h-48.1c-4.2 0-7.8-3.2-8.1-7.4C604 636.1 562.5 597 512 597s-92.1 39.1-95.8 88.6c-0.3 4.2-3.9 7.4-8.1 7.4H360c-4.6 0-8.2-3.8-8-8.4 4.4-84.3 74.5-151.6 160-151.6s155.6 67.3 160 151.6c0.2 4.6-3.4 8.4-8 8.4z m24-224c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateInline extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M880.96 280.61h-736c-17.7 0-32 14.3-32 32v400c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32v-400c0-17.7-14.3-32-32-32z m-40 392h-656v-320h656v320zM904.87 837.61H121.06c-4.5 0-8.09 3.6-8.09 8v60c0 4.4 3.6 8 8.09 8h783.81c4.5 0 8.09-3.6 8.09-8v-60c0-4.4-3.59-8-8.09-8zM904.87 111.86H121.06c-4.5 0-8.09 3.6-8.09 8v60c0 4.4 3.6 8 8.09 8h783.81c4.5 0 8.09-3.6 8.09-8v-60c0-4.4-3.59-8-8.09-8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateFlex extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M880.86 112.61h-736c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32v-736c0-17.7-14.3-32-32-32z m-40 728h-656v-656h656v656z"></path>
      <path d="M570.86 760.61h206c8.84 0 16-7.16 16-16v-464c0-8.84-7.16-16-16-16h-206c-8.84 0-16 7.16-16 16v464c0 8.84 7.16 16 16 16z m56-423.08h94V687.7h-94V337.53zM248.48 760.61h206c8.84 0 16-7.16 16-16v-464c0-8.84-7.16-16-16-16h-206c-8.84 0-16 7.16-16 16v464c0 8.84 7.16 16 16 16z m56-423.08h94V687.7h-94V337.53z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateBlock extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M708.1 224.14H315.9c-17.65 0-31.9 14.3-31.9 32V768c0 17.7 14.26 32 31.9 32h392.2c17.65 0 31.9-14.3 31.9-32V256.14c0-17.7-14.26-32-31.9-32z m-39.79 504.47H355.88V296.75h312.43v431.86zM180.19 112h-60c-4.4 0-8 3.6-8 8.09V903.9c0 4.5 3.6 8.09 8 8.09h60c4.4 0 8-3.6 8-8.09V120.09c0-4.49-3.6-8.09-8-8.09zM904 112h-60c-4.4 0-8 3.6-8 8.09V903.9c0 4.5 3.6 8.09 8 8.09h60c4.4 0 8-3.6 8-8.09V120.09c0-4.49-3.6-8.09-8-8.09z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateInlineBlock extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M180.19 112h-60c-4.4 0-8 3.6-8 8.09V903.9c0 4.5 3.6 8.09 8 8.09h60c4.4 0 8-3.6 8-8.09V120.09c0-4.49-3.6-8.09-8-8.09zM904 112h-60c-4.4 0-8 3.6-8 8.09V903.9c0 4.5 3.6 8.09 8 8.09h60c4.4 0 8-3.6 8-8.09V120.09c0-4.49-3.6-8.09-8-8.09zM559.01 235.06c-2.49-7.35-9.79-11.7-17.2-10.74h-62.53c-1.33-0.17-2.65-0.16-3.95 0h-0.14v0.02c-5.87 0.76-11.08 4.74-13.11 10.73L273.05 789.42c-1.77 5.19 2.09 10.58 7.57 10.58h54.87c6.86 0 12.96-4.37 15.16-10.87l50-147.8h219.8l50 147.8c2.2 6.5 8.3 10.87 15.16 10.87h54.87c5.48 0 9.34-5.39 7.57-10.58L559.01 235.06z m-134 334.27l85.54-252.84 85.54 252.84H425.01z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateCloumnStart extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M180.19 112h-60c-4.4 0-8 3.6-8 8.09V903.9c0 4.5 3.6 8.09 8 8.09h60c4.4 0 8-3.6 8-8.09V120.09c0-4.49-3.6-8.09-8-8.09zM896 112H276.19c-8.84 0-16 7.16-16 16v184.44c0 8.84 7.16 16 16 16H896c8.84 0 16-7.16 16-16V128c0-8.84-7.16-16-16-16z m-56.92 152.44H324.19V176h514.89v88.44zM896 695.56H276.19c-8.84 0-16 7.16-16 16V896c0 8.84 7.16 16 16 16H896c8.84 0 16-7.16 16-16V711.56c0-8.84-7.16-16-16-16zM839.08 848H324.19v-88.44h514.89V848zM276.19 620.08H696c8.84 0 16-7.16 16-16V419.64c0-8.84-7.16-16-16-16H276.19c-8.84 0-16 7.16-16 16v184.44c0 8.84 7.16 16 16 16z m48-152.44h314.89v88.44H324.19v-88.44z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateCloumnEnd extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M904 112h-60c-4.4 0-8 3.6-8 8.09V903.9c0 4.5 3.6 8.09 8 8.09h60c4.4 0 8-3.6 8-8.09V120.09c0-4.49-3.6-8.09-8-8.09zM748 112H128.19c-8.84 0-16 7.16-16 16v184.44c0 8.84 7.16 16 16 16H748c8.84 0 16-7.16 16-16V128c0-8.84-7.16-16-16-16z m-48 152.44H185.11V176H700v88.44zM748 695.56H128.19c-8.84 0-16 7.16-16 16V896c0 8.84 7.16 16 16 16H748c8.84 0 16-7.16 16-16V711.56c0-8.84-7.16-16-16-16zM700 848H185.11v-88.44H700V848zM748 403.64H328.19c-8.84 0-16 7.16-16 16v184.44c0 8.84 7.16 16 16 16H748c8.84 0 16-7.16 16-16V419.64c0-8.83-7.16-16-16-16z m-48 152.44H385.11v-88.44H700v88.44z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateCloumnCenter extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M542 112h-60c-4.4 0-8 3.6-8 8.09V903.9c0 4.5 3.6 8.09 8 8.09h60c4.4 0 8-3.6 8-8.09V120.09c0-4.49-3.6-8.09-8-8.09zM366.33 186.1H161.89c-8.84 0-16 7.16-16 16v619.81c0 8.84 7.16 16 16 16h204.44c8.84 0 16-7.16 16-16V202.1c0-8.84-7.16-16-16-16z m-56 578.89h-92.44V259.01h92.44v505.98zM862.44 186.1H658c-8.84 0-16 7.16-16 16v619.81c0 8.84 7.16 16 16 16h204.44c8.84 0 16-7.16 16-16V202.1c0-8.84-7.16-16-16-16z m-56 578.89H714V259.01h92.44v505.98z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateCloumnSpaceBetween extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M904 112h-60c-4.4 0-8 3.6-8 8.09V903.9c0 4.5 3.6 8.09 8 8.09h60c4.4 0 8-3.6 8-8.09V120.09c0-4.49-3.6-8.09-8-8.09zM180.19 112h-60c-4.4 0-8 3.6-8 8.09V903.9c0 4.5 3.6 8.09 8 8.09h60c4.4 0 8-3.6 8-8.09V120.09c0-4.49-3.6-8.09-8-8.09zM420.63 185.96H236.19c-8.84 0-16 7.16-16 16v619.81c0 8.84 7.16 16 16 16h184.44c8.84 0 16-7.16 16-16V201.96c0-8.84-7.16-16-16-16z m-48 587.81h-88.44V258.88h88.44v514.89zM788 185.96H603.56c-8.84 0-16 7.16-16 16v619.81c0 8.84 7.16 16 16 16H788c8.84 0 16-7.16 16-16V201.96c0-8.84-7.16-16-16-16z m-48 587.81h-88.44V258.88H740v514.89z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateRowStart extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M904 112.1H120.19c-4.5 0-8.09 3.6-8.09 8v60c0 4.4 3.6 8 8.09 8H904c4.5 0 8.09-3.6 8.09-8v-60c0-4.4-3.59-8-8.09-8zM896.09 260.1H711.65c-8.84 0-16 7.16-16 16v619.81c0 8.84 7.16 16 16 16h184.44c8.84 0 16-7.16 16-16V276.1c0-8.84-7.16-16-16-16z m-48 578.89h-88.44V324.1h88.44v514.89zM312.54 260.1H128.09c-8.84 0-16 7.16-16 16v619.81c0 8.84 7.16 16 16 16h184.44c8.84 0 16-7.16 16-16V276.1c0.01-8.84-7.16-16-15.99-16z m-48 578.89H176.1V324.1h88.44v514.89zM604.45 260.1H420.01c-8.84 0-16 7.16-16 16v419.81c0 8.84 7.16 16 16 16h184.44c8.84 0 16-7.16 16-16V276.1c0-8.84-7.16-16-16-16z m-48 378.89h-88.44V324.1h88.44v314.89z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateRowEnd extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M904 835.91H120.19c-4.5 0-8.09 3.6-8.09 8v60c0 4.4 3.6 8 8.09 8H904c4.5 0 8.09-3.6 8.09-8v-60c0-4.4-3.59-8-8.09-8zM896.09 112.1H711.65c-8.84 0-16 7.16-16 16v619.81c0 8.84 7.16 16 16 16h184.44c8.84 0 16-7.16 16-16V128.1c0-8.84-7.16-16-16-16z m-48 587.81h-88.44v-514.9h88.44v514.9zM128.09 763.91h184.44c8.84 0 16-7.16 16-16V128.1c0-8.84-7.16-16-16-16H128.09c-8.84 0-16 7.16-16 16v619.81c0 8.83 7.17 16 16 16z m48-578.9h88.44V699.9h-88.44V185.01zM420.01 763.91h184.44c8.84 0 16-7.16 16-16V328.1c0-8.84-7.16-16-16-16H420.01c-8.84 0-16 7.16-16 16v419.81c0 8.83 7.17 16 16 16z m48-378.9h88.44V699.9h-88.44V385.01z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateRowCenter extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M951.91 474H788.44V309.07c0-8.84-7.16-16-16-16H568c-8.84 0-16 7.16-16 16V474h-80V128.14c0-8.84-7.16-16-16-16H251.56c-8.84 0-16 7.16-16 16V474H72.09c-4.5 0-8.09 3.6-8.09 8v60c0 4.4 3.6 8 8.09 8h163.47v346.14c0 8.84 7.16 16 16 16H456c8.84 0 16-7.16 16-16V550h80v164.93c0 8.84 7.16 16 16 16h204.44c8.84 0 16-7.16 16-16V550h163.47c4.5 0 8.09-3.6 8.09-8v-60c0-4.4-3.6-8-8.09-8zM400 839.86h-92.44V184.14H400v655.72zM716.44 474V658.02H624V365.99h92.44V474z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateRowBaseline extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M951.91 474H788.44V128.14c0-8.84-7.16-16-16-16H568c-8.84 0-16 7.16-16 16V474h-80V128.14c0-8.84-7.16-16-16-16H251.56c-8.84 0-16 7.16-16 16V474H72.09c-4.5 0-8.09 3.6-8.09 8v60c0 4.4 3.6 8 8.09 8h163.47v346.14c0 8.84 7.16 16 16 16H456c8.84 0 16-7.16 16-16V550h80v169.86c0 8.84 7.16 16 16 16h204.44c8.84 0 16-7.16 16-16V550h163.47c4.5 0 8.09-3.6 8.09-8v-60c0-4.4-3.6-8-8.09-8zM307.56 184.14H400V474h-92.44V184.14zM400 839.86h-92.44V550H400v289.86z m224-654.81h92.44V474H624V185.05z m92.44 477.9H624V550h92.44v112.95z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateRowStretch extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M904 835.91H120.19c-4.5 0-8.09 3.6-8.09 8v60c0 4.4 3.6 8 8.09 8H904c4.5 0 8.09-3.6 8.09-8v-60c0.01-4.4-3.59-8-8.09-8zM904 112.1H120.19c-4.5 0-8.09 3.6-8.09 8v60c0 4.4 3.6 8 8.09 8H904c4.5 0 8.09-3.6 8.09-8v-60c0.01-4.4-3.59-8-8.09-8zM128 763.91h184.44c8.84 0 16-7.16 16-16V276.1c0-8.84-7.16-16-16-16H128c-8.84 0-16 7.16-16 16v471.81c0 8.83 7.16 16 16 16z m48-430.9h88.44v370.85H176V333.01zM896 763.91c8.84 0 16-7.16 16-16V276.1c0-8.84-7.16-16-16-16H711.56c-8.84 0-16 7.16-16 16v471.81c0 8.84 7.16 16 16 16H896z m-136.44-430.9H848v370.85h-88.44V333.01zM604.22 763.91c8.84 0 16-7.16 16-16V276.1c0-8.84-7.16-16-16-16H419.78c-8.84 0-16 7.16-16 16v471.81c0 8.84 7.16 16 16 16h184.44z m-136.44-430.9h88.44v370.85h-88.44V333.01z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateRow extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M903.91 644.14H120.09c-4.5 0-8.09 3.6-8.09 8v60c0 4.4 3.6 8 8.09 8H903.9c4.5 0 8.09-3.6 8.09-8v-60c0.01-4.4-3.59-8-8.08-8zM923.93 397.82l-141.7-112c-5.2-4.1-12.9-0.4-12.9 6.3v74.1H120c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h649.23v73.9c0 6.7 7.7 10.4 12.9 6.3l141.8-112c4.1-3.2 4.1-9.4 0-12.6z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateRowReverse extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M903.91 644.14H120.09c-4.5 0-8.09 3.6-8.09 8v60c0 4.4 3.6 8 8.09 8H903.9c4.5 0 8.09-3.6 8.09-8v-60c0.01-4.4-3.59-8-8.08-8zM904 366.22H254.67v-74.1c0-6.7-7.7-10.4-12.9-6.3l-141.7 112c-4.1 3.2-4.1 9.4 0 12.6l141.8 112c5.2 4.1 12.9 0.4 12.9-6.3v-73.9H904c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateColumnReverse extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M369.49 112h-60c-4.4 0-8 3.6-8 8.09V903.9c0 4.5 3.6 8.09 8 8.09h60c4.4 0 8-3.6 8-8.09V120.09c0-4.49-3.6-8.09-8-8.09zM735.8 239.39l-112-141.7c-3.2-4.1-9.4-4.1-12.6 0l-112 141.8c-4.1 5.2-0.4 12.9 6.3 12.9h73.9v649.23c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V252.29h74.1c6.7 0 10.4-7.7 6.3-12.9z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateColumn extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M369.49 112h-60c-4.4 0-8 3.6-8 8.09V903.9c0 4.5 3.6 8.09 8 8.09h60c4.4 0 8-3.6 8-8.09V120.09c0-4.49-3.6-8.09-8-8.09zM729.5 769.47h-74.1V120.14c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v649.23h-73.9c-6.7 0-10.4 7.7-6.3 12.9l112 141.8c3.2 4.1 9.4 4.1 12.6 0l112-141.7c4.1-5.2 0.4-12.9-6.3-12.9z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateNowrap extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M120.09 708.02H903.9c4.5 0 8.09-3.6 8.09-8v-60c0-4.4-3.6-8-8.09-8H120.09c-4.5 0-8.09 3.6-8.09 8v60c0 4.4 3.6 8 8.09 8zM120.09 391.98H903.9c4.5 0 8.09-3.6 8.09-8v-60c0-4.4-3.6-8-8.09-8H120.09c-4.5 0-8.09 3.6-8.09 8v60c0 4.4 3.6 8 8.09 8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateWrap extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M120.09 707.51h296.36c4.5 0 8.09-3.6 8.09-8v-60c0-4.4-3.6-8-8.09-8H120.09c-4.5 0-8.09 3.6-8.09 8v60c0 4.4 3.6 8 8.09 8zM836 282.57v375.85c0 4.5 3.6 8.09 8 8.09h60c4.4 0 8-3.6 8-8.09V282.57c0-4.5-3.6-8.09-8-8.09h-60c-4.4-0.01-8 3.59-8 8.09z"></path>
      <path d="M120.09 350.47H903.9c4.5 0 8.09-3.6 8.09-8v-60c0-4.4-3.6-8-8.09-8H120.09c-4.5 0-8.09 3.6-8.09 8v60c0 4.4 3.6 8 8.09 8zM649.42 787.81c5.2 4.1 12.9 0.4 12.9-6.3v-73.9H904c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H662.22v-74.1c0-6.7-7.7-10.4-12.9-6.3l-141.7 112c-4.1 3.2-4.1 9.4 0 12.6l141.8 112z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateWrapReverse extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M120.09 300.35h296.36c4.5 0 8.09 3.6 8.09 8v60c0 4.4-3.6 8-8.09 8H120.09c-4.5 0-8.09-3.6-8.09-8v-60c0-4.4 3.6-8 8.09-8zM836 725.3V349.45c0-4.5 3.6-8.09 8-8.09h60c4.4 0 8 3.6 8 8.09V725.3c0 4.5-3.6 8.09-8 8.09h-60c-4.4 0-8-3.6-8-8.09z"></path>
      <path d="M120.09 657.39H903.9c4.5 0 8.09 3.6 8.09 8v60c0 4.4-3.6 8-8.09 8H120.09c-4.5 0-8.09-3.6-8.09-8v-60c0-4.4 3.6-8 8.09-8zM507.62 332.05c-4.1 3.2-4.1 9.4 0 12.6l141.7 112c5.2 4.1 12.9 0.4 12.9-6.3v-74.1H904c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H662.32v-73.9c0-6.7-7.7-10.4-12.9-6.3l-141.8 112z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalScreenshot extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M580.07 190.91h-136c-4.42 0-8 3.58-8 8v56c0 4.42 3.58 8 8 8h136c4.42 0 8-3.58 8-8v-56c0-4.42-3.58-8-8-8zM580.07 758.91h-136c-4.42 0-8 3.58-8 8v56c0 4.42 3.58 8 8 8h136c4.42 0 8-3.58 8-8v-56c0-4.42-3.58-8-8-8zM824.07 657.91h-56c-4.42 0-8 3.58-8 8v93h-92c-4.42 0-8 3.58-8 8v56c0 4.42 3.58 8 8 8h92v92c0 4.42 3.58 8 8 8h56c4.42 0 8-3.58 8-8v-92h92c4.42 0 8-3.58 8-8v-56c0-4.42-3.58-8-8-8h-92v-93c0-4.42-3.58-8-8-8zM256.07 657.91h-56c-4.42 0-8 3.58-8 8v133c0 17.67 14.33 32 32 32h132c4.42 0 8-3.58 8-8v-56c0-4.42-3.58-8-8-8h-92v-93c0-4.42-3.58-8-8-8zM800.07 190.91h-132c-4.42 0-8 3.58-8 8v56c0 4.42 3.58 8 8 8h84c4.42 0 8 3.58 8 8v83c0 4.42 3.58 8 8 8h56c4.42 0 8-3.58 8-8v-131c0-17.67-14.33-32-32-32zM824.07 433.91h-56c-4.42 0-8 3.58-8 8v136c0 4.42 3.58 8 8 8h56c4.42 0 8-3.58 8-8v-136c0-4.42-3.58-8-8-8zM256.07 433.91h-56c-4.42 0-8 3.58-8 8v136c0 4.42 3.58 8 8 8h56c4.42 0 8-3.58 8-8v-136c0-4.42-3.58-8-8-8zM256.07 90.91h-56c-4.42 0-8 3.58-8 8v92h-92c-4.42 0-8 3.58-8 8v56c0 4.42 3.58 8 8 8h92v91c0 4.42 3.58 8 8 8h56c4.42 0 8-3.58 8-8v-91h92c4.42 0 8-3.58 8-8v-56c0-4.42-3.58-8-8-8h-92v-92c0-4.42-3.58-8-8-8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalFeedbackFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M896 112.5h-768a32 32 0 0 0-32 32v591.2a32 32 0 0 0 32 32h243.3l103.4 127.4a48 48 0 0 0 74.6 0l103.4-127.4h243.3a32 32 0 0 0 32-32v-591.2a32 32 0 0 0-32-32z m-576 375.5a48 48 0 1 1 48-48 48 48 0 0 1-48 48z m192 0a48 48 0 1 1 48-48 48 48 0 0 1-48 48z m192 0a48 48 0 1 1 48-48 48 48 0 0 1-48 48z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalIntegrate extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M911.6 385.67l-0.3-1.5c-0.2-1-0.3-1.9-0.6-2.9-0.2-0.6-0.4-1.1-0.5-1.7-0.3-0.8-0.5-1.7-0.9-2.5-0.2-0.6-0.5-1.1-0.8-1.7-0.4-0.8-0.8-1.5-1.2-2.3-0.3-0.5-0.6-1.1-1-1.6-0.8-1.2-1.7-2.4-2.6-3.6-0.5-0.6-1.1-1.3-1.7-1.9-0.4-0.5-0.9-0.9-1.4-1.3-0.6-0.6-1.3-1.1-1.9-1.6-0.5-0.4-1-0.8-1.6-1.2-0.2-0.1-0.4-0.3-0.6-0.4L531 118.17c-11.5-7.7-26.6-7.7-38.1 0l-365.7 243.5c-0.2 0.1-0.4 0.3-0.6 0.4-0.5 0.4-1 0.8-1.6 1.2-0.7 0.5-1.3 1.1-1.9 1.6-0.5 0.4-0.9 0.9-1.4 1.3-0.6 0.6-1.2 1.2-1.7 1.9-1 1.1-1.8 2.3-2.6 3.6-0.3 0.5-0.7 1-1 1.6-0.4 0.7-0.8 1.5-1.2 2.3-0.3 0.5-0.5 1.1-0.8 1.7-0.3 0.8-0.6 1.7-0.9 2.5-0.2 0.6-0.4 1.1-0.5 1.7-0.2 0.9-0.4 1.9-0.6 2.9l-0.3 1.5c-0.2 1.5-0.3 3-0.3 4.5v243.5c0 1.5 0.1 3 0.3 4.5l0.3 1.5c0.2 1 0.4 1.9 0.6 2.9 0.2 0.6 0.3 1.1 0.5 1.7 0.3 0.9 0.6 1.7 0.9 2.5 0.2 0.6 0.5 1.1 0.8 1.7 0.4 0.8 0.7 1.5 1.2 2.3 0.3 0.5 0.6 1.1 1 1.6 0.5 0.7 0.9 1.4 1.5 2.1l1.2 1.5c0.5 0.6 1.1 1.3 1.7 1.9 0.4 0.5 0.9 0.9 1.4 1.3 0.6 0.6 1.3 1.1 1.9 1.6 0.5 0.4 1 0.8 1.6 1.2 0.2 0.1 0.4 0.3 0.6 0.4l365.6 243.5c5.6 3.8 12.3 5.8 19.1 5.8 6.6 0 13.3-1.9 19.1-5.8l365.6-243.5c0.2-0.1 0.4-0.3 0.6-0.4 0.5-0.4 1-0.8 1.6-1.2 0.7-0.5 1.3-1.1 1.9-1.6 0.5-0.4 0.9-0.9 1.4-1.3 0.6-0.6 1.2-1.2 1.7-1.9l1.2-1.5 1.5-2.1c0.3-0.5 0.7-1 1-1.6 0.4-0.8 0.8-1.5 1.2-2.3 0.3-0.5 0.5-1.1 0.8-1.7 0.3-0.8 0.6-1.7 0.9-2.5 0.2-0.5 0.4-1.1 0.5-1.7 0.3-0.9 0.4-1.9 0.6-2.9l0.3-1.5c0.2-1.5 0.3-3 0.3-4.5v-243.7c-0.3-1.5-0.4-3-0.6-4.5zM546.4 210.94l269.3 179.33-120.3 80.4-149-99.6V210.94z m-68.9-0.07v160.2l-149 99.6-120.3-80.4 269.3-179.4z m0 602.1L180.6 614.64V454.47l86 57.5 61.9 41.2 149 99.6v160.2z m34.4-219.8l-121.6-81.2 121.6-81.3 121.6 81.2-121.6 81.3z m34.4 219.8v-160.2l149-99.6 61.9-41.3 86-57.5 0.93 160.2-297.83 198.4z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MaterialLockFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M875.64 314H770V170c0-61.86-50.14-112-112-112H370c-61.86 0-112 50.14-112 112v144H148.36c-20.08 0-36.36 14.33-36.36 32v536c0 17.67 16.28 32 36.36 32h727.27c20.08 0 36.36-14.33 36.36-32V346c0.01-17.67-16.27-32-36.35-32zM548 585.05v111.93c0 4.43-3.58 8.02-8 8.02h-56c-4.42 0-8-3.59-8-8.02V585.05c-19.21-12.05-32-33.45-32-57.85 0-37.67 30.44-68.2 68-68.2s68 30.53 68 68.2c0 24.4-12.79 45.8-32 57.85zM330 314V178c0-26.51 21.49-48 48-48h272c26.51 0 48 21.49 48 48v136H330z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MoneyYuanFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m166.6 246.8L567.5 515.6h62c4.4 0 8 3.6 8 8v29.9c0 4.4-3.6 8-8 8h-82V603h82c4.4 0 8 3.6 8 8v29.9c0 4.4-3.6 8-8 8h-82V717c0 4.4-3.6 8-8 8h-54.3c-4.4 0-8-3.6-8-8v-68.1h-81.7c-4.4 0-8-3.6-8-8V611c0-4.4 3.6-8 8-8h81.7v-41.5h-81.7c-4.4 0-8-3.6-8-8v-29.9c0-4.4 3.6-8 8-8h61.4L345.4 310.8c-2.1-3.9-0.7-8.7 3.2-10.9 1.2-0.6 2.5-1 3.8-1h60.7c3 0 5.8 1.7 7.1 4.4l90.6 180h3.4l90.6-180c1.4-2.7 4.1-4.4 7.1-4.4h59.5c4.4 0 8 3.6 8 8 0.2 1.4-0.2 2.7-0.8 3.9z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MoneyCollectFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M911.5 699.7c-1.5-4.2-6.1-6.3-10.3-4.8L840 717.2V179c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-0.9-0.3-1.8-0.5-2.7-0.5-4.4 0-8 3.6-8 8V762c0 3.3 2.1 6.3 5.3 7.5L501 909.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-0.2-1.9-0.5-2.8z m-243.8-377L564 514.3h57.6c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3v39h76.3c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3V703c0 4.4-3.6 8-8 8h-49.9c-4.4 0-8-3.6-8-8v-63.4h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h76v-39h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h57L356.5 322.8c-2.1-3.8-0.7-8.7 3.2-10.8 1.2-0.7 2.5-1 3.8-1h55.7c3 0 5.7 1.7 7.1 4.4L511 484.2h3.3L599 315.4c1.3-2.7 4.1-4.4 7.1-4.4h54.5c4.4 0 8 3.6 8.1 7.9 0 1.3-0.4 2.6-1 3.8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MoneyAccountBookFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zM648.3 426.8l-87.7 161.1h45.7c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4v29.7h63.4c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4V752c0 5.5-4.5 10-10 10h-41.3c-5.5 0-10-4.5-10-10v-51.8h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h63.1v-29.7h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h45.2l-88-161.1c-2.6-4.8-0.9-10.9 4-13.6 1.5-0.8 3.1-1.2 4.8-1.2h46c3.8 0 7.2 2.1 8.9 5.5l72.9 144.3 73.2-144.3c1.7-3.4 5.2-5.5 8.9-5.5h45c5.5 0 10 4.5 10 10 0.1 1.7-0.3 3.3-1.1 4.8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateFixedFillet extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M682 112.14H342c-127 0-230 103-230 230v340c0 127 103 230 230 230h340c127 0 230-103 230-230v-340c0-127-103-230-230-230z m158 570c0 87.3-70.7 158-158 158H342c-87.3 0-158-70.7-158-158v-340c0-87.3 70.7-158 158-158h340c87.3 0 158 70.7 158 158v340z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateCustomizedFillet extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M444 840.14H342c-87.3 0-158-70.7-158-158V580c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v102.14c0 127 103 230 230 230h102c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM904 572h-56c-4.4 0-8 3.6-8 8v102.14c0 87.3-70.7 158-158 158H580c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h102c127 0 230-103 230-230V580c0-4.4-3.6-8-8-8zM444 112.14H342c-127 0-230 103-230 230V444c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V342.14c0-87.3 70.7-158 158-158h102c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM682 112.14H580c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h102c87.3 0 158 70.7 158 158V444c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V342.14c0-127-103-230-230-230z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateLeftBorder extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M216 112h-88c-8.84 0-16 7.16-16 16v768c0 8.84 7.16 16 16 16h88c8.84 0 16-7.16 16-16V128c0-8.84-7.16-16-16-16zM880.86 112.61H328c-8.84 0-16 7.16-16 16v40c0 8.84 7.16 16 16 16h512.86v656H328c-8.84 0-16 7.16-16 16v40c0 8.35 6.4 15.2 14.56 15.93 0.48 0.04 0.95 0.07 1.44 0.07 0.48 0 0.96-0.03 1.43-0.07l551.42 0.07c17.7 0 32-14.3 32-32v-736c0.01-17.67-14.32-32-31.99-32z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateRightBorder extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M896.86 112.61h-88c-8.84 0-16 7.16-16 16v768c0 8.84 7.16 16 16 16h88c8.84 0 16-7.16 16-16v-768c0-8.84-7.17-16-16-16zM698.3 112.07c-0.48-0.04-0.95-0.07-1.44-0.07-0.48 0-0.96 0.03-1.43 0.07L144 112c-17.7 0-32 14.3-32 32v736c0 17.67 14.33 32 32 32h552.86c8.84 0 16-7.16 16-16v-40c0-8.84-7.16-16-16-16H184V184h512.86c8.84 0 16-7.16 16-16v-40c0-8.35-6.4-15.2-14.56-15.93z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateTopBorder extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M896.73 111.88h-768c-8.84 0-16 7.16-16 16v88c0 8.84 7.16 16 16 16h768c8.84 0 16-7.16 16-16v-88c0-8.84-7.16-16-16-16zM896.12 311.88h-40c-8.84 0-16 7.16-16 16v512.86h-656V327.88c0-8.84-7.16-16-16-16h-40c-8.35 0-15.2 6.4-15.93 14.56-0.04 0.48-0.07 0.95-0.07 1.44 0 0.48 0.03 0.96 0.07 1.43l-0.07 551.42c0 17.7 14.3 32 32 32h736c17.67 0 32-14.33 32-32V327.88c0-8.84-7.16-16-16-16z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateBottomBorder extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M896.12 792.73h-768c-8.84 0-16 7.16-16 16v88c0 8.84 7.16 16 16 16h768c8.84 0 16-7.16 16-16v-88c0-8.83-7.16-16-16-16zM912.73 143.88c0-17.7-14.3-32-32-32h-736c-17.67 0-32 14.33-32 32v552.86c0 8.84 7.16 16 16 16h40c8.84 0 16-7.16 16-16V183.88h656v512.86c0 8.84 7.16 16 16 16h40c8.35 0 15.2-6.4 15.93-14.56 0.04-0.48 0.07-0.95 0.07-1.44 0-0.48-0.03-0.96-0.07-1.43l0.07-551.43z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateAllBorders extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M896.12 112.61h-768c-8.84 0-16 7.16-16 16v768.12c0 8.84 7.16 16 16 16h768c8.84 0 16-7.16 16-16V128.61c0-8.84-7.16-16-16-16z m-104 680.12h-560V232.61h560v560.12z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateSolidLine extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M112.73 545.69v-67.38c0-7.9 6.41-14.31 14.31-14.31h771.38c7.9 0 14.31 6.41 14.31 14.31v67.38c0 7.9-6.41 14.31-14.31 14.31H127.05c-7.91 0-14.32-6.41-14.32-14.31z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateDottedLine extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M309.76 464H119.24c-4 0-7.24 3.24-7.24 7.24v81.51c0 4 3.24 7.24 7.24 7.24h190.51c4 0 7.24-3.24 7.24-7.24v-81.51c0.01-4-3.23-7.24-7.23-7.24zM607.74 464H416.26a7.26 7.26 0 0 0-7.26 7.26v81.48a7.26 7.26 0 0 0 7.26 7.26h191.48a7.26 7.26 0 0 0 7.26-7.26v-81.48a7.26 7.26 0 0 0-7.26-7.26zM905.38 463.86H714.19c-4 0-7.24 3.24-7.24 7.24v81.51c0 4 3.24 7.24 7.24 7.24h191.19c4 0 7.24-3.24 7.24-7.24V471.1c0-3.99-3.24-7.24-7.24-7.24z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateRoundLine extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M237.21 464H117.79c-3.2 0-5.79 2.59-5.79 5.79v84.42c0 3.2 2.59 5.79 5.79 5.79h119.42c3.2 0 5.79-2.59 5.79-5.79v-84.42c0-3.2-2.59-5.79-5.79-5.79zM460.21 464H340.79c-3.2 0-5.79 2.59-5.79 5.79v84.42c0 3.2 2.59 5.79 5.79 5.79h119.42c3.2 0 5.79-2.59 5.79-5.79v-84.42c0-3.2-2.59-5.79-5.79-5.79zM683.21 464H563.79c-3.2 0-5.79 2.59-5.79 5.79v84.42c0 3.2 2.59 5.79 5.79 5.79h119.42c3.2 0 5.79-2.59 5.79-5.79v-84.42c0-3.2-2.59-5.79-5.79-5.79zM906.21 464H786.79c-3.2 0-5.79 2.59-5.79 5.79v84.42c0 3.2 2.59 5.79 5.79 5.79h119.42c3.2 0 5.79-2.59 5.79-5.79v-84.42c0-3.2-2.59-5.79-5.79-5.79z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateOuterShadow extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M912.17 541.83v-60c0-4.4-3.6-8-8.09-8H120.26c-4.5 0-8.09 3.6-8.09 8v60c0 4.4 3.6 8 8.09 8h783.81c4.5 0 8.1-3.6 8.1-8zM838.07 366.17V161.73c0-8.84-7.16-16-16-16H202.26c-8.84 0-16 7.16-16 16v204.44c0 8.84 7.16 16 16 16h619.81c8.84 0 16-7.17 16-16z m-578.89-56v-92.44h505.98v92.44H259.18zM838.07 862.27V657.83c0-8.84-7.16-16-16-16H202.26c-8.84 0-16 7.16-16 16v204.44c0 8.84 7.16 16 16 16h619.81c8.84 0 16-7.16 16-16z m-578.89-56v-92.44h505.98v92.44H259.18z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateInnerShadow extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M912.09 903.9v-60c0-4.4-3.6-8-8.09-8H120.19c-4.5 0-8.09 3.6-8.09 8v60c0 4.4 3.6 8 8.09 8H904c4.5 0 8.09-3.6 8.09-8zM912.09 180.1v-60c0-4.4-3.6-8-8.09-8H120.19c-4.5 0-8.09 3.6-8.09 8v60c0 4.4 3.6 8 8.09 8H904c4.5 0 8.09-3.6 8.09-8zM838.14 420.54V236.1c0-8.84-7.16-16-16-16H202.33c-8.84 0-16 7.16-16 16v184.44c0 8.84 7.16 16 16 16h619.81c8.83 0 16-7.17 16-16z m-587.81-48V284.1h514.89v88.44H250.33zM838.14 787.9V603.46c0-8.84-7.16-16-16-16H202.33c-8.84 0-16 7.16-16 16V787.9c0 8.84 7.16 16 16 16h619.81c8.83 0 16-7.16 16-16z m-587.81-48v-88.44h514.89v88.44H250.33z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateUpperLeftCorner extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M912.12 152.61v-8c0-9.36-4.02-17.79-10.43-23.64l-0.21-0.18c-0.63-0.56-1.28-1.1-1.96-1.62a32.079 32.079 0 0 0-4.86-3.06c-0.48-0.24-0.96-0.48-1.45-0.7-4-1.8-8.43-2.8-13.1-2.8h-736c-17.67 0-32 14.33-32 32v736c0 17.67 14.33 32 32 32h736c17.67 0 32-14.33 32-32v-728h0.01z m-728 32h656v656h-656v-656z"></path>
      <path d="M516.12 248.61h-236c-17.67 0-32 14.33-32 32v236c0 17.67 14.33 32 32 32h236c17.67 0 32-14.33 32-32v-236c0-17.67-14.32-32-32-32z m-28 240h-180v-180h180v180z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateUpperRightCorner extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M880.12 112.61h-736c-17.67 0-32 14.33-32 32v736c0 17.67 14.33 32 32 32h736c17.67 0 32-14.33 32-32v-736c0-17.67-14.32-32-32-32z m-40 72v656h-656v-656h656z"></path>
      <path d="M508.12 548.61h236c17.67 0 32-14.33 32-32v-236c0-17.67-14.33-32-32-32h-236c-17.67 0-32 14.33-32 32v236c0 17.67 14.33 32 32 32z m28-240h180v180h-180v-180z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateBottomLeftCorner extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M880.12 112.61h-736c-17.67 0-32 14.33-32 32v736c0 17.67 14.33 32 32 32h736c17.67 0 32-14.33 32-32v-736c0-17.67-14.32-32-32-32z m-40 728h-656v-656h656v656z"></path>
      <path d="M280.12 776.61h236c17.67 0 32-14.33 32-32v-236c0-17.67-14.33-32-32-32h-236c-17.67 0-32 14.33-32 32v236c0 17.67 14.33 32 32 32z m28-240h180v180h-180v-180z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateBottomRightCorner extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M880.12 112.61h-736c-17.67 0-32 14.33-32 32v736c0 17.67 14.33 32 32 32h736c17.67 0 32-14.33 32-32v-736c0-17.67-14.32-32-32-32z m-40 72v656h-656v-656h656z"></path>
      <path d="M508.12 776.61h236c17.67 0 32-14.33 32-32v-236c0-17.67-14.33-32-32-32h-236c-17.67 0-32 14.33-32 32v236c0 17.67 14.33 32 32 32z m28-240h180v180h-180v-180z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateKeepLeft extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M880.12 112.61h-736c-17.67 0-32 14.33-32 32v736c0 17.67 14.33 32 32 32h736c17.67 0 32-14.33 32-32v-736c0-17.67-14.32-32-32-32z m-40 72v656h-656v-656h656z"></path>
      <path d="M280.12 776.61h236c17.67 0 32-14.33 32-32v-464c0-17.67-14.33-32-32-32h-236c-17.67 0-32 14.33-32 32v464c0 17.67 14.33 32 32 32z m28-468h180v408h-180v-408z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateKeepRight extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M880.12 112.61h-736c-17.67 0-32 14.33-32 32v736c0 17.67 14.33 32 32 32h736c17.67 0 32-14.33 32-32v-736c0-17.67-14.32-32-32-32z m-40 72v656h-656v-656h656z"></path>
      <path d="M508.12 776.61h236c17.67 0 32-14.33 32-32v-464c0-17.67-14.33-32-32-32h-236c-17.67 0-32 14.33-32 32v464c0 17.67 14.33 32 32 32z m28-468h180v408h-180v-408z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateTop extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M880.12 112.61h-736c-17.67 0-32 14.33-32 32v736c0 17.67 14.33 32 32 32h736c17.67 0 32-14.33 32-32v-736c0-17.67-14.32-32-32-32z m-40 72v656h-656v-656h656z"></path>
      <path d="M280.12 548.61h464c17.67 0 32-14.33 32-32v-236c0-17.67-14.33-32-32-32h-464c-17.67 0-32 14.33-32 32v236c0 17.67 14.33 32 32 32z m28-240h408v180h-408v-180z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateBottom extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M880.12 112.61h-736c-17.67 0-32 14.33-32 32v736c0 17.67 14.33 32 32 32h736c17.67 0 32-14.33 32-32v-736c0-17.67-14.32-32-32-32z m-40 72v656h-656v-656h656z"></path>
      <path d="M280.12 776.61h464c17.67 0 32-14.33 32-32v-236c0-17.67-14.33-32-32-32h-464c-17.67 0-32 14.33-32 32v236c0 17.67 14.33 32 32 32z m28-240h408v180h-408v-180z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateMiddle extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M880.12 112.61h-736c-17.67 0-32 14.33-32 32v736c0 17.67 14.33 32 32 32h736c17.67 0 32-14.33 32-32v-736c0-17.67-14.32-32-32-32z m-40 72v656h-656v-656h656z"></path>
      <path d="M280.12 776.61h464c17.67 0 32-14.33 32-32v-464c0-17.67-14.33-32-32-32h-464c-17.67 0-32 14.33-32 32v464c0 17.67 14.33 32 32 32z m28-468h408v408h-408v-408z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateRepeat extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M320 132.14H164c-17.67 0-32 14.33-32 32v156c0 17.67 14.33 32 32 32h156c17.67 0 32-14.33 32-32v-156c0-17.68-14.33-32-32-32z m-28 160H192v-100h100v100zM860.12 132.14h-156c-17.67 0-32 14.33-32 32v156c0 17.67 14.33 32 32 32h156c17.67 0 32-14.33 32-32v-156c0-17.68-14.32-32-32-32z m-28 160h-100v-100h100v100zM590 132.14H434c-17.67 0-32 14.33-32 32v156c0 17.67 14.33 32 32 32h156c17.67 0 32-14.33 32-32v-156c0-17.68-14.33-32-32-32z m-28 160H462v-100h100v100zM320 402H164c-17.67 0-32 14.33-32 32v156c0 17.67 14.33 32 32 32h156c17.67 0 32-14.33 32-32V434c0-17.67-14.33-32-32-32z m-28 160H192V462h100v100zM860.12 402h-156c-17.67 0-32 14.33-32 32v156c0 17.67 14.33 32 32 32h156c17.67 0 32-14.33 32-32V434c0-17.67-14.32-32-32-32z m-28 160h-100V462h100v100zM590 402H434c-17.67 0-32 14.33-32 32v156c0 17.67 14.33 32 32 32h156c17.67 0 32-14.33 32-32V434c0-17.67-14.33-32-32-32z m-28 160H462V462h100v100zM320 671.86H164c-17.67 0-32 14.33-32 32v156c0 17.67 14.33 32 32 32h156c17.67 0 32-14.33 32-32v-156c0-17.67-14.33-32-32-32z m-28 160H192v-100h100v100zM860.12 671.86h-156c-17.67 0-32 14.33-32 32v156c0 17.67 14.33 32 32 32h156c17.67 0 32-14.33 32-32v-156c0-17.67-14.32-32-32-32z m-28 160h-100v-100h100v100zM590 671.86H434c-17.67 0-32 14.33-32 32v156c0 17.67 14.33 32 32 32h156c17.67 0 32-14.33 32-32v-156c0-17.67-14.33-32-32-32z m-28 160H462v-100h100v100z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateRepeatX extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M320 402H164c-17.67 0-32 14.33-32 32v156c0 17.67 14.33 32 32 32h156c17.67 0 32-14.33 32-32V434c0-17.67-14.33-32-32-32z m-28 160H192V462h100v100zM860.12 402h-156c-17.67 0-32 14.33-32 32v156c0 17.67 14.33 32 32 32h156c17.67 0 32-14.33 32-32V434c0-17.67-14.32-32-32-32z m-28 160h-100V462h100v100zM590 402H434c-17.67 0-32 14.33-32 32v156c0 17.67 14.33 32 32 32h156c17.67 0 32-14.33 32-32V434c0-17.67-14.33-32-32-32z m-28 160H462V462h100v100z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateRepeatY extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M590 132.14H434c-17.67 0-32 14.33-32 32v156c0 17.67 14.33 32 32 32h156c17.67 0 32-14.33 32-32v-156c0-17.68-14.33-32-32-32z m-28 160H462v-100h100v100zM590 402H434c-17.67 0-32 14.33-32 32v156c0 17.67 14.33 32 32 32h156c17.67 0 32-14.33 32-32V434c0-17.67-14.33-32-32-32z m-28 160H462V462h100v100zM590 671.86H434c-17.67 0-32 14.33-32 32v156c0 17.67 14.33 32 32 32h156c17.67 0 32-14.33 32-32v-156c0-17.67-14.33-32-32-32z m-28 160H462v-100h100v100z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateTextBaseline extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M859.9 852H548.38V714.52l77.63 77.25c3.12 3.12 8.19 3.12 11.31 0l39.6-39.6c3.12-3.12 3.12-8.19 0-11.31L534.88 599.2c-12.5-12.5-32.76-12.5-45.25 0L348.08 740.74c-3.12 3.12-3.12 8.19 0 11.31l39.6 39.6c3.12 3.12 8.19 3.12 11.31 0l77.38-77.38V852H164.1c-4.5 0-8.1 2.84-8.1 6.32v47.37c0 3.47 3.6 6.32 8.1 6.32h695.8c4.5 0 8.1-2.84 8.1-6.32v-47.37c0-3.48-3.6-6.32-8.1-6.32zM859.9 112H164.1c-4.5 0-8.1 2.84-8.1 6.32v47.37c0 3.47 3.6 6.32 8.1 6.32h312.53v137.48L399 232.23c-3.12-3.12-8.19-3.12-11.31 0l-39.6 39.6c-3.12 3.12-3.12 8.19 0 11.31L490.13 424.8c12.5 12.5 32.76 12.5 45.25 0l141.54-141.54c3.12-3.12 3.12-8.19 0-11.31l-39.6-39.6c-3.12-3.12-8.19-3.12-11.31 0l-77.38 77.38V172H859.9c4.5 0 8.1-2.84 8.1-6.32v-47.37c0-3.47-3.6-6.31-8.1-6.31zM859.9 474H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateTextAlignCenter extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M534.88 599.2c-12.5-12.5-32.76-12.5-45.25 0L320.61 768.21c-3.12 3.12-3.12 8.19 0 11.31l39.6 39.6c3.12 3.12 8.19 3.12 11.31 0l104.85-104.85v237.87c0 4.42 3.58 8 8 8h56c4.42 0 8-3.58 8-8V714.52l105.05 104.66c3.12 3.12 8.19 3.12 11.31 0l39.6-39.6c3.12-3.12 3.12-8.19 0-11.31L534.88 599.2zM490.07 424.05c12.5 12.5 32.76 12.5 45.25 0l169.01-169.01c3.12-3.12 3.12-8.19 0-11.31l-39.6-39.6c-3.12-3.12-8.19-3.12-11.31 0L548.57 308.98V71.11c0-4.42-3.58-8-8-8h-56c-4.42 0-8 3.58-8 8v237.61L371.53 204.06c-3.12-3.12-8.19-3.12-11.31 0l-39.6 39.6c-3.12 3.12-3.12 8.19 0 11.31l169.45 169.08zM859.9 473.83H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateTextLeft extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M904 160H120c-4.4 0-8 4.32-8 9.6v76.8c0 5.28 3.6 9.6 8 9.6h784c4.4 0 8-4.32 8-9.6v-76.8c0-5.28-3.6-9.6-8-9.6zM904 768H120c-4.4 0-8 4.32-8 9.6v76.8c0 5.28 3.6 9.6 8 9.6h784c4.4 0 8-4.32 8-9.6v-76.8c0-5.28-3.6-9.6-8-9.6zM116 560h392c2.2 0 4-4.32 4-9.6v-76.8c0-5.28-1.8-9.6-4-9.6H116c-2.2 0-4 4.32-4 9.6v76.8c0 5.28 1.8 9.6 4 9.6z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateTextCenter extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M904 160H120c-4.4 0-8 4.32-8 9.6v76.8c0 5.28 3.6 9.6 8 9.6h784c4.4 0 8-4.32 8-9.6v-76.8c0-5.28-3.6-9.6-8-9.6zM904 768H120c-4.4 0-8 4.32-8 9.6v76.8c0 5.28 3.6 9.6 8 9.6h784c4.4 0 8-4.32 8-9.6v-76.8c0-5.28-3.6-9.6-8-9.6zM708 560c2.2 0 4-4.32 4-9.6v-76.8c0-5.28-1.8-9.6-4-9.6H316c-2.2 0-4 4.32-4 9.6v76.8c0 5.28 1.8 9.6 4 9.6h392z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateTextRight extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M904 160H120c-4.4 0-8 4.32-8 9.6v76.8c0 5.28 3.6 9.6 8 9.6h784c4.4 0 8-4.32 8-9.6v-76.8c0-5.28-3.6-9.6-8-9.6zM904 768H120c-4.4 0-8 4.32-8 9.6v76.8c0 5.28 3.6 9.6 8 9.6h784c4.4 0 8-4.32 8-9.6v-76.8c0-5.28-3.6-9.6-8-9.6zM908 464H516c-2.2 0-4 4.32-4 9.6v76.8c0 5.28 1.8 9.6 4 9.6h392c2.2 0 4-4.32 4-9.6v-76.8c0-5.28-1.8-9.6-4-9.6z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateTextJustify extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M904 160H120c-4.4 0-8 4.32-8 9.6v76.8c0 5.28 3.6 9.6 8 9.6h784c4.4 0 8-4.32 8-9.6v-76.8c0-5.28-3.6-9.6-8-9.6zM904 768H120c-4.4 0-8 4.32-8 9.6v76.8c0 5.28 3.6 9.6 8 9.6h784c4.4 0 8-4.32 8-9.6v-76.8c0-5.28-3.6-9.6-8-9.6zM904 464H120c-4.4 0-8 4.32-8 9.6v76.8c0 5.28 3.6 9.6 8 9.6h784c4.4 0 8-4.32 8-9.6v-76.8c0-5.28-3.6-9.6-8-9.6z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateStatic extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M880.14 111.94h-736c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32v-736c0-17.7-14.3-32-32-32z m-696 72h136v656h-136v-656z m656 656.01h-456v-456h456v456z m-456-520v-136h456v136h-456z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateRelative extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M905 112.14H499c-4.4 0-8 4.32-8 9.6v52.8c0 5.28 3.6 9.6 8 9.6h167v236c0 4.4 4.32 8 9.6 8h52.8c5.28 0 9.6-3.6 9.6-8v-236h167c4.4 0 8-4.32 8-9.6v-52.8c0-5.28-3.6-9.6-8-9.6zM417.56 665.14h-236v-167c0-4.4-4.32-8-9.6-8h-52.8c-5.28 0-9.6 3.6-9.6 8v406c0 4.4 4.32 8 9.6 8h52.8c5.28 0 9.6-3.6 9.6-8v-167h236c4.4 0 8-4.32 8-9.6v-52.8c0-5.28-3.6-9.6-8-9.6zM912 532.14v-8c0-9.36-4.02-17.79-10.43-23.64l-0.21-0.18c-0.63-0.56-1.28-1.1-1.96-1.62a32.079 32.079 0 0 0-4.86-3.06c-0.48-0.24-0.96-0.48-1.45-0.7-4-1.8-8.43-2.8-13.1-2.8H524c-17.67 0-32 14.33-32 32v356c0 17.67 14.33 32 32 32h356c17.67 0 32-14.33 32-32v-348z m-348 32h276v276H564v-276z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateAbsolute extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M905 112.14H499c-4.4 0-8 4.32-8 9.6v52.8c0 5.28 3.6 9.6 8 9.6h167v236c0 4.4 4.32 8 9.6 8h52.8c5.28 0 9.6-3.6 9.6-8v-236h167c4.4 0 8-4.32 8-9.6v-52.8c0-5.28-3.6-9.6-8-9.6z"></path>
      <path d="M902.4 248.14h-52.8c-5.28 0-9.6 3.6-9.6 8v164c0 4.4 4.32 8 9.6 8h52.8c5.28 0 9.6-3.6 9.6-8v-164c0-4.4-4.32-8-9.6-8zM901.57 500.5l-0.21-0.18c-0.63-0.56-1.28-1.1-1.96-1.62a32.079 32.079 0 0 0-4.86-3.06c-0.48-0.24-0.96-0.48-1.45-0.7-4-1.8-8.43-2.8-13.1-2.8H524c-17.67 0-32 14.33-32 32v356c0 17.67 14.33 32 32 32h356c17.67 0 32-14.33 32-32v-356c0-9.37-4.02-17.79-10.43-23.64zM840 840.14H564v-276h276v276zM121.6 418.14h52.8c5.28 0 9.6-3.6 9.6-8v-226h235c4.4 0 8-4.32 8-9.6v-52.8c0-5.28-3.6-9.6-8-9.6H120c-2.09 0-4 0.98-5.43 2.57-1.59 1.43-2.57 3.33-2.57 5.43v290c0 4.4 4.32 8 9.6 8zM420 593.14H184v-103c0-4.4-4.32-8-9.6-8h-52.8c-5.28 0-9.6 3.6-9.6 8v278c0 4.4 4.32 8 9.6 8h52.8c5.28 0 9.6-3.6 9.6-8v-103h236c4.4 0 8-4.32 8-9.6v-52.8c0-5.28-3.6-9.6-8-9.6zM420 840.14H120c-4.4 0-8 4.32-8 9.6v52.8c0 5.28 3.6 9.6 8 9.6h300c4.4 0 8-4.32 8-9.6v-52.8c0-5.28-3.6-9.6-8-9.6z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateFixed extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M909.2 130.85a32.742 32.742 0 0 0-3.3-5.69c-0.15-0.21-0.3-0.42-0.46-0.62a30.06 30.06 0 0 0-1.62-1.96l-0.18-0.21c-5.85-6.41-14.27-10.43-23.64-10.43H144c-0.57 0-1.14 0.02-1.7 0.05l-0.41 0.03c-0.43 0.03-0.86 0.06-1.28 0.1-0.13 0.01-0.26 0.03-0.4 0.05-0.43 0.05-0.86 0.11-1.28 0.17l-0.32 0.06c-0.45 0.08-0.9 0.16-1.34 0.25-0.08 0.02-0.16 0.04-0.23 0.05-0.47 0.11-0.94 0.22-1.41 0.35-0.05 0.01-0.09 0.03-0.14 0.04-0.5 0.14-0.99 0.28-1.47 0.44-0.02 0.01-0.05 0.02-0.07 0.02-0.51 0.17-1.01 0.35-1.51 0.54-0.01 0-0.01 0-0.02 0.01-0.51 0.2-1.01 0.41-1.51 0.63-0.49 0.22-0.97 0.45-1.45 0.69-0.69 0.35-1.36 0.73-2.01 1.13-0.2 0.12-0.4 0.26-0.6 0.38-0.46 0.29-0.91 0.59-1.36 0.91l-0.27 0.18c-0.21 0.15-0.42 0.3-0.62 0.46l-0.15 0.12c-0.62 0.48-1.22 0.97-1.81 1.49l-0.21 0.18c-0.39 0.35-0.77 0.72-1.14 1.09-0.08 0.08-0.15 0.16-0.23 0.24-0.29 0.3-0.58 0.6-0.86 0.91-0.1 0.11-0.2 0.23-0.3 0.35-0.25 0.28-0.49 0.57-0.73 0.86l-0.33 0.42c-0.22 0.28-0.43 0.55-0.64 0.83-0.12 0.16-0.23 0.32-0.34 0.47-0.19 0.27-0.39 0.55-0.57 0.83-0.11 0.17-0.22 0.34-0.33 0.52-0.17 0.27-0.35 0.55-0.51 0.83-0.11 0.18-0.21 0.37-0.32 0.55-0.16 0.28-0.31 0.56-0.46 0.84-0.1 0.19-0.2 0.39-0.3 0.59-0.14 0.28-0.28 0.56-0.41 0.85-0.09 0.2-0.19 0.41-0.28 0.61-0.12 0.28-0.25 0.57-0.36 0.86a30.186 30.186 0 0 0-0.56 1.51c-0.08 0.22-0.15 0.44-0.22 0.66-0.1 0.3-0.18 0.59-0.27 0.89-0.06 0.22-0.13 0.45-0.19 0.67-0.08 0.3-0.15 0.61-0.22 0.92-0.05 0.23-0.11 0.45-0.16 0.68-0.07 0.31-0.12 0.63-0.18 0.95l-0.12 0.68c-0.05 0.33-0.09 0.67-0.13 1-0.03 0.22-0.06 0.43-0.08 0.65-0.04 0.37-0.06 0.75-0.09 1.13-0.01 0.18-0.03 0.36-0.04 0.55-0.03 0.56-0.05 1.13-0.05 1.7v736c0 17.67 14.33 32 32 32h736c17.67 0 32-14.33 32-32v-736a32.11 32.11 0 0 0-2.81-13.06zM408 375.95h-32v464H184v-656h656v192H408z m200 464H448v-160h160v160z m0-232H448v-160h160v160z m232 232H680v-160h160v160z m0-232H680v-160h160v160z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateSticky extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M880.12 112.61h-736c-17.67 0-32 14.33-32 32v736c0 17.67 14.33 32 32 32h736c17.67 0 32-14.33 32-32v-736c0-17.67-14.32-32-32-32z m-696 72h656v307.53H524c-17.67 0-32 14.33-32 32v316.47H184.12v-656zM564 840.14v-276h276v276H564z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateLeftFloat extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M537.57 168.5l-0.21-0.18c-0.63-0.56-1.28-1.1-1.96-1.62a32.079 32.079 0 0 0-4.86-3.06c-0.48-0.24-0.96-0.48-1.45-0.7-4-1.8-8.43-2.8-13.1-2.8H144c-17.67 0-32 14.33-32 32v640c0 17.67 14.33 32 32 32h372c17.67 0 32-14.33 32-32v-640c0-9.37-4.02-17.79-10.43-23.64zM476 792.14H184v-560h292v560zM904 160H622c-4.4 0-8 4.32-8 9.6v76.8c0 5.28 3.6 9.6 8 9.6h282c4.4 0 8-4.32 8-9.6v-76.8c0-5.28-3.6-9.6-8-9.6zM904 464H622c-4.4 0-8 4.32-8 9.6v76.8c0 5.28 3.6 9.6 8 9.6h282c4.4 0 8-4.32 8-9.6v-76.8c0-5.28-3.6-9.6-8-9.6zM788 768H618c-2.2 0-4 4.32-4 9.6v76.8c0 5.28 1.8 9.6 4 9.6h170c2.2 0 4-4.32 4-9.6v-76.8c0-5.28-1.8-9.6-4-9.6z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateRightFloat extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M880 160.14H508c-4.67 0-9.1 1.01-13.1 2.8a32.742 32.742 0 0 0-5.69 3.3c-0.21 0.15-0.42 0.3-0.62 0.46-0.67 0.51-1.33 1.05-1.96 1.62l-0.21 0.18c-6.41 5.85-10.43 14.27-10.43 23.64v640c0 17.67 14.33 32 32 32h372c17.67 0 32-14.33 32-32v-640c0.01-17.68-14.32-32-31.99-32z m-40 632H548v-560h292v560zM402 160H120c-4.4 0-8 4.32-8 9.6v76.8c0 5.28 3.6 9.6 8 9.6h282c4.4 0 8-4.32 8-9.6v-76.8c0-5.28-3.6-9.6-8-9.6zM402 464H120c-4.4 0-8 4.32-8 9.6v76.8c0 5.28 3.6 9.6 8 9.6h282c4.4 0 8-4.32 8-9.6v-76.8c0-5.28-3.6-9.6-8-9.6zM406 768H236c-2.2 0-4 4.32-4 9.6v76.8c0 5.28 1.8 9.6 4 9.6h170c2.2 0 4-4.32 4-9.6v-76.8c0-5.28-1.8-9.6-4-9.6z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateLeftClear extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M537.57 532.5l-0.21-0.18c-0.63-0.56-1.28-1.1-1.96-1.62a32.079 32.079 0 0 0-4.86-3.06c-0.48-0.24-0.96-0.48-1.45-0.7-4-1.8-8.43-2.8-13.1-2.8H144c-17.67 0-32 14.33-32 32v276c0 17.67 14.33 32 32 32h372c17.67 0 32-14.33 32-32v-276c0-9.37-4.02-17.79-10.43-23.64zM476 792.14H184v-196h292v196zM916.43 305.85l-141.7-112c-5.2-4.1-12.9-0.4-12.9 6.3v74.1H112.5c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h649.23v73.9c0 6.7 7.7 10.4 12.9 6.3l141.8-112c4.1-3.2 4.1-9.4 0-12.6zM904 524.14H622c-4.4 0-8 4.32-8 9.6v76.8c0 5.28 3.6 9.6 8 9.6h282c4.4 0 8-4.32 8-9.6v-76.8c0-5.28-3.6-9.6-8-9.6zM904 768H622c-4.4 0-8 4.32-8 9.6v76.8c0 5.28 3.6 9.6 8 9.6h282c4.4 0 8-4.32 8-9.6v-76.8c0-5.28-3.6-9.6-8-9.6z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateRightClear extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M537.57 532.5l-0.21-0.18c-0.63-0.56-1.28-1.1-1.96-1.62a32.079 32.079 0 0 0-4.86-3.06c-0.48-0.24-0.96-0.48-1.45-0.7-4-1.8-8.43-2.8-13.1-2.8H144c-17.67 0-32 14.33-32 32v276c0 17.67 14.33 32 32 32h372c17.67 0 32-14.33 32-32v-276c0-9.37-4.02-17.79-10.43-23.64zM476 792.14H184v-196h292v196zM911.5 274.25H262.17v-74.1c0-6.7-7.7-10.4-12.9-6.3l-141.7 112c-4.1 3.2-4.1 9.4 0 12.6l141.8 112c5.2 4.1 12.9 0.4 12.9-6.3v-73.9H911.5c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM904 524.14H622c-4.4 0-8 4.32-8 9.6v76.8c0 5.28 3.6 9.6 8 9.6h282c4.4 0 8-4.32 8-9.6v-76.8c0-5.28-3.6-9.6-8-9.6zM904 768H622c-4.4 0-8 4.32-8 9.6v76.8c0 5.28 3.6 9.6 8 9.6h282c4.4 0 8-4.32 8-9.6v-76.8c0-5.28-3.6-9.6-8-9.6z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateBothClear extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M537.57 532.5l-0.21-0.18c-0.63-0.56-1.28-1.1-1.96-1.62a32.079 32.079 0 0 0-4.86-3.06c-0.48-0.24-0.96-0.48-1.45-0.7-4-1.8-8.43-2.8-13.1-2.8H144c-17.67 0-32 14.33-32 32v276c0 17.67 14.33 32 32 32h372c17.67 0 32-14.33 32-32v-276c0-9.37-4.02-17.79-10.43-23.64zM476 792.14H184v-196h292v196zM262.27 424.15v-73.9H471.5c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H262.17v-74.1c0-6.7-7.7-10.4-12.9-6.3l-141.7 112c-4.1 3.2-4.1 9.4 0 12.6l141.8 112c5.2 4.1 12.9 0.4 12.9-6.3zM920.93 305.85l-141.7-112c-5.2-4.1-12.9-0.4-12.9 6.3v74.1H557c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h209.23v73.9c0 6.7 7.7 10.4 12.9 6.3l141.8-112c4.1-3.2 4.1-9.4 0-12.6zM904 524.14H622c-4.4 0-8 4.32-8 9.6v76.8c0 5.28 3.6 9.6 8 9.6h282c4.4 0 8-4.32 8-9.6v-76.8c0-5.28-3.6-9.6-8-9.6zM904 768H622c-4.4 0-8 4.32-8 9.6v76.8c0 5.28 3.6 9.6 8 9.6h282c4.4 0 8-4.32 8-9.6v-76.8c0-5.28-3.6-9.6-8-9.6z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateColorFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M766.4 744.3c43.7 0 79.4-36.2 79.4-80.5 0-53.5-79.4-140.8-79.4-140.8S687 610.3 687 663.8c0 44.3 35.7 80.5 79.4 80.5z m-377.1-44.1c7.1 7.1 18.6 7.1 25.6 0l256.1-256c7.1-7.1 7.1-18.6 0-25.6l-256-256c-0.6-0.6-1.3-1.2-2-1.7l-78.2-78.2c-3.5-3.5-9.3-3.5-12.8 0l-48 48c-3.5 3.5-3.5 9.3 0 12.8l67.2 67.2-207.8 207.9c-7.1 7.1-7.1 18.6 0 25.6l255.9 256z m12.9-448.6l178.9 178.9H223.4l178.8-178.9zM904 816H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MaterialFire extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M834.1 469.2c-19.5-43.8-47.4-82.6-82.9-115.2l-29.1-26.7c-4.3-3.8-11.1-2.1-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8-1.4 1.5-3 1.9-4.1 2s-2.8-0.1-4.3-1.5c-1.4-1.2-2.1-3-2-4.8 3.7-60.2-14.3-128.1-53.7-202C555.3 171 510 123.1 453.4 89.7l-41.3-24.3c-5.4-3.2-12.3 1-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9-11 29.5-26.8 56.9-47 81.5-14.2 17.2-30.1 32.7-47.5 46.1-42.1 32.3-76.8 74.4-100.3 121.5C172.5 503.3 160 556.6 160 610c0 47.2 9.3 92.9 27.7 136 17.8 41.5 43.2 78.9 75.5 110.9 32.4 32 70 57.2 111.9 74.7C418.5 949.8 464.5 959 512 959s93.5-9.2 136.9-27.3c41.9-17.5 79.6-42.6 111.9-74.7 32.4-32 57.8-69.4 75.5-110.9 18.4-43.1 27.7-88.8 27.7-136 0-48.8-10-96.2-29.9-140.9zM713 808.5c-53.7 53.2-125 82.4-201 82.4s-147.3-29.2-201-82.4c-53.5-53.1-83-123.5-83-198.4 0-43.5 9.8-85.2 29.1-124 18.8-37.9 46.8-71.8 80.8-97.9 21.5-16.4 41.2-35.5 58.6-56.8 25-30.5 44.6-64.5 58.2-101 5.4-14.5 9.5-30 12.1-46.5 24.1 22.2 44.3 49 61.2 80.4 33.4 62.6 48.8 118.3 45.8 165.7-1.4 22.8 7.5 44.5 24.4 59.8 14.7 13.2 33.7 19.9 53.4 18.8 19.7-1 37.8-9.7 51-24.4 13.3-14.9 24.8-30.1 34.4-45.6 14 17.9 25.7 37.4 35 58.4 15.9 35.8 24 73.9 24 113.1 0 74.9-29.5 145.4-83 198.4z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateOutline extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M920 760H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z m0-568H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z m0 284H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM216 712H100c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h72.4v20.5h-35.7c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h35.7V838H100c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h116c2.2 0 4-1.8 4-4V716c0-2.2-1.8-4-4-4zM100 188h38v120c0 2.2 1.8 4 4 4h40c2.2 0 4-1.8 4-4V152c0-4.4-3.6-8-8-8h-78c-2.2 0-4 1.8-4 4v36c0 2.2 1.8 4 4 4z m116 240H100c-2.2 0-4 1.8-4 4v36c0 2.2 1.8 4 4 4h68.4l-70.3 77.7c-1.3 1.5-2.1 3.4-2.1 5.4V592c0 2.2 1.8 4 4 4h116c2.2 0 4-1.8 4-4v-36c0-2.2-1.8-4-4-4h-68.4l70.3-77.7c1.3-1.5 2.1-3.4 2.1-5.4V432c0-2.2-1.8-4-4-4z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateSchema extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M661.2 168.7h-67.5c-3.4 0-6.5 2.2-7.6 5.4L354.7 846c-0.3 0.8-0.4 1.7-0.4 2.6 0 4.4 3.6 8 8 8h67.8c3.4 0 6.5-2.2 7.6-5.4l0.7-2.1 223.1-648.3 7.4-21.4c0.3-0.8 0.4-1.7 0.4-2.6-0.1-4.5-3.6-8.1-8.1-8.1z m293.4 333.4c-0.8-1-1.7-1.9-2.7-2.7l-219-171.3c-3.5-2.7-8.5-2.1-11.2 1.4-1.1 1.4-1.7 3.1-1.7 4.9v81.3c0 2.5 1.1 4.8 3.1 6.3l115 90-115 90c-1.9 1.5-3.1 3.8-3.1 6.3v81.3c0 4.4 3.6 8 8 8 1.8 0 3.5-0.6 4.9-1.7l219-171.3c6.9-5.4 8.2-15.5 2.7-22.5z m-663.5-174l-219 171.3c-1 0.8-1.9 1.7-2.7 2.7-5.4 7-4.2 17 2.7 22.5l219 171.3c1.4 1.1 3.1 1.7 4.9 1.7 4.4 0 8-3.6 8-8v-81.3c0-2.5-1.1-4.8-3.1-6.3l-115-90 115-90c1.9-1.5 3.1-3.8 3.1-6.3v-81.3c0-1.8-0.6-3.5-1.7-4.9-2.7-3.5-7.7-4.1-11.2-1.4z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateFunction extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M841 370c3-3.3 2.7-8.3-0.6-11.3-1.5-1.3-3.4-2.1-5.3-2.1h-72.6c-2.4 0-4.6 1-6.1 2.8L633.5 504.6c-2.9 3.4-7.9 3.8-11.3 0.9-0.9-0.8-1.6-1.7-2.1-2.8l-63.5-141.3c-1.3-2.9-4.1-4.7-7.3-4.7H380.7l0.9-4.7 8-42.3c10.5-55.4 38-81.4 85.8-81.4 18.6 0 35.5 1.7 48.8 4.7l14.1-66.8c-22.6-4.7-35.2-6.1-54.9-6.1-103.3 0-156.4 44.3-175.9 147.3l-9.4 49.4h-97.6c-3.8 0-7.1 2.7-7.8 6.4L181.9 415c-0.9 4.3 1.9 8.6 6.2 9.5 0.5 0.1 1.1 0.2 1.6 0.2H284l-89 429.9c-0.9 4.3 1.9 8.6 6.2 9.5 0.5 0.1 1.1 0.2 1.6 0.2H269c3.8 0 7.1-2.7 7.8-6.4l89.7-433.1h135.8l68.2 139.1c1.4 2.9 1 6.4-1.2 8.8l-180.6 203c-2.9 3.3-2.6 8.4 0.7 11.3 1.5 1.3 3.4 2 5.3 2h72.7c2.4 0 4.6-1 6.1-2.8l123.7-146.7c2.8-3.4 7.9-3.8 11.3-1 0.9 0.8 1.6 1.7 2.1 2.8L676.4 784c1.3 2.8 4.1 4.7 7.3 4.7h64.6c4.4 0 8-3.6 8-8 0-1.2-0.3-2.4-0.8-3.5l-95.2-198.9c-1.4-2.9-0.9-6.4 1.3-8.8L841 370z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateComponent extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M800 450.85V280.14c0-17.67-14.33-32-32-32H619.82c-2.13-75.35-64.08-136-139.94-136s-137.81 60.65-139.94 136H192c-17.67 0-32 14.33-32 32v248.8c13.26-10.79 30.16-17.27 48.55-17.27 8.17 0 16.05 1.29 23.45 3.66 31.07 9.95 53.63 39.09 53.63 73.42s-22.56 63.48-53.63 73.42a76.717 76.717 0 0 1-23.45 3.66c-18.39 0-35.29-6.48-48.55-17.27v207.58c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V726.65c65.7-11.5 115.8-68.96 115.8-137.9 0-68.95-50.1-126.4-115.8-137.9z m0 211.06a76.644 76.644 0 0 1-24.2 3.91c-18.05 0-34.65-6.25-47.8-16.68v166.99H232v-89.36c66.07-11.19 116.55-68.82 116.55-138.03S298.07 461.9 232 450.71V320.14h211.63c-24.28-12.99-40.83-38.59-40.83-68 0-1.34 0.04-2.68 0.1-4 2.09-40.65 35.82-73.08 76.98-73.08s74.89 32.43 76.98 73.08c0.07 1.32 0.1 2.66 0.1 4 0 29.41-16.56 55.01-40.83 68H728v208.21c13.15-10.43 29.75-16.68 47.8-16.68 8.45 0 16.58 1.39 24.2 3.91 30.68 10.17 52.88 39.12 52.88 73.16 0 34.06-22.2 63-52.88 73.17z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class DirectionLeftCircle extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M603.3 327.5l-246 178c-4.4 3.2-4.4 9.7 0 12.9l246 178c5.3 3.8 12.7 0 12.7-6.5V643c0-10.2-4.9-19.9-13.2-25.9L457.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5z"></path>
      <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class DirectionRightCircle extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M666.7 505.5l-246-178c-5.3-3.8-12.7-0.1-12.7 6.5v46.9c0 10.2 4.9 19.9 13.2 25.9L566.6 512 421.2 617.2c-8.3 6-13.2 15.6-13.2 25.9V690c0 6.5 7.4 10.3 12.7 6.5l246-178c4.4-3.2 4.4-9.8 0-13z"></path>
      <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class DirectionUpCircle extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M518.5 360.3c-3.2-4.4-9.7-4.4-12.9 0l-178 246c-3.8 5.3 0 12.7 6.5 12.7H381c10.2 0 19.9-4.9 25.9-13.2L512 460.4l105.2 145.4c6 8.3 15.6 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.5-12.7l-178-246z"></path>
      <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class DirectionDownCircle extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M690 405h-46.9c-10.2 0-19.9 4.9-25.9 13.2L512 563.6 406.8 418.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246c3.2 4.4 9.7 4.4 12.9 0l178-246c3.9-5.3 0.1-12.7-6.4-12.7z"></path>
      <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalFilter extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 597.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V597.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.4 798H420.6V642h182.9v156h-0.1z m9.6-236.6l-9.5 16.6h-183l-9.5-16.6L212.7 226h598.6L613 561.4z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalRotateRight extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M480.5 251.2c13-1.6 25.9-2.4 38.8-2.5v63.9c0 6.5 7.5 10.1 12.6 6.1L660 217.6c4-3.2 4-9.2 0-12.3l-128-101c-5.1-4-12.6-0.4-12.6 6.1l-0.2 64c-118.6 0.5-235.8 53.4-314.6 154.2-69.6 89.2-95.7 198.6-81.1 302.4h74.9c-0.9-5.3-1.7-10.7-2.4-16.1-5.1-42.1-2.1-84.1 8.9-124.8 11.4-42.2 31-81.1 58.1-115.8 27.2-34.7 60.3-63.2 98.4-84.3 37-20.6 76.9-33.6 119.1-38.8z"></path>
      <path d="M880 418H352c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32z m-44 402H396V494h440v326z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalAppStore extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16z m-52 268H212V212h200v200z m452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16z m-52 268H612V212h200v200zM464 544H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16z m-52 268H212V612h200v200z m452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16z m-52 268H612V612h200v200z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class DirectionArrowUp extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M882.01 536.39L535.47 159.33c-12.66-13.78-34.27-13.78-46.94 0L141.99 536.39c-4.52 4.92-0.85 12.61 6.02 12.61h90.63c2.31 0 4.5-0.95 6.02-2.6L474 296.88v570.11c0 4.42 3.58 8.01 8.01 8.01H542c4.42 0 8.01-3.58 8.01-8.01V296.88L779.33 546.4c1.52 1.65 3.72 2.6 6.03 2.6h90.63c6.87 0 10.54-7.69 6.02-12.61z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class DirectionArrowDown extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M882.01 487.61L535.47 864.67c-12.66 13.78-34.27 13.78-46.94 0L141.99 487.61c-4.52-4.92-0.85-12.61 6.02-12.61h90.63c2.31 0 4.5 0.95 6.02 2.6L474 727.12V157.01c0-4.42 3.58-8.01 8.01-8.01H542c4.42 0 8.01 3.58 8.01 8.01v570.11L779.33 477.6c1.52-1.65 3.72-2.6 6.03-2.6h90.63c6.87 0 10.54 7.69 6.02 12.61z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class DirectionLeftFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M448.07 227.27L120.5 493.77c-11.34 9.22-11.34 27.24 0 36.47l327.57 266.49c9.86 8.02 23.93 0.39 23.93-12.98V612h430.36c5.33 0 9.64-4.32 9.64-9.64V421.64c0-5.33-4.32-9.65-9.64-9.65H472V240.25c0-13.37-14.07-21-23.93-12.98z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class DirectionRightFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M575.93 227.27l327.57 266.5c11.34 9.22 11.34 27.24 0 36.47L575.93 796.73c-9.86 8.02-23.93 0.39-23.93-12.98V612H121.64c-5.33 0-9.64-4.32-9.64-9.64V421.64c0-5.33 4.32-9.65 9.64-9.65H552V240.25c0-13.37 14.07-21 23.93-12.98z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateExport extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M888.3 757.4h-53.8c-4.2 0-7.7 3.5-7.7 7.7v61.8H197.1V197.1h629.8v61.8c0 4.2 3.5 7.7 7.7 7.7h53.8c4.2 0 7.7-3.4 7.7-7.7V158.7c0-17-13.7-30.7-30.7-30.7H158.7c-17 0-30.7 13.7-30.7 30.7v706.6c0 17 13.7 30.7 30.7 30.7h706.6c17 0 30.7-13.7 30.7-30.7V765.1c0-4.3-3.5-7.7-7.7-7.7z"></path>
      <path d="M430.02 484v56c0 4.4 3.6 8 8 8h314v76c0 6.7 7.7 10.5 13 6.3l141.9-112c4.1-3.2 4.1-9.4 0-12.6l-141.9-112c-5.2-4.2-13-0.4-13 6.3v76h-314c-4.4 0-8 3.6-8 8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateProject extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M908 640H804V488c0-4.4-3.6-8-8-8H548v-96h108c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h108v96H228c-4.4 0-8 3.6-8 8v152H116c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V656c0-8.8-7.2-16-16-16H292v-88h440v88H620c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V656c0-8.8-7.2-16-16-16z m-564 76v168H176V716h168z m84-408V140h168v168H428z m420 576H680V716h168v168z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalPauseCircle extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path>
      <path d="M424 352h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z m224 0h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalPlayShopping extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M722.5 488.21c-123.6 0-223.81 100.22-223.81 223.81 0 123.6 100.22 223.81 223.81 223.81s223.81-100.22 223.81-223.81c0.01-123.59-100.21-223.81-223.81-223.81z m0 383.63c-88.24 0-159.81-71.57-159.81-159.81 0-88.24 71.57-159.81 159.81-159.81 88.24 0 159.81 71.57 159.81 159.81 0.01 88.24-71.57 159.81-159.81 159.81z"></path>
      <path d="M820.64 688.43l-125.02-72.15c-8.41-4.85-18.85-4.85-27.25 0-8.41 4.85-13.63 13.89-13.63 23.59v144.31c0 9.7 5.22 18.74 13.63 23.59 4.2 2.43 8.92 3.64 13.63 3.64s9.43-1.21 13.63-3.64l125.02-72.15c8.41-4.85 13.63-13.89 13.63-23.59-0.01-9.71-5.23-18.75-13.64-23.6z m-116.45 64.89v-82.58l71.54 41.29-71.54 41.29z"></path>
      <path d="M444.5 816.16H212v-456h96v42c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-42h224v42c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-42h96v80.14c0 4.42 3.58 8 8 8h56c4.42 0 8-3.58 8-8V320.16c0-17.67-14.33-32-32-32H676v-14.42c0-101.36-82.93-185.73-184.28-185.58-101.47 0.16-183.72 82.5-183.72 184v16H172c-17.67 0-32 14.33-32 32v536c0 17.67 14.33 32 32 32h272.5c4.42 0 8-3.58 8-8v-56c0-4.42-3.58-8-8-8z m-64.5-544c0-61.9 50.1-112 112-112s112 50.1 112 112v16H380v-16z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalTimeCircle extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path>
      <path d="M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandKeyword extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M512 136.66c50.66 0 99.76 9.91 145.94 29.44 44.65 18.88 84.76 45.93 119.22 80.4 34.46 34.46 61.51 74.57 80.4 119.22C877.09 411.9 887 461 887 511.66s-9.91 99.76-29.44 145.95c-18.88 44.65-45.93 84.76-80.4 119.22-34.46 34.46-74.57 61.51-119.22 80.4-46.19 19.53-95.29 29.44-145.94 29.44s-99.76-9.91-145.94-29.44c-44.65-18.88-84.76-45.93-119.22-80.4-34.46-34.46-61.51-74.57-80.4-119.22C146.91 611.42 137 562.32 137 511.66s9.91-99.76 29.44-145.95c18.88-44.65 45.93-84.76 80.4-119.22 34.46-34.46 74.57-61.51 119.22-80.4 46.18-19.52 95.28-29.43 145.94-29.43m0-72c-246.87 0-447 200.13-447 447s200.13 447 447 447 447-200.13 447-447-200.13-447-447-447z"></path>
      <path d="M431.89 659.8l-8.74-38.92c-0.24-1.2-0.72-2.28-1.32-3.23-2.99-4.43-8.86-5.63-13.29-2.63l-27.91 18.68V446.86c0-5.27-4.31-9.58-9.58-9.58h-97.01c-5.27 0-9.58 4.31-9.58 9.58v43.12c0 5.27 4.31 9.58 9.58 9.58h44.31v230.43c0 2.04 0.6 3.95 1.8 5.63 3.11 4.31 9.1 5.27 13.41 2.16l94.62-68.03c3.11-2.28 4.54-6.11 3.71-9.95z m-67.91-259.41l0.24 0.24c3.83 3.59 9.94 3.35 13.53-0.6l28.86-31.38c3.47-3.83 3.35-9.7-0.36-13.41l-64.31-62.4c-3.71-3.59-9.7-3.59-13.41 0.12l-29.58 29.58c-3.71 3.71-3.71 9.82 0.12 13.53l64.91 64.32zM634.82 458.13H467.4c-4.42 0-8-3.58-8-8v-46.34c0-4.42 3.58-8 8-8h167.42c4.42 0 8 3.58 8 8v46.34c0 4.42-3.58 8-8 8zM579.28 489.3h-103.1c-5.3 0-9.59 4.29-9.59 9.59v151.05c0 5.3 4.29 9.59 9.59 9.59h151.05c5.3 0 9.59-4.29 9.59-9.59V498.89c0-5.3-4.29-9.59-9.59-9.59h-47.95z m0 112.69h-55.15v-55.15h55.15v55.15z"></path>
      <path d="M665.6 301.08H452.2c-5.3 0-9.59 4.29-9.59 9.59v43.16c0 5.3 4.29 9.59 9.59 9.59h213.4v321.29h-57.16c-7.5 0-12.1 8.23-8.17 14.62l26.56 43.16a9.588 9.588 0 0 0 8.17 4.56h83.36c5.3 0 9.59-4.29 9.59-9.59V310.67c0-5.3-4.29-9.59-9.59-9.59H665.6z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalTeam extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M824.2 699.9c-25.4-25.4-54.7-45.7-86.4-60.4C783.1 602.8 812 546.8 812 484c0-110.8-92.4-201.7-203.2-200-109.1 1.7-197 90.6-197 200 0 62.8 29 118.8 74.2 155.5-31.7 14.7-60.9 34.9-86.4 60.4C345 754.6 314 826.8 312 903.8c-0.1 4.5 3.5 8.2 8 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5C493.8 707.7 551.1 684 612 684c60.9 0 118.2 23.7 161.3 66.8C814.5 792 838 846.3 840 904.3c0.1 4.3 3.7 7.7 8 7.7h56c4.5 0 8.1-3.7 8-8.2-2-77-33-149.2-87.8-203.9zM612 612c-34.2 0-66.4-13.3-90.5-37.5-24.5-24.5-37.9-57.1-37.5-91.8 0.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-0.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4 0 34.2-13.3 66.3-37.5 90.5-24.2 24.2-56.4 37.5-90.6 37.5z"></path>
      <path d="M361.5 510.4c-0.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5 0.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1-25.8-25.2-39.7-59.3-38.7-95.4 0.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9 0.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-0.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.9-1.7-203.3 89.2-203.3 199.9 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204-0.1 4.5 3.5 8.2 8 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.9-1 6.5-4.7 6-8.7z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalReport extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M312.1 591.5c3.1 3.1 8.2 3.1 11.3 0l101.8-101.8 86.1 86.2c3.1 3.1 8.2 3.1 11.3 0l226.3-226.5c3.1-3.1 3.1-8.2 0-11.3l-36.8-36.8c-3.1-3.1-8.2-3.1-11.3 0L517 485.3l-86.1-86.2c-3.1-3.1-8.2-3.1-11.3 0L275.3 543.4c-3.1 3.1-3.1 8.2 0 11.3l36.8 36.8z"></path>
      <path d="M904 160H548V96c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H120c-17.7 0-32 14.3-32 32v520c0 17.7 14.3 32 32 32h356.4v32L311.6 884.1c-3.7 2.4-4.7 7.3-2.3 11l30.3 47.2v0.1c2.4 3.7 7.4 4.7 11.1 2.3L512 838.9l161.3 105.8c3.7 2.4 8.7 1.4 11.1-2.3v-0.1l30.3-47.2c2.4-3.7 1.3-8.6-2.3-11L548 776.3V744h356c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32z m-40 512H160V232h704v440z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalUnorderedList extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M912 760H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM912 476H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"></path>
      <path d="M160 228m-56 0a56 56 0 1 0 112 0 56 56 0 1 0-112 0Z"></path>
      <path d="M160 512m-56 0a56 56 0 1 0 112 0 56 56 0 1 0-112 0Z"></path>
      <path d="M160 796m-56 0a56 56 0 1 0 112 0 56 56 0 1 0-112 0Z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandSubsidy extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M637.08 171.4zM571.43 269.33h-0.03c-19.53-2.9-39.36-4.37-59.4-4.37 20.06 0 39.89 1.47 59.43 4.37zM638.74 468.99c-0.1-4.4-3.7-8-8.1-8h-59.5c-3 0-6.18 2.22-7.48 4.92l-48.47 97.16h-3.4l-50.76-97.69c-1.4-2.7-4.1-4.4-7.1-4.4h-60.7c-1.3 0-2.6 0.3-3.8 1-3.9 2.1-5.3 7-3.2 10.9l71.56 122.49h-61.4c-4.4 0-8 3.6-8 8v29.9c0 4.4 3.6 8 8 8h81.7v41.4h-81.7c-4.4 0-8 3.6-8 8v29.9c0 4.4 3.6 8 8 8h81.7v68.1c0 4.4 3.6 8 8 8h54.3c4.4 0 8-3.6 8-8v-68.1h82c4.4 0 8-3.6 8-8v-29.9c0-4.4-3.6-8-8-8h-82v-41.5h82c4.4 0 8-3.6 8-8v-29.9c0-4.4-3.6-8-8-8h-62l69.35-122.49c0.6-1.19 1-2.49 1-3.79z"></path>
      <path d="M881.35 494.82c-18.36-43.4-43.94-82.75-76.08-117.2 11.61-8.36 19.18-21.97 19.18-37.33v-89.17c0-25.36-20.64-46-46-46h-58.89l3.43-4.31c19.38-22.33 22.22-52.67 7.14-77.7-8.18-13.58-21.12-24.41-36.43-30.51-15.79-6.29-33.15-7.35-50.19-3.07L517.4 120.59c-3.05 0.75-6.25 0.69-9.27-0.18L378.66 83.26l-1.37-0.29c-34.1-7.12-67.94 7.2-84.21 35.65-14.07 24.6-11.06 54.17 7.54 75.94l7.81 10.55h-62.89c-25.36 0-46 20.64-46 46v89.17c0 15.36 7.58 28.98 19.18 37.33-32.14 34.45-57.72 73.8-76.08 117.2-20.91 49.45-31.52 101.95-31.52 156.05 0 33.56 4.08 66.5 12.17 98.48 8.2 36.67 19.98 73.9 43.03 104.64a231.09 231.09 0 0 0 21.47 24.76c42.25 42.25 98.18 65.83 157.79 66.64v0.04H673.6v-0.01c60.49-0.22 117.33-23.87 160.12-66.67 13.9-13.9 25.77-29.29 35.49-45.81a224.563 224.563 0 0 0 23.62-56.67c13.29-40.3 20.01-82.35 20.01-125.41 0.03-54.09-10.58-106.59-31.49-156.03zM392.03 166.16l95.14 27.3a94.194 94.194 0 0 0 48.42 0.92l95.88-23.62c1.39-0.34 2.71-0.32 3.91-0.01 0.6 0.15 1.17 0.38 1.7 0.66s1.03 0.62 1.48 1.01c0.23 0.19 0.44 0.4 0.64 0.62 0.4 0.44 0.76 0.91 1.07 1.43 0.3 0.51 0.55 1.06 0.74 1.62 0.28 0.85 0.42 1.75 0.4 2.66-0.04 1.62-0.58 3.27-1.77 4.77l-17.18 21.61H403.02l-19.63-26.5a8.2 8.2 0 0 1-1.41-3c-0.14-0.61-0.21-1.23-0.2-1.84 0.07-4.87 4.73-9.21 10.25-7.63zM275.55 281.11h472.89v29.17H275.55v-29.17z m561.32 384.71c0 36.35-5.95 71.77-17.35 105.19a321.274 321.274 0 0 1-15.84 38.19c-26.35 44.93-75.16 75.17-130.9 75.17h-324c-48.67 0-92.04-23.05-119.81-58.79-13.46-23.76-23.79-49.09-30.83-75.49-7.24-27.15-11-55.42-11-84.27 0-2.54 0.03-5.08 0.09-7.61-0.05-2.44-0.09-4.89-0.09-7.35 0-38.36 6.62-75.71 19.29-110.74 15.99-44.21 41.63-84.74 75.86-118.97a329.296 329.296 0 0 1 41.1-34.87h377.22a327.862 327.862 0 0 1 41.1 34.87c34.96 34.96 60.96 76.5 76.87 121.81 12.01 34.21 18.28 70.58 18.28 107.91 0 2.49-0.03 4.97-0.09 7.46 0.06 2.48 0.1 4.99 0.1 7.49z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalFollow extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M812 112H212c-17.67 0-32 14.33-32 32v736c0 17.67 14.33 32 32 32h8c0.56 0 1.11-0.01 1.66-0.04 5.9 0.27 11.93-1.08 17.42-4.25l274.46-158.46L788 907.71c0.04 0.02 0.09 0.05 0.13 0.07 0.4 0.23 0.81 0.45 1.23 0.67l0.18 0.09c0.42 0.21 0.85 0.42 1.28 0.62 0.06 0.03 0.12 0.06 0.18 0.08 0.42 0.19 0.84 0.36 1.26 0.53 0.08 0.03 0.17 0.07 0.25 0.1 0.39 0.15 0.79 0.29 1.19 0.43 0.12 0.04 0.23 0.08 0.35 0.12 0.36 0.12 0.72 0.23 1.09 0.33 0.16 0.05 0.32 0.09 0.48 0.14 0.32 0.09 0.64 0.17 0.97 0.24 0.21 0.05 0.41 0.1 0.62 0.14 0.28 0.06 0.56 0.12 0.84 0.17 0.25 0.05 0.51 0.09 0.76 0.14 0.25 0.04 0.49 0.08 0.74 0.11 0.29 0.04 0.58 0.08 0.87 0.11 0.22 0.02 0.44 0.05 0.67 0.07a27.64 27.64 0 0 0 1.6 0.1c0.31 0.01 0.61 0.02 0.92 0.02 0.13 0 0.26 0.01 0.39 0.01h8c17.67 0 32-14.33 32-32V144c0-17.67-14.33-32-32-32z m-40 703.34L513.49 666.08 252 817.1V184h520v631.34z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalCancelFollow extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M840 790.41l-56-32.33c-5.33-3.08-12 0.77-12 6.93v50.33L513.49 666.08 252 817.1V455.55c0-2.86-1.52-5.5-4-6.93l-56-32.33c-5.33-3.08-12 0.77-12 6.93V880c0 17.67 14.33 32 32 32h8c0.56 0 1.11-0.01 1.66-0.04 5.9 0.27 11.93-1.08 17.42-4.25l274.46-158.46L788 907.71c0.04 0.02 0.09 0.05 0.13 0.07 0.4 0.23 0.81 0.45 1.23 0.67l0.18 0.09c0.42 0.21 0.85 0.42 1.28 0.62 0.06 0.03 0.12 0.06 0.18 0.08 0.42 0.19 0.84 0.36 1.26 0.53 0.08 0.03 0.16 0.07 0.25 0.1 0.39 0.15 0.79 0.3 1.19 0.43 0.12 0.04 0.23 0.08 0.35 0.12 0.36 0.12 0.72 0.23 1.09 0.33 0.16 0.05 0.32 0.09 0.48 0.14 0.32 0.09 0.64 0.17 0.97 0.24 0.21 0.05 0.41 0.1 0.62 0.14 0.28 0.06 0.56 0.12 0.84 0.17 0.25 0.05 0.51 0.09 0.76 0.14 0.25 0.04 0.49 0.08 0.74 0.11 0.29 0.04 0.58 0.08 0.87 0.11a27.64 27.64 0 0 0 2.27 0.17c0.31 0.01 0.61 0.02 0.92 0.02 0.13 0 0.26 0.01 0.39 0.01h8c17.67 0 32-14.33 32-32v-82.66c0-2.86-1.52-5.5-4-6.93zM184 208.53l56 32.33c5.33 3.08 12-0.77 12-6.93V184h520v359.39c0 2.86 1.52 5.5 4 6.93l56 32.33c5.33 3.08 12-0.77 12-6.93V144c0-17.67-14.33-32-32-32H212c-17.67 0-32 14.33-32 32v57.6c0 2.86 1.52 5.5 4 6.93zM929.91 703.71a8.01 8.01 0 0 0-4-6.84L103.7 222.17c-0.21-0.12-0.43-0.23-0.65-0.34-4.81-2.23-10.28 1.6-10.28 6.91l0.1 65.71c0 2.85 1.53 5.49 4 6.92l822.92 475.11c0.21 0.12 0.43 0.23 0.65 0.34 4.82 2.23 10.3-1.64 10.24-6.96l-0.77-66.15z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalBatchOperation extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M915.49 205.6h-69.9c-9.8 0-19.1 4.5-25.1 12.2L588.26 512.46 482.82 373.71c-6.1-7.7-15.3-12.2-25.1-12.2h-69.9c-6.7 0-10.4 7.7-6.3 12.9l181.63 235.26c12.8 16.2 37.4 16.2 50.3 0L921.79 218.4c4.1-5.1 0.4-12.8-6.3-12.8z"></path>
      <path d="M864 504h-56c-4.42 0-8 3.58-8 8v191.86H324v-476h260.5c4.42 0 8-3.58 8-8v-56c0-4.42-3.58-8-8-8H284c-17.67 0-32 14.33-32 32v100H144c-17.7 0-32 14.3-32 32v556c0 17.7 14.3 32 32 32h556c17.7 0 32-14.3 32-32v-100h108c17.67 0 32-14.33 32-32V512c0-4.42-3.58-8-8-8zM660 787.86v48H184v-476h68v384c0 17.67 14.33 32 32 32h376v12z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandButler extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M900.2 234.8h-120.2v-88.3c0-5.8-3.6-10.5-8-10.5h-56c-4.4 0-8 4.7-8 10.5v88.3h-372v-86.9c0-6.6-3.6-11.9-8-11.9h-56c-4.4 0-8 5.3-8 11.9v86.9h-139.8a32 32 0 0 0-32 32v589.2a32 32 0 0 0 32 32h776a32 32 0 0 0 32-32v-589.2a32 32 0 0 0-32-32z m-40 581.2h-696v-509.2h696z"></path>
      <path d="M360 645.4a44 44 0 0 0 44-44v-80a44 44 0 0 0-88 0v80a44 44 0 0 0 44 44z"></path>
      <path d="M664 645.4a44 44 0 0 0 44-44v-80a44 44 0 0 0-88 0v80a44 44 0 0 0 44 44z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandRobot extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M867.16 812.47H155.34c-4.45 0-8.09 3.6-8.09 8v56c0 4.4 3.64 8 8.09 8h711.82c4.45 0 8.09-3.6 8.09-8v-56c0-4.4-3.64-8-8.09-8zM842.89 138.47H179.6c-17.8 0-32.36 14.4-32.36 32v496c0 17.6 14.56 32 32.36 32h663.29c17.8 0 32.36-14.4 32.36-32v-496c0-17.6-14.56-32-32.36-32z m-39.64 488h-584v-416h584v416z"></path>
      <path d="M651.9 482.47H370.59c-4.04 0-7.34 3.3-7.34 7.34v57.32c0 4.04 3.3 7.34 7.34 7.34H651.9c4.04 0 7.34-3.3 7.34-7.34v-57.32c0.01-4.04-3.3-7.34-7.34-7.34z"></path>
      <path d="M355.25 346.47m-56 0a56 56 0 1 0 112 0 56 56 0 1 0-112 0Z"></path>
      <path d="M667.25 346.47m-56 0a56 56 0 1 0 112 0 56 56 0 1 0-112 0Z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class FileSearch extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M873.46 878.47l-93.19-93.19c22.27-29.47 35.56-66.22 35.56-106.07 0-97.09-78.71-175.79-175.79-175.79s-175.79 78.71-175.79 175.79S542.95 855 640.04 855c35.76 0 68.92-10.69 96.69-28.97l94.59 94.59c1.6 1.6 3.6 2.3 5.59 2.3 2 0 4.1-0.8 5.59-2.3l30.96-30.96c3.1-3.1 3.1-8.09 0-11.19z m-233.42-87.39c-61.83 0-111.87-50.04-111.87-111.87s50.04-111.87 111.87-111.87S751.9 617.38 751.9 679.21s-50.04 111.87-111.86 111.87z"></path>
      <path d="M223.29 159.47h576v352h64v-392c0-17.6-14.4-32-32-32h-640c-17.6 0-32 14.4-32 32v784c0 17.6 14.4 32 32 32h320v-72h-288v-704z"></path>
      <path d="M710.48 296.14v-48c0-4.4-3.6-8-8-8h-384c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zM316.13 374.47c-3.11 0-5.66 2.55-5.66 5.66v52.69c0 3.11 2.55 5.66 5.66 5.66h188.69c3.11 0 5.66-2.55 5.66-5.66v-52.69c0-3.11-2.55-5.66-5.66-5.66H316.13z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalCompass extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M512.23 65.47c-246.85 0-447 200.15-447 447s200.15 447 447 447 447-200.15 447-447-200.15-447-447-447z m3.83 822c-207.06 0-378.83-167.94-378.83-375s171.77-375 378.83-375 375 167.94 375 375-167.94 375-375 375z"></path>
      <path d="M698 310.29c-7.48-2.9-15.61-2.71-22.91 0.47L421.72 421.64 310.93 675.01a29.822 29.822 0 0 0 0 24.03c3.18 7.29 9.07 13 16.55 15.89 3.55 1.4 7.2 2.06 10.94 2.06 4.11 0 8.13-0.84 11.97-2.52l253.37-110.88 110.79-253.37a29.822 29.822 0 0 0 0-24.03c-3.28-7.39-9.17-13-16.55-15.9zM453.2 502.63l69.31 69.31-123.2 53.94 53.89-123.25z m118.29 16.46l-65.56-65.56 116.56-50.93c-0.01 0-47.44 108.34-51 116.49z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalRead extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M928.21 111.47h-228.8c-49.1 0-97.1 14.07-138.4 40.62l-48.8 31.24-48.8-31.24c-41.2-26.55-89.3-40.62-138.4-40.62H96.21c-17.7 0-32 14.27-32 31.94v665.67c0 17.66 14.3 31.94 32 31.94h228.8c49.1 0 97.1 14.07 138.4 40.62l44.4 28.54c1.3 0.8 2.8 1.3 4.3 1.3s3-0.4 4.3-1.3l44.4-28.54c41.4-26.55 89.5-40.62 138.6-40.62h228.8c17.7 0 32-14.27 32-31.94V143.41c0-17.67-14.3-31.94-32-31.94z m-603.2 657.69h-188.8V183.33h188.8c35.4 0 69.8 10.08 99.5 29.14l48.8 31.24 2.79 1.82v560.39c-46.54-24.14-98.25-36.76-151.09-36.76z m563.2 0h-188.8c-52.92 0-104.71 12.66-151.31 36.87V245.66l3.01-1.96 48.8-31.24c29.7-19.06 64.1-29.14 99.5-29.14h188.8v585.84z"></path>
      <path d="M811.08 364.7h-184c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM811.08 516.7h-184c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM398.16 364.7h-184c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM398.16 516.7h-184c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalLocationFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M511.98 66.26c-96.21 0-192.41 36.71-265.8 110.2-146.9 146.85-146.9 384.96 0 531.81l237.5 237.74c15.62 15.64 40.97 15.64 56.6 0l237.5-237.74c146.97-146.98 146.97-385.09 0-531.81-73.33-73.49-169.6-110.2-265.8-110.2z m1.26 562.89c-55.2 0-105.2-22.5-141.4-58.6s-58.6-86.1-58.6-141.4c0-110.5 89.5-200 200-200s200 89.5 200 200c0 55.3-22.5 105.3-58.6 141.4-36.1 36.1-86.2 58.6-141.4 58.6z m0-72c-35.33 0-67.33-14.4-90.5-37.5s-37.5-55.1-37.5-90.5c0-70.72 57.28-128 128-128s128 57.28 128 128c0 35.39-14.4 67.39-37.5 90.5-23.11 23.1-55.17 37.5-90.5 37.5z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class DirectionLeftFill1 extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m104 316.9c0 10.3-4.9 19.9-13.2 25.9L457.4 512l145.4 105.1c8.3 6 13.2 15.7 13.2 25.9v46.9c0 6.5-7.4 10.3-12.7 6.5l-246-178c-4.4-3.2-4.4-9.7 0-12.9l246-178c5.3-3.8 12.7 0 12.7 6.5v46.9z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class DirectionRightFill1 extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m154.7 454.5l-246 178c-5.3 3.8-12.7 0-12.7-6.5v-46.9c0-10.3 4.9-19.9 13.2-25.9L566.6 512 421.2 406.8c-8.3-6-13.2-15.7-13.2-25.9V334c0-6.6 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.8 0 13z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandOdin extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M156.62 767.74l43.25-43.25a7.979 7.979 0 0 0 1.05-10C163.02 656.22 141 586.67 141 512c0-205.9 168.6-373.34 374.49-371.99 101.46 0.67 193.3 41.99 260.04 108.48l0.58 0.58 53.75-53.75 53.73-53.73c3.12-3.12 3.12-8.19 0-11.31l-39.6-39.6c-3.12-3.12-8.19-3.12-11.31 0l-57.81 57.81C701.21 95.33 610.76 64 513 64 265.99 64 64.79 265.38 65 512.39c0.08 94.44 29.4 182.05 79.39 254.26 2.83 4.1 8.71 4.62 12.23 1.09zM882.18 258.16c-2.83-4.11-8.71-4.63-12.24-1.1l-43.27 43.27a7.977 7.977 0 0 0-1.06 9.98c37.62 58.17 59.44 127.5 59.4 201.92-0.13 206.97-167.72 373.22-374.68 371.76-101.33-0.72-193.06-41.98-259.74-108.38l-0.01-0.01-107.5 107.49c-3.12 3.12-3.12 8.19 0 11.31l39.6 39.6c3.12 3.12 8.19 3.12 11.31 0l57.93-57.93c73.6 52.88 163.87 84 261.41 83.92 246.72-0.17 447.7-201.33 447.67-448.04-0.01-94.22-29.12-181.64-78.82-253.79z"></path>
      <path d="M662.67 297.19c-11.55-8.98-27.73-8.98-39.28 0l-86.72 67.41c-11.55 8.98-27.73 8.98-39.28 0l-86.72-67.41c-11.55-8.98-27.73-8.98-39.28 0l-94 73.07a31.995 31.995 0 0 0-12.36 25.26V560.1c0 9.88 4.56 19.2 12.36 25.26l113.64 88.34 106.37 82.7c11.55 8.98 27.73 8.98 39.28 0l106.36-82.68 113.64-88.34a31.995 31.995 0 0 0 12.36-25.26V395.53c0-9.88-4.56-19.2-12.36-25.26l-94.01-73.08z m33.96 242.56L517.04 681.22l-179.6-141.47-0.41-125.07 53.87-41.56 126.13 98.85 126.13-98.85 53.87 41.56-0.4 125.07z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandContract extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M192.57 795h639.97c17.68 0 32.02-14.33 32.02-32.01V588.33c-2.22-15.51-15.56-27.44-31.68-27.44H543.55v-65.51C643 478.29 718.68 391.6 718.68 287.23 718.68 170.57 624.15 76 507.55 76s-211.13 94.57-211.13 211.23c0 104.38 75.68 191.06 175.13 208.16v65.51H192.24c-16.13 0-29.46 11.92-31.68 27.44v174.65c-0.01 17.68 14.33 32.01 32.01 32.01z m219.79-412.54c-25.36-25.49-39.42-59.28-39.42-95.23S387 217.49 412.36 192c25.48-25.49 59.25-39.44 95.19-39.44s69.71 13.95 95.19 39.44c25.48 25.49 39.42 59.28 39.42 95.23s-13.94 69.74-39.42 95.23c-25.48 25.37-59.25 39.44-95.19 39.44s-69.71-14.07-95.19-39.44zM232.25 632.93h560.59v90.04H232.25v-90.04zM863.48 863.97H161.62c-5.01 0-9.07 4.06-9.07 9.08v53.88c0 5.01 4.06 9.07 9.07 9.07h701.86c5.01 0 9.07-4.06 9.07-9.07v-53.88c0-5.02-4.06-9.08-9.07-9.08z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandCpa extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M814.55 334.36L510.88 565.41l-94.64-78.6a8.004 8.004 0 0 0-5.07-1.81h-96.58c-7.48 0-10.86 9.35-5.11 14.14L505.93 663a7.976 7.976 0 0 0 10.02 0.15l402.49-316.12c5.99-4.68 2.69-14.29-4.92-14.29h-94.17c-1.73 0.01-3.42 0.58-4.8 1.62z"></path>
      <path d="M929.88 403.21l-55.94 47.41a8 8 0 0 0-2.82 6.1v108.42L511.56 835.71l-0.04 0.03v-0.05L151.96 565.11V297.19l144.01-112.81 215.58 169.39L727.1 184.41l85.72 67.15a7.984 7.984 0 0 0 10.09-0.19l43.87-37.18c3.87-3.28 3.74-9.29-0.26-12.4L746.9 108.73c-11.54-8.98-27.71-8.98-39.25 0L511.52 261.28 315.38 108.73c-11.54-8.98-27.71-8.98-39.25 0L92.34 251.68A31.967 31.967 0 0 0 80 276.92v304.36c0 9.86 4.55 19.18 12.34 25.23l203.42 158.21 196.13 152.55c11.54 8.98 27.71 8.98 39.25 0l196.13-152.55L930.69 606.5a31.962 31.962 0 0 0 12.34-25.23V409.31c0-6.81-7.96-10.5-13.15-6.1z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandScene extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M702.97 418.24l-91.24-14.02c-13.56-2.08-25.2-10.83-31.03-23.32L541 295.83c-11.85-25.38-47.75-25.38-59.59 0l-39.7 85.07c-5.83 12.49-17.47 21.24-31.03 23.32l-91.24 14.02c-26.48 4.07-37.3 36.56-18.59 55.84l68.31 70.41c9.12 9.4 13.26 22.6 11.16 35.56l-15.85 97.75c-4.42 27.27 24.36 47.67 48.41 34.3l78.43-43.6a40.92 40.92 0 0 1 39.81 0l78.43 43.6c24.05 13.37 52.84-7.03 48.41-34.3l-15.85-97.75c-2.1-12.96 2.04-26.16 11.16-35.56l68.31-70.41c18.69-19.29 7.87-51.77-18.61-55.84z m-125.6 118.11a15.891 15.891 0 0 0-4.31 13.67l13.73 84.14-70.93-39.21a15.89 15.89 0 0 0-15.39 0l-70.93 39.21 13.72-84.14a15.94 15.94 0 0 0-4.31-13.67l-58.01-59.45 79.52-12.15c5.24-0.8 9.74-4.16 11.99-8.96l35.71-76.08 35.71 76.08c2.25 4.8 6.75 10.16 11.99 10.96l79.52 10.15-58.01 59.45z"></path>
      <path d="M865.78 639.38c13.98-39.33 21.59-81.67 21.59-125.8 0-45.77-8.19-89.63-23.18-130.19 52.06-24.65 88.08-77.66 88.08-139.09 0-84.96-68.87-153.83-153.83-153.83-58.01 0-108.51 32.12-134.71 79.54C617.28 149.44 565.87 138 511.79 138c-51.3 0-100.19 10.29-144.73 28.91-26.66-45.71-76.22-76.43-132.96-76.43-84.96 0-153.83 68.87-153.83 153.83 0 58.43 32.58 109.23 80.55 135.27-15.9 41.62-24.62 86.8-24.62 134.01 0 45.6 8.13 89.3 23.01 129.73-47.1 26.3-78.95 76.62-78.95 134.39 0 84.96 68.87 153.83 153.83 153.83 55.02 0 103.28-28.89 130.47-72.33 45.21 19.28 94.97 29.96 147.22 29.96 54.99 0 107.22-11.82 154.29-33.05 26.8 45.15 76.04 75.43 132.36 75.43 84.96 0 153.83-68.87 153.83-153.83 0-60.82-35.28-113.37-86.48-138.34z m-67.35-476.99c45.24 0 81.91 36.67 81.91 81.91 0 32.94-19.45 61.31-47.48 74.31-27.24-44.77-63.59-83.39-106.47-113.29 13.86-25.57 40.92-42.93 72.04-42.93zM152.18 244.3c0-45.24 36.67-81.91 81.91-81.91 29.31 0 55.01 15.41 69.48 38.57-44.51 29.71-82.33 68.66-110.69 114.12-24.33-14.2-40.7-40.58-40.7-70.78z m81.91 615.31c-45.24 0-81.91-36.67-81.91-81.91 0-29.24 15.33-54.9 38.39-69.38 28.11 46.27 65.94 85.97 110.64 116.3-14.8 21.15-39.34 34.99-67.12 34.99z m277.7-42.37c-167.71 0-303.66-135.96-303.66-303.66s135.95-303.66 303.66-303.66 303.66 135.95 303.66 303.66-135.96 303.66-303.66 303.66z m286.64 42.37c-29.61 0-55.53-15.72-69.91-39.27 43.21-30.59 79.68-70.07 106.73-115.79 26.74 13.48 45.08 41.16 45.08 73.15 0.01 45.24-36.66 81.91-81.9 81.91z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandSearch extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M682.31 679.6c30.09-40.57 47.89-90.8 47.89-145.19 0-134.76-109.24-244-244-244s-244 109.24-244 244 109.24 244 244 244c54.39 0 104.62-17.81 145.19-47.89l146.34 146.34c4.19 4.19 11.04 4.19 15.23 0l35.68-35.68c4.19-4.19 4.19-11.04 0-15.23L682.31 679.6z m-196.1 26.81c-94.99 0-172-77.01-172-172s77.01-172 172-172 172 77.01 172 172-77.01 172-172 172z"></path>
      <path d="M762.61 144.01H265.46C155.21 144.01 65 234.22 65 344.47c0 78.74 46.02 147.25 112.48 179.98 5.14 2.53 11.21-0.98 11.54-6.71 1.13-19.38 4.12-38.26 8.8-56.47 0.82-3.18-0.4-6.57-3.09-8.46-34.18-23.98-56.64-63.67-56.64-108.35 0-72.77 59.54-132.3 132.3-132.3h489.13c72.77 0 132.3 59.54 132.3 132.3 0 64.58-46.89 118.73-108.3 130.1-4.17 0.77-6.9 4.75-6.17 8.92a298.67 298.67 0 0 1 4.51 51.79v0.09c0 4.66 4.13 8.23 8.75 7.58 97.12-13.73 172.46-97.73 172.46-198.49 0-110.23-90.21-200.44-200.46-200.44z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandStar extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M389.87 803.5H235V560.6h272.72c3.1 0 5.92-1.79 7.23-4.59l26.31-55.95c2.49-5.3-1.38-11.39-7.23-11.39H231.77c-39.5 0-69.56-35.46-63.08-74.43l43.59-262.29h597.5l43.59 262.29c4.93 29.66-11.31 57.27-36.77 68.78-4.05 1.83-5.78 6.67-3.87 10.68l26.6 55.96c1.75 3.69 6.02 5.48 9.87 4.12 53.01-18.76 88.06-73.62 78.2-132.78l-52.21-313.27C872.61 92.3 859.27 81 843.64 81H178.41c-15.63 0-28.97 11.3-31.54 26.72L94.66 420.99c-9.24 55.43 20.95 107.07 68.39 128.8v293.68c0 17.66 14.32 31.97 31.97 31.97h194.85c4.41 0 7.99-3.58 7.99-7.99V811.5c0-4.43-3.58-8-7.99-8z"></path>
      <path d="M847.32 749.89l80.75-83.24c20.94-22.8 8.15-61.2-23.15-65.01l-107.86-16.57c-16.03-3.46-27.79-13.8-34.69-28.57l-48.93-100.56c-14-30.01-56.44-30.01-70.45 0L596.05 556.5c-6.89 14.77-20.65 25.11-36.68 27.57l-107.86 16.57c-31.31 4.81-44.09 43.21-21.97 66.01l80.75 83.24c10.78 11.11 15.68 26.71 13.19 42.03l-18.74 115.55c-5.23 32.24 28.8 56.35 57.23 40.55l92.72-51.54a48.397 48.397 0 0 1 47.06 0l92.72 51.54c28.43 15.8 62.46-8.31 57.23-40.55l-18.74-115.55c-2.5-15.31 2.4-30.91 14.36-42.03z m-73.87-13.5a21.565 21.565 0 0 0-5.85 18.53l18.61 114.06-96.16-53.16a21.548 21.548 0 0 0-20.86 0l-96.16 53.16 18.6-114.06c1.1-6.75-1.07-13.63-5.85-18.53l-78.63-80.59 107.8-16.47c7.11-1.09 13.2-5.64 16.26-12.15l48.41-103.13 48.41 103.13c3.05 6.51 9.15 13.77 16.26 14.86l107.8 13.76-78.64 80.59z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalActivity extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M885.69 332h-96V136.07c0-22.76-23.04-38.27-44.09-29.66L342.3 291.57c-1.01 0.44-2.1 0.67-3.2 0.67H141c-17.6 0-31.99 14.42-31.99 32.04v347.81c0 10.8 8.83 19.64 19.62 19.64h32.51L204.7 896.4c3.8 13.94 16.44 23.61 30.87 23.61H355.2c21.1 0 36.42-20.09 30.87-40.47L340.1 691.72h0.66L745.6 877.3c21.05 8.61 44.09-6.9 44.09-29.66V652h96c17.67 0 32-14.33 32-32V364c0-17.67-14.33-32-32-32zM268.11 850.96l-35.99-160.23h32.99l36.99 160.23h-33.99zM717.7 783.2L340.76 620.28H180.99V364.1h159.78L717.7 202.52V783.2zM845.69 580h-56V404h56v176z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandImc extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M223.2 266c-3.96 0-7.2 3.6-7.2 8v48c0 4.4 3.24 8 7.2 8h345.6c3.96 0 7.2-3.6 7.2-8v-48c0-4.4-3.24-8-7.2-8H223.2zM369.6 394H222.4c-3.52 0-6.4 3.6-6.4 8v48c0 4.4 2.88 8 6.4 8h147.2c3.52 0 6.4-3.6 6.4-8v-48c0-4.4-2.88-8-6.4-8z"></path>
      <path d="M326 744.16H136v-560h752v324c0 4.42 3.58 8 8 8h56c4.42 0 8-3.58 8-8v-364c0-17.67-14.33-32-32-32H96c-17.67 0-32 14.33-32 32v640c0 17.67 14.33 32 32 32h230c4.42 0 8-3.58 8-8v-56c0-4.42-3.58-8-8-8z"></path>
      <path d="M863.32 704.3l-92.01-131.4c12.43-17.13 19.76-38.2 19.76-60.99 0-57.44-46.56-104-104-104s-104 46.56-104 104c0 22.79 7.33 43.85 19.76 60.99l-91.81 131.11c-0.34 0-0.68-0.01-1.03-0.01-57.44 0-104 46.56-104 104s46.56 104 104 104c46.24 0 85.42-30.18 98.95-71.91h148.84c13.5 41.78 52.7 72 98.98 72 57.44 0 104-46.56 104-104 0.01-55.24-43.06-100.41-97.44-103.79zM687.07 471.91c22.09 0 40 17.91 40 40s-17.91 40-40 40-40-17.91-40-40 17.91-40 40-40zM510 848c-22.09 0-40-17.91-40-40s17.91-40 40-40 40 17.91 40 40-17.91 40-40 40z m247.79-71.91H609c-6.47-20.09-18.88-37.51-35.17-50.19l80.66-115.19c10.25 3.38 21.2 5.21 32.58 5.21 12.22 0 23.94-2.11 34.84-5.99l77.85 111.18c-19.62 12.87-34.61 32.21-41.97 54.98z m98.98 72c-22.09 0-40-17.91-40-40s17.91-40 40-40 40 17.91 40 40-17.91 40-40 40z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MaterialHammer1 extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M592.97 876.01H105.12c-4.42 0-8 3.58-8 8v56.01c0 4.42 3.58 8 8 8h487.85c4.42 0 8-3.58 8-8v-56.01c0-4.42-3.58-8-8-8zM925.96 765.57L634.88 474.33l40.91 3.93c9.51 0.91 18.93-2.47 25.69-9.23l97.71-97.76c12.5-12.51 12.5-32.78 0-45.29L558.75 85.4c-12.5-12.51-32.76-12.51-45.26 0l-97.71 97.76a32.033 32.033 0 0 0-9.23 25.7l7.93 82.66c0.91 9.52-2.47 18.94-9.23 25.7l-80.14 80.19a31.979 31.979 0 0 1-25.69 9.23l-82.61-7.94a32.012 32.012 0 0 0-25.69 9.23L92.7 506.4c-12.5 12.51-12.5 32.78 0 45.29l240.45 240.58c12.5 12.51 32.76 12.51 45.26 0l98.42-98.47a32.033 32.033 0 0 0 9.23-25.7l-3.78-39.37L772.5 919.11c12.5 12.51 32.76 12.51 45.26 0l108.2-108.26c12.5-12.5 12.5-32.78 0-45.28zM450.01 494.56l0.14 0.14-47.05 46.87 11.97 112.02-59.02 59.72-184.14-184.25 56.06-56.55 111.53 9.41 151.88-151.59-11.19-109.15 56.21-56.24 183.59 183.69-55.54 55.57-113.27-10.12-49.29 49.09-0.26-0.26-51.62 51.65z m345.12 345.3L501.26 545.84l51.63-51.65 293.87 294.03-51.63 51.64z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalAccount extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M912.16 797.56c0-0.45 0.02-0.89 0.02-1.34 0-101.96-59.61-189.99-145.89-231.16 26.14-27.46 42.11-64.69 41.88-105.65-0.47-83.71-68.28-151.13-152-151.13-83.95 0-152 68.05-152 152 0 40.62 15.93 77.51 41.89 104.78-86.27 41.17-145.89 129.2-145.89 231.16l0.01 108.66c0 4.42 3.58 8 8 8h496c4.42 0 8-3.58 8-8l-0.02-107.32zM658.12 380.3c43.15 1.02 78.03 36.76 78.06 79.93 0.03 43.69-34.97 79.18-78.46 80.01-0.52 0-1.03-0.02-1.54-0.02s-1.03 0.02-1.54 0.02c-43.47-0.83-78.46-36.3-78.46-79.96 0-44.83 36.87-81.05 81.94-79.98zM472.18 796.22c0-100.85 81.13-182.73 181.68-183.97 0.77 0.01 1.54 0.03 2.32 0.03 0.77 0 1.54-0.02 2.31-0.03 100.55 1.24 181.69 83.12 181.69 183.97v44.66H472.21v-43.95c-0.02-0.41-0.03-0.66-0.03-0.71z"></path>
      <path d="M880.37 112.19h-736c-17.67 0-32 14.33-32 32v737c0 17.67 14.33 32 32 32h174.81c4.42 0 8-3.58 8-8v-56c0-4.42-3.58-8-8-8H184.37v-657h656v92.23c0 4.42 3.58 8 8 8h56c4.42 0 8-3.58 8-8V144.19c0-17.67-14.33-32-32-32z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalAlertFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M850.3 854.5H173.7c-7.57 0-13.7 6.13-13.7 13.7v44.6c0 7.57 6.13 13.7 13.7 13.7h676.6c7.57 0 13.7-6.13 13.7-13.7v-44.6c0-7.57-6.13-13.7-13.7-13.7zM484.01 169.42h55.97c4.42 0 8-3.58 8-7.99V65.49c0-4.42-3.58-7.99-8-7.99h-55.97c-4.42 0-8 3.58-8 7.99v95.93c0.01 4.42 3.59 8 8 8zM249.19 285.16c3.12 3.12 8.19 3.12 11.31 0l39.58-39.57c3.12-3.12 3.12-8.18 0-11.31l-67.85-67.83c-3.12-3.12-8.19-3.12-11.31 0l-39.58 39.57c-3.12 3.12-3.12 8.18 0 11.31l67.85 67.83zM763.5 285.16c3.12 3.12 8.19 3.12 11.31 0l67.85-67.83c3.12-3.12 3.12-8.18 0-11.31l-39.58-39.57c-3.12-3.12-8.19-3.12-11.31 0l-67.85 67.83c-3.12 3.12-3.12 8.18 0 11.31l39.58 39.57zM222 497.14V779c0 17.67 14.33 32 32 32h112V549.88c0-6.01 3.58-10.88 8-10.88h56c4.42 0 8 4.87 8 10.88V811h336c17.67 0 32-14.33 32-32V496.86C806 335.67 675.27 205 514 205S222 335.67 222 496.86v0.28z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalZoomIn extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M633.56 440H516V306.84a8.84 8.84 0 0 0-8.84-8.84h-58.32a8.84 8.84 0 0 0-8.84 8.84V440H322.44a8.44 8.44 0 0 0-8.44 8.44v59.12a8.44 8.44 0 0 0 8.44 8.44H440v133.16a8.84 8.84 0 0 0 8.84 8.84h58.32a8.84 8.84 0 0 0 8.84-8.84V516h117.56a8.44 8.44 0 0 0 8.44-8.44v-59.12a8.44 8.44 0 0 0-8.44-8.44z"></path>
      <path d="M919.36 866.87L768.88 716.38A374.47 374.47 0 0 0 854.5 477.5c0-207.66-168.34-376-376-376s-376 168.34-376 376 168.34 376 376 376a374.41 374.41 0 0 0 236.68-83.83l150.69 150.69a7.31 7.31 0 0 0 10.33 0l43.16-43.16a7.31 7.31 0 0 0 0-10.33zM478.5 781.5c-167.89 0-304-136.11-304-304s136.11-304 304-304 304 136.11 304 304-136.11 304-304 304z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalZoomOut extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M317 439m8.44 0l311.12 0q8.44 0 8.44 8.44l0 59.12q0 8.44-8.44 8.44l-311.12 0q-8.44 0-8.44-8.44l0-59.12q0-8.44 8.44-8.44Z"></path>
      <path d="M919.36 866.87L768.88 716.38A374.47 374.47 0 0 0 854.5 477.5c0-207.66-168.34-376-376-376s-376 168.34-376 376 168.34 376 376 376a374.41 374.41 0 0 0 236.68-83.83l150.69 150.69a7.31 7.31 0 0 0 10.33 0l43.16-43.16a7.31 7.31 0 0 0 0-10.33zM478.5 781.5c-167.89 0-304-136.11-304-304s136.11-304 304-304 304 136.11 304 304-136.11 304-304 304z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandSpeed extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M792 359.59H571.41L769.77 109a8 8 0 0 0-6.3-13h-384a7.94 7.94 0 0 0-6.91 4L113.1 548a8 8 0 0 0 6.9 12h174.64l-89.51 358c-1.91 7.81 7.51 13.32 13.31 7.71L797.51 373.3a8 8 0 0 0-5.51-13.71zM321.43 734l60.38-241.27H224.2L414.06 165H639L430.38 428.58h211.28zM904 666H792V552a8 8 0 0 0-8-8h-60a8 8 0 0 0-8 8v114H600a8 8 0 0 0-8 8v60a8 8 0 0 0 8 8h116v114a8 8 0 0 0 8 8h60a8 8 0 0 0 8-8V742h112a8 8 0 0 0 8-8v-60a8 8 0 0 0-8-8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandAutomaticPrice extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M668.6 320a8 8 0 0 0-8-8h-54.5a7.89 7.89 0 0 0-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 0 0-7.1-4.4h-55.7a7.46 7.46 0 0 0-3.8 1 8 8 0 0 0-3.2 10.8l103.9 191.6h-57a8 8 0 0 0-8 8v27.1a8 8 0 0 0 8 8h76v39h-76a8 8 0 0 0-8 8v27.1a8 8 0 0 0 8 8h76V704a8 8 0 0 0 8 8h49.9a8 8 0 0 0 8-8v-63.5h76.3a8 8 0 0 0 8-8v-27.1a8 8 0 0 0-8-8h-76.3v-39h76.3a8 8 0 0 0 8-8v-27.1a8 8 0 0 0-8-8H564l103.7-191.6a9.16 9.16 0 0 0 0.9-3.7zM157.9 504.2a353.32 353.32 0 0 1 603.5-242.4 358 358 0 0 1 27.9 31.4l-50 39.1a8 8 0 0 0 3 14.1l156.8 38.3a8 8 0 0 0 9.9-7.7l0.8-161.5a8 8 0 0 0-12.9-6.3l-47.8 37.4C770.7 146.3 648.6 82 511.5 82 277 82 86.3 270.1 82 503.8a8 8 0 0 0 8 8.2h60a8 8 0 0 0 7.9-7.8zM934 512h-60a8.05 8.05 0 0 0-8 7.8 353.32 353.32 0 0 1-603.5 242.4 358 358 0 0 1-27.9-31.4l49.9-39.1a8 8 0 0 0-3-14.1l-156.8-38.3a8 8 0 0 0-9.9 7.7l-0.8 161.7a8 8 0 0 0 12.9 6.3l47.8-37.4C253.3 877.7 375.4 942 512.5 942 747 942 937.7 753.9 942 520.2a8 8 0 0 0-8-8.2z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalStrictfp extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M512 512m-168 0a168 168 0 1 0 336 0 168 168 0 1 0-336 0Z"></path>
      <path d="M920 472.21h-82c-18.09-149.39-136.58-267.83-286-285.82V104a40 40 0 0 0-80 0v82.48c-149.06 18.3-267.17 136.59-285.21 285.73H104a40 40 0 0 0-40 40 40 40 0 0 0 40 40h82.84c18.21 148.94 136.24 267 285.16 285.31V920a40 40 0 0 0 80 0v-82.39c149.28-18 267.69-136.2 285.93-285.4H920a40 40 0 0 0 0-80zM512.38 768c-141.38 0-256-114.62-256-256s114.62-256 256-256 256 114.62 256 256-114.61 256-256 256z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalEqualSquare extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M880 112H144a32 32 0 0 0-32 32v736a32 32 0 0 0 32 32h736a32 32 0 0 0 32-32V144a32 32 0 0 0-32-32z m-40 728H184V184h656z"></path>
      <path d="M332 405m8 0l344 0q8 0 8 8l0 56q0 8-8 8l-344 0q-8 0-8-8l0-56q0-8 8-8Z"></path>
      <path d="M332 549m8 0l344 0q8 0 8 8l0 56q0 8-8 8l-344 0q-8 0-8-8l0-56q0-8 8-8Z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalTimeSandglassFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M602.35 487.76l86.81-75.11C748 365 776 318.93 776 265.14V184h72a16 16 0 0 0 16-16v-40a16 16 0 0 0-16-16H176a16 16 0 0 0-16 16v40a16 16 0 0 0 16 16h72v81.14c0 53.79 28 99.86 86.84 147.51l86.81 75.11a32.06 32.06 0 0 1 0 48.48l-86.81 75.11C276 659 248 705.07 248 758.86V840h-72a16 16 0 0 0-16 16v40a16 16 0 0 0 16 16h672a16 16 0 0 0 16-16v-40a16 16 0 0 0-16-16h-72v-81.14c0-53.79-28-99.86-86.84-147.51l-86.81-75.11a32.06 32.06 0 0 1 0-48.48z"></path>
      <path d="M343.63 768.4m7.2 0l325.6 0q7.2 0 7.2 7.2l0 57.6q0 7.2-7.2 7.2l-325.6 0q-7.2 0-7.2-7.2l0-57.6q0-7.2 7.2-7.2Z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalQuote extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M752 240H144a32 32 0 0 0-32 32v608a32 32 0 0 0 32 32h608a32 32 0 0 0 32-32V272a32 32 0 0 0-32-32z m-40 600H184V312h528z"></path>
      <path d="M880 112H264a8 8 0 0 0-8 8v56a8 8 0 0 0 8 8h576v576a8 8 0 0 0 8 8h56a8 8 0 0 0 8-8V144a32 32 0 0 0-32-32zM308 614h108v108a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8V614h108a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8H480V442a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v108H308a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalProposalOrderFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M553.4 193.4a31.94 31.94 0 0 0-22.6-9.4H192a32 32 0 0 0-32 32v704a32 32 0 0 0 32 32h512a32 32 0 0 0 32-32V389.3a31.94 31.94 0 0 0-9.4-22.6z m67.13 529.83l-76.12-44A311.15 311.15 0 0 1 442 780.8c-51.84 31.85-152.49 31.71-195.5 30a3.73 3.73 0 0 1-1.07-7.25c34.32-11.93 106.24-41.58 145.19-91 17-21.47 39.42-63.47 53.53-91.25l-72.67-42a15 15 0 0 1 1.86-26.85l216.42-87.6a15 15 0 0 1 20.41 11.79l32.6 231.6a14.94 14.94 0 0 1-22.24 14.99z"></path>
      <path d="M854.2 298.6L611.3 64.9a32.18 32.18 0 0 0-22.2-8.9H296a8 8 0 0 0-8 8v56a8 8 0 0 0 8 8h277l219 210.6V816a8 8 0 0 0 8 8h56a8 8 0 0 0 8-8V321.6a31.68 31.68 0 0 0-9.8-23z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandJointPromotion extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M686 299v-48c0-4.4-3.6-8-8-8H294c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zM294 371c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H294z"></path>
      <path d="M336.82 865H206V161h560v186.25c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V121c0-17.7-14.3-32-32-32H166c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h170.82c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"></path>
      <path d="M885.62 567.36l-224-121.43a15.971 15.971 0 0 0-15.24 0l-224 121.43c-5.16 2.8-8.38 8.2-8.38 14.08v241.12c0 5.88 3.22 11.28 8.38 14.08l224 121.43a15.971 15.971 0 0 0 15.24 0l224-121.43c5.16-2.8 8.38-8.2 8.38-14.08V581.44c0-5.88-3.22-11.28-8.38-14.08zM822 793.07l-168 91.07-168-91.07V610.93l168-91.07 168 91.07v182.14z"></path>
      <path d="M622 610v60h-60c-4.42 0-8 3.58-8 8v48c0 4.42 3.58 8 8 8h60v60c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-60h60c4.42 0 8-3.58 8-8v-48c0-4.42-3.58-8-8-8h-60v-60c0-4.42-3.58-8-8-8h-48c-4.42 0-8 3.58-8 8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandServiceCentre extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M924.79 338.4c-22.6-53.7-55-101.9-96.3-143.3-41.3-41.3-89.5-73.8-143.3-96.3-55-23.1-113.4-34.8-173.6-34.8h-2c-60.6 0.3-119.3 12.3-174.5 35.9-53.3 22.8-101.1 55.2-142 96.5-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.31 174.9 0.31 69.4 16.91 138.3 48.01 199.9v152c0 25.4 20.6 46 46 46h152.1c61.6 31.1 130.5 47.7 199.9 48h2.1c59.9 0 118-11.6 172.7-34.3 53.5-22.3 101.6-54.3 142.8-95.2 41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.91-174.5 0.29-60.9-11.51-120-34.81-175.6z m-151.18 438C703.53 845.8 610.56 884 511.59 884h-1.7c-60.28-0.3-120.17-15.3-173.05-43.5l-8.4-4.5H187.68V695.2l-4.5-8.4c-28.19-52.9-43.19-112.8-43.49-173.1-0.4-99.7 37.69-193.3 107.57-263.8 69.78-70.5 163.05-109.5 262.72-109.9h1.7c49.99 0 98.47 9.7 144.16 28.9 44.59 18.7 84.58 45.6 118.97 80 34.29 34.3 61.28 74.4 79.98 119 19.39 46.2 29.09 95.2 28.89 145.8-0.6 99.6-39.69 192.9-110.07 262.7z"></path>
      <path d="M692.56 522.37c-14.12 0-26.33 8.13-32.23 19.96h-0.02c-28.26 52.99-84.08 89.05-148.32 89.05-64.18 0-119.94-35.99-148.23-88.89l-0.01 0.01c-5.9-11.83-18.11-19.96-32.23-19.96-19.88 0-36 16.12-36 36 0 6.17 1.56 11.98 4.29 17.06h-0.01c40.28 76 120.17 127.78 212.18 127.78 91.8 0 171.56-51.55 211.92-127.28h-0.03a35.821 35.821 0 0 0 4.67-17.73c0.02-19.89-16.09-36-35.98-36z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalStable extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M783.36 732.37A147.66 147.66 0 0 0 931 586.5a8 8 0 0 0-0.75-3.43L785.5 270.16a8 8 0 0 0-7.24-4.63h-226l-1.94-29.22a79.8 79.8 0 1 0-78.31 0l-1.95 29.22H245.74a8 8 0 0 0-7.24 4.63L93.75 583.07a8 8 0 0 0-0.75 3.43 147.65 147.65 0 0 0 295.28 0 8 8 0 0 0-0.74-3.43L273.9 337.37h191.43l-35.14 527.79H180a8 8 0 0 0-8 8V929a8 8 0 0 0 8 8h662.43a8 8 0 0 0 8-8v-55.85a8 8 0 0 0-8-8H592.22l-35.14-527.78h193l-113.62 245.7a8 8 0 0 0-0.74 3.43 147.65 147.65 0 0 0 147.64 145.87zM174.62 584.7l66-154 66 154z m608.74-154l66 154H717.33z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalSalesVolume extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M864 121H160a32 32 0 0 0-32 32v520a32 32 0 0 0 32 32h316.4v32L311.6 845.1a7.92 7.92 0 0 0-2.3 11l30.3 47.2v0.1a8 8 0 0 0 11.1 2.3L512 799.9l161.3 105.8a8 8 0 0 0 11.1-2.3v-0.1l30.3-47.2a8 8 0 0 0-2.3-11L548 737.3V705h316a32 32 0 0 0 32-32V153a32 32 0 0 0-32-32zM748.9 310.61l-226.3 226.5a8 8 0 0 1-11.3 0l-86.1-86.2-101.8 101.8a8 8 0 0 1-11.3 0l-36.8-36.8a8 8 0 0 1 0-11.3l144.3-144.3a8 8 0 0 1 11.3 0l86.1 86.2 183.8-184a8 8 0 0 1 11.3 0l36.8 36.8a8 8 0 0 1 0 11.3z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class FileOperationRecord extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M286.94 242.92m8 0l383.84 0q8 0 8 8l0 47.97q0 8-8 8l-383.84 0q-8 0-8-8l0-47.97q0-8 8-8Z"></path>
      <path d="M286.94 370.86m8 0l173.92 0q8 0 8 8l0 47.97q0 8-8 8l-173.92 0q-8 0-8-8l0-47.97q0-8 8-8Z"></path>
      <path d="M357.73 864.62H207V161h559.75v206.11a8 8 0 0 0 8 8h56a8 8 0 0 0 8-8V121a32 32 0 0 0-32-32H167a32 32 0 0 0-32 32v783.6a32 32 0 0 0 32 32h190.73a8 8 0 0 0 8-8v-56a8 8 0 0 0-8-7.98z"></path>
      <path d="M661.1 463.24c-136.91 0-247.9 111-247.9 247.88S524.19 959 661.1 959 909 848 909 711.12 798 463.24 661.1 463.24z m0 423.8A175.92 175.92 0 1 1 837 711.12 175.92 175.92 0 0 1 661.1 887z"></path>
      <path d="M774.87 699.78h-96v-96a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v159.96h160a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-7.96z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalCalendarFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M112 880a32 32 0 0 0 32 32h736a32 32 0 0 0 32-32V460H112z m768-696H712v-84a8 8 0 0 0-8-8h-56a8 8 0 0 0-8 8v84H384v-84a8 8 0 0 0-8-8h-56a8 8 0 0 0-8 8v84H144a32 32 0 0 0-32 32v176h800V216a32 32 0 0 0-32-32z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalCrowdFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M899.2 575.5c-27.6-25.5-141.8-94.3-150.4-109.1-2-7.8 2.5-14.4 7.5-27 92.1-155.9 15-329.7-145.1-318.8 90.1 92.9 84.8 242.4 16.9 341.9-8 14-22.7 40.4-24.1 54.1 99.9 69.9 277.4 121.9 278.2 269.4v26.5h45.8a32 32 0 0 0 32-32v-84.9c0-43.1-20.4-84.1-60.8-120.1z"></path>
      <path d="M609.5 596.2c-55.4-29.4-88.7-57.7-58.1-124.5 26.6-57.5 64.2-102.7 65.4-172.6 2.1-100.5-74.5-189.1-175.7-187.1-101.1-2-177.6 86.7-175.5 187.1 1.2 69.8 38.8 115.1 65.4 172.6 30.6 66.3-2.8 95.4-58.1 124.5-73.3 46.2-202.4 87-208.7 189.8v94a32 32 0 0 0 32 32h690a32 32 0 0 0 32-32v-94c-5.2-101.5-134.9-143.5-208.7-189.8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalOriginalityFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M632 921.5H392a8 8 0 0 0-8 8v32a32 32 0 0 0 32 32h192a32 32 0 0 0 32-32v-32a8 8 0 0 0-8-8zM512 38.5c-211 0-382 171-382 382 0 137.64 72.8 258.28 182 325.5v88.5a32 32 0 0 0 32 32h336a32 32 0 0 0 32-32V746c109.2-67.22 182-187.86 182-325.5 0-210.97-171-382-382-382z m-93.49 197.56l0.06 0.11A216 216 0 0 0 296.92 430.5c0 3.67 0.11 7.31 0.29 10.94 0.05 0.57 0.08 1.14 0.1 1.72 0 0.31 0 0.62 0.05 0.94a32 32 0 0 1-64 0h-0.07q-0.33-6.77-0.34-13.6c0-109.6 63-204.49 154.72-250.46a32 32 0 0 1 30.87 56z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandKeywordFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M470.88 549.42h82.55l-41.28-118.35-41.27 118.35z"></path>
      <path d="M854.6 288.7L639.4 73.4a32.18 32.18 0 0 0-22.7-9.4H192a32 32 0 0 0-32 32v832a32 32 0 0 0 32 32h640a32 32 0 0 0 32-32V311.3a31.94 31.94 0 0 0-9.4-22.6zM653.15 684.2h-47a8 8 0 0 1-7.55-5.37l-22.81-65.41H448.56l-22.81 65.41a8 8 0 0 1-7.55 5.37h-47a8 8 0 0 1-7.55-10.64l114.35-328a8 8 0 0 1 7.55-5.36h53.22a8 8 0 0 1 7.56 5.36l114.38 328a8 8 0 0 1-7.56 10.64z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandLiveBroadcastFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M917.8 218H740.21l90-90a17.53 17.53 0 0 0 0-24.78l-26.13-26.09a17.53 17.53 0 0 0-24.78 0L638.38 218H387.11L247.19 78.13a17.53 17.53 0 0 0-24.78 0l-26.13 26.13a17.53 17.53 0 0 0 0 24.78l89 89H108.2C88.73 218 73 230.34 73 245.56v632.92C73 893.7 88.73 906 108.2 906h809.6c19.47 0 35.2-12.3 35.2-27.52V245.56c0-15.22-15.73-27.56-35.2-27.56zM638.27 589.64l-197.34 148a16 16 0 0 1-25.6-12.79v-296a16 16 0 0 1 25.6-12.8L638.27 564a16 16 0 0 1 0 25.64z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandDetailsFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M880 112.21H144a32 32 0 0 0-32 32v736a32 32 0 0 0 32 32h736a32 32 0 0 0 32-32v-736a32 32 0 0 0-32-32z m-532 572a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8v-56a8 8 0 0 1 8-8h56a8 8 0 0 1 8 8z m0-144a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8v-56a8 8 0 0 1 8-8h56a8 8 0 0 1 8 8z m0-144a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8v-56a8 8 0 0 1 8-8h56a8 8 0 0 1 8 8z m400 287.68a8.31 8.31 0 0 1-8.32 8.32H436.32a8.31 8.31 0 0 1-8.32-8.32v-55.36a8.31 8.31 0 0 1 8.32-8.32h303.36a8.31 8.31 0 0 1 8.32 8.32z m0-144a8.31 8.31 0 0 1-8.32 8.32H436.32a8.31 8.31 0 0 1-8.32-8.32v-55.36a8.31 8.31 0 0 1 8.32-8.32h303.36a8.31 8.31 0 0 1 8.32 8.32z m0-144a8.31 8.31 0 0 1-8.32 8.32H436.32a8.31 8.31 0 0 1-8.32-8.32v-55.36a8.31 8.31 0 0 1 8.32-8.32h303.36a8.31 8.31 0 0 1 8.32 8.32z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandUnitFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M65.5 813m8 0l877 0q8 0 8 8l0 56q0 8-8 8l-877 0q-8 0-8-8l0-56q0-8 8-8Z"></path>
      <path d="M666 332.88h-32v216h32a80 80 0 0 0 80-80v-56a80 80 0 0 0-80-80zM321.56 478.11h82.55l-41.28-118.36-41.27 118.36z"></path>
      <path d="M926.5 141h-829a32 32 0 0 0-32 32v560a8 8 0 0 0 8 8h877a8 8 0 0 0 8-8V173a32 32 0 0 0-32-32zM503.7 613h-47a8 8 0 0 1-7.55-5.36l-22.82-65.41H299.11l-22.81 65.41a8 8 0 0 1-7.55 5.36h-47a8 8 0 0 1-7.56-10.63l114.39-328a8 8 0 0 1 7.55-5.37h53.22a8 8 0 0 1 7.55 5.37l114.39 328A8 8 0 0 1 503.7 613z m306.17-120a120 120 0 0 1-120 120h-112a8 8 0 0 1-8-8V277a8 8 0 0 1 8-8h112a120 120 0 0 1 120 120z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalUserChart extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M518.12 415.95h-61.63c-2.87 0-5.19 3.3-5.19 7.38v241.25c0 4.07 2.32 7.38 5.19 7.38h61.63c2.86 0 5.19-3.3 5.19-7.38V423.32c-0.01-4.07-2.33-7.37-5.19-7.37zM256.49 337.95c-2.87 0-5.19 2.59-5.19 5.77v322.45c0 3.19 2.32 5.78 5.19 5.78h61.63c2.86 0 5.19-2.59 5.19-5.78V343.72c0-3.19-2.32-5.77-5.19-5.77h-61.63z"></path>
      <path d="M514.19 780.81H123.3V229.09h735.68v141.86c0 4.42 3.58 8 8 8h56c4.42 0 8-3.58 8-8V189.09c0-17.67-14.33-32-32-32H83.3c-17.67 0-32 14.33-32 32v631.72c0 17.67 14.33 32 32 32h430.89c4.42 0 8-3.58 8-8v-56c0-4.42-3.58-8-8-8z"></path>
      <path d="M885.13 680.7c22.24-24.2 35.74-56.56 35.49-92.08-0.52-73.31-60.39-133.16-133.7-133.67-74.81-0.52-135.62 59.97-135.62 134.66 0 35.13 13.46 67.12 35.49 91.09-53.2 33.15-88.61 92.17-88.61 159.46 0 4.62 0.17 9.21 0.51 13.75 0.31 4.2 3.77 7.47 7.99 7.47h56.21c4.74 0 8.45-4.1 7.95-8.82-0.44-4.09-0.66-8.23-0.66-12.4 0-31.31 12.34-60.71 34.72-82.67 21.3-20.9 50.05-32.81 79.89-33.1 31.35-0.3 60.88 11.76 83.02 33.9 21.87 21.87 33.91 50.94 33.91 81.86 0 4.17-0.22 8.31-0.66 12.4-0.5 4.72 3.21 8.82 7.95 8.82h56.21c4.21 0 7.68-3.27 7.99-7.47 0.33-4.54 0.51-9.12 0.51-13.75 0.02-67.29-35.39-126.3-88.59-159.45z m-99.17-28.44c-34.55 0-62.66-28.11-62.66-62.66s28.11-62.66 62.66-62.66 62.66 28.11 62.66 62.66c0 34.56-28.1 62.66-62.66 62.66z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalArrowFollowFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M538.95 643.91c-14.44-31.62-11.89-67.88 6.83-97 8.9-13.85 21.16-25.47 35.45-33.62 30.58-16.15 57.94-18.21 92.14-4.11l129.69 58.87c5.3 2.4 11.31-1.47 11.31-7.28V144.01c0-17.89-13.78-32-32-32h-628.5c-19.6 0-32 15.59-32 32v735.96c0 23.14 23.8 38.63 44.96 29.26l301.29-133.48L613.15 840c6.73 2.98 13.58-3.94 10.52-10.64l-84.72-185.45zM288.11 260.12c0-4.41 3.58-8 8-8h344c4.42 0 8 3.59 8 8v56c0 4.42-3.58 8-8 8h-344c-4.42 0-8-3.58-8-8v-56z m180 200.74c0 4.42-2.69 8-6 8h-168c-3.32 0-6-3.58-6-8v-56c0-4.41 2.68-8 6-8h168c3.31 0 6 3.59 6 8v56z"></path>
      <path d="M946.51 716.62c-2.88-1.31-304.55-138.24-304.55-138.24-21.56-9.79-43.71 12.42-33.88 33.96 0 0 133.61 292.5 133.7 292.69 11.06 24.24 48.69 15.98 48.69-11.12v-128.6H935.4c28.02 0 34.86-37.07 11.11-48.69z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalUserFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M888.72 114.26H138.56c-13.33 0-24.14 10.81-24.14 24.14v750.15c0 13.33 10.81 24.14 24.14 24.14h750.15c13.33 0 24.14-10.81 24.14-24.14V138.4c0-13.33-10.8-24.14-24.13-24.14z m-374.2 155.23c80.29 0 145.38 65.09 145.38 145.38s-65.09 145.38-145.38 145.38-145.38-65.09-145.38-145.38 65.09-145.38 145.38-145.38z m225.54 474.77c-0.39 2.47-3.51 4.34-7.2 4.34H296.18c-3.7 0-6.81-1.87-7.2-4.34-0.4-2.52-0.61-5.06-0.61-7.62 0-57.66 101.25-104.39 226.14-104.39 124.9 0 226.14 46.74 226.14 104.39 0.01 2.56-0.19 5.11-0.59 7.62z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalPlusFollow extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M965.74 587.58h-136v-136c0-4.42-3.58-8-8-8h-56c-4.42 0-8 3.58-8 8v136h-136c-4.42 0-8 3.58-8 8v56c0 4.42 3.58 8 8 8h136v136c0 4.42 3.58 8 8 8h56c4.42 0 8-3.58 8-8v-136h136c4.42 0 8-3.58 8-8v-56c0-4.42-3.58-8-8-8z"></path>
      <path d="M650.12 799.36l-164.61-73.29-29.29-13.04-29.29 13.04L218.23 819V184h476v163.58c0 4.42 3.58 8 8 8h56c4.42 0 8-3.58 8-8V144c0-17.67-14.33-32-32-32h-556c-17.67 0-32 14.33-32 32v736.59c0 18.46 15.13 32.04 31.99 32.04 4.3 0 8.72-0.89 13.03-2.8l264.98-117.98 187.38 83.43c5.29 2.36 11.25-1.52 11.25-7.31v-61.3c0-3.16-1.86-6.02-4.74-7.31z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalConversion extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M929.32 652.16l-90.96-102.33c-3.18-3.58-8.78-3.58-11.96 0l-90.96 102.33c-4.59 5.16-0.92 13.31 5.98 13.31h54.96v172.95H560.26c-4.42 0-8 3.58-8 8v56c0 4.42 3.58 8 8 8h276.12c17.67 0 32-14.33 32-32V665.48h54.96c6.9 0 10.56-8.16 5.98-13.32zM197.6 474.51l90.96-102.33c4.59-5.16 0.92-13.31-5.98-13.31h-54.96v-173.3h229.66c4.42 0 8-3.58 8-8v-56c0-4.42-3.58-8-8-8H187.62c-17.67 0-32 14.33-32 32v213.29h-54.96c-6.9 0-10.57 8.16-5.98 13.31l90.96 102.33c3.18 3.59 8.77 3.59 11.96 0.01zM865.28 474.19c17.67 0 32-14.33 32-32v-296c0-17.67-14.33-32-32-32h-296c-17.67 0-32 14.33-32 32v296c0 17.67 14.33 32 32 32h296z m-256-288h216v216h-216v-216zM452.26 549.81h-296c-17.67 0-32 14.33-32 32v296c0 17.67 14.33 32 32 32h296c17.67 0 32-14.33 32-32v-296c0-17.67-14.33-32-32-32z m-40 288h-216v-216h216v216z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class FileUpload extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M753.64 468.15h0.26c-1.06 0.89-2.09 1.83-3.09 2.83l2.83-2.83zM818.69 470.98c-1-1-2.03-1.94-3.09-2.83h0.26l2.83 2.83z"></path>
      <path d="M975.39 627.68L815.86 468.15c-8.31-8.31-19.36-12.89-31.11-12.89s-22.8 4.58-31.11 12.89L594.11 627.68c-5.04 5.04-1.47 13.66 5.66 13.66h79.2c2.12 0 4.16-0.84 5.66-2.34l64.13-64.13v292.4c0 4.42 3.58 8 8 8h56c4.42 0 8-3.58 8-8v-292.4L884.89 639c1.5 1.5 3.54 2.34 5.66 2.34h79.2c7.11 0 10.68-8.62 5.64-13.66z"></path>
      <path d="M652.75 784.01H151.99V239.99h199.55l152.02 82.22h368.45v74.54c0 4.42 3.58 8 8 8h56c4.42 0 8-3.58 8-8V282.21c0-17.67-14.33-32-32-32H521.78l-152.02-82.22H111.99c-17.67 0-32 14.33-32 32v624.02c0 17.67 14.33 32 32 32h540.76c4.42 0 8-3.58 8-8v-56c0-4.42-3.58-8-8-8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class FileListCheckFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M264.57 159.83h576v459.34c0 3.06 3.7 4.59 5.86 2.43 16.28-16.28 37.92-25.24 60.94-25.24 0.58 0 1.15 0.01 1.72 0.02 1.91 0.05 3.48-1.52 3.48-3.43V119.83c0-17.67-14.33-32-32-32h-616c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z"></path>
      <path d="M589.07 819.64c-32.75-32.75-32.75-86.04 0-118.79l39.09-39.09c36.36-36.36 90.62-28.18 118.8 0 0 0 7.1 7.4 9.05 9.05 6.06 4.99 12.4-0.09 12.4-5.94V264c0-17.67-14.33-32-32-32h-576c-17.68 0-32 14.33-32 32v640c0 17.67 14.32 32 32 32h525.71c7.12 0 10.69-8.62 5.65-13.66l-102.7-102.7zM267.64 384c0-4.41 3.58-8 8-8h344c4.42 0 8 3.59 8 8v56c0 4.42-3.58 8-8 8h-344c-4.42 0-8-3.58-8-8v-56z m180 200.74c0 4.42-2.68 8-6 8h-168c-3.31 0-6-3.58-6-8v-56c0-4.41 2.69-8 6-8h168c3.32 0 6 3.59 6 8v56z"></path>
      <path d="M956.24 705.69l-36.01-36.01c-5.84-6.63-17.26-7.98-25.72 0L778.17 786.03c-0.53 0.53-1.13 0.64-1.54 0.64-0.41 0-1.02-0.11-1.54-0.64l-60.52-60.52c-7.4-7.17-17.85-7.17-25.72 0l-36.01 36.01c-7.74 8.25-6.45 18.83 0 25.72l110.93 110.93c3.43 3.43 8 5.33 12.86 5.33 4.86 0 9.42-1.89 12.86-5.33l166.76-166.76c7.08-7.09 7.08-18.63-0.01-25.72z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandFcpa extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M458.13 115.88H161.77c-17.67 0-32 14.33-32 32v320c0 4.42 3.58 8 8 8h56c4.42 0 8-3.58 8-8V363.61h240c4.42 0 8-3.58 8-8v-56c0-4.42-3.58-8-8-8h-240V187.88h256.36c4.42 0 8-3.58 8-8v-56c0-4.42-3.58-8-8-8zM596.18 459.88h283.89c4.42 0 8-3.58 8-8v-56c0-4.42-3.58-8-8-8H636.18v-200h244.11c4.42 0 8-3.58 8-8v-56c0-4.42-3.58-8-8-8H596.18c-17.67 0-32 14.33-32 32v280c0 17.67 14.33 32 32 32zM434.12 547.61H162.13c-17.67 0-32 14.33-32 32v320c0 4.42 3.58 8 8 8h56c4.42 0 8-3.58 8-8v-93.43h231.98c17.67 0 32-14.33 32-32V579.61c0.01-17.68-14.32-32-31.99-32z m-40 186.56H202.13V619.61h191.98v114.56zM782.23 547.61H670.24c-61.86 0-112 50.14-112 112v237.01c0 6.35 5.15 11.5 11.5 11.5h49c6.35 0 11.5-5.15 11.5-11.5v-90.45h191.98v90.45c0 6.35 5.15 11.5 11.5 11.5h49c6.35 0 11.5-5.15 11.5-11.5V659.61c0.01-61.86-50.14-112-111.99-112z m40 186.56H630.24V659.6c0-22.09 17.91-40 40-40h111.98c22.09 0 40 17.91 40 40v74.57z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalRadioTime extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M960 286.97c0-16.75-12.87-30.49-29.25-31.88v-0.12l-260.12 0.03 71.46-71.07c6.25-6.25 6.25-16.38 0-22.62l-22.62-22.62c-6.25-6.25-16.37-6.25-22.62 0L580.16 255H444.2L328.62 138.69c-6.25-6.25-16.37-6.25-22.62 0l-22.62 22.62c-6.25 6.25-6.25 16.38 0 22.62L353.72 255H95.98C78.32 255 64 269.33 64 287c0 0.2 0.01 0.4 0.02 0.6H64V853.99c0 17.67 14.32 32 31.98 32H927.53c17.66 0 31.98-14.33 31.98-32v-0.03c0 0.01 0.49-565.1 0.49-566.99z m-72.46 527.05H135.97V326.98h751.57v487.04z"></path>
      <path d="M480.17 603.47l222.47 128.44c3.61 2.09 8.33 0.68 10.54-3.15l28-48.5c2.21-3.83 1.07-8.62-2.54-10.71L548.5 559.78V415.97c0-4.33-3.58-7.84-8-7.84h-56c-4.42 0-8 3.51-8 7.84v180.31c0 0.08 0.01 0.15 0.01 0.22-0.14 2.81 1.17 5.53 3.66 6.97z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalRadioCloumn extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M959.88 260.9c0-16.75-12.87-30.49-29.25-31.88v-0.12l-260.12 0.03 71.46-71.07c6.25-6.25 6.25-16.38 0-22.62l-22.62-22.62c-6.25-6.25-16.37-6.25-22.62 0l-116.7 116.31H444.08L328.5 112.62c-6.25-6.25-16.37-6.25-22.62 0l-22.62 22.62c-6.25 6.25-6.25 16.38 0 22.62l70.34 71.07H95.87c-17.66 0-31.98 14.33-31.98 32 0 0.2 0.01 0.4 0.02 0.6h-0.01v566.39c0 17.67 14.32 32 31.98 32H927.43c17.66 0 31.98-14.33 31.98-32v-0.03c-0.01 0.01 0.47-565.1 0.47-566.99z m-72.46 527.05H135.86V300.92h751.57v487.03z"></path>
      <path d="M315.88 653.49h56c4.42 0 8-3.58 8-8V441.57c0-4.42-3.58-8-8-8h-56c-4.42 0-8 3.58-8 8v203.92c0 4.42 3.59 8 8 8zM483.88 690.14h56c4.42 0 8-3.58 8-8V404.92c0-4.42-3.58-8-8-8h-56c-4.42 0-8 3.58-8 8v277.23c0 4.41 3.59 7.99 8 7.99zM651.88 653.49h56c4.42 0 8-3.58 8-8V441.57c0-4.42-3.58-8-8-8h-56c-4.42 0-8 3.58-8 8v203.92c0 4.42 3.59 8 8 8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalRadioRow extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M960.13 286.97c0-16.75-12.87-30.49-29.25-31.88v-0.12l-260.12 0.03 71.46-71.07c6.25-6.25 6.25-16.38 0-22.62l-22.62-22.62c-6.25-6.25-16.37-6.25-22.62 0L580.28 255H444.32L328.75 138.69c-6.25-6.25-16.37-6.25-22.62 0l-22.62 22.62c-6.25 6.25-6.25 16.38 0 22.62L353.85 255H96.11c-17.66 0-31.98 14.33-31.98 32 0 0.2 0.01 0.4 0.02 0.6h-0.01V853.99c0 17.67 14.32 32 31.98 32H927.66c17.66 0 31.98-14.33 31.98-32v-0.03c0 0.01 0.49-565.1 0.49-566.99z m-72.46 527.05H136.1V326.98h751.57v487.04z"></path>
      <path d="M347.64 606.5h328c4.42 0 8-3.58 8-8v-56c0-4.42-3.58-8-8-8h-328c-4.42 0-8 3.58-8 8v56c0 4.42 3.58 8 8 8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalBookNewFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M940 142.38H578.2a64 64 0 0 0-64.05 64.05 64.05 64.05 0 0 0-64.06-64.05H84a32 32 0 0 0-32 32v636.16a32 32 0 0 0 32 32h360.8a8 8 0 0 1 7.11 4.34 72.08 72.08 0 0 0 128.56 0 8 8 0 0 1 7.11-4.34H940a32 32 0 0 0 32-32V174.4a32 32 0 0 0-32-32.02zM354.37 620.91a8 8 0 0 1-8 8H305a8 8 0 0 1-6.61-3.49L188 463.68v157.23a8 8 0 0 1-8 8h-32a8 8 0 0 1-8-8V380.7a8 8 0 0 1 8-8h41.18a8 8 0 0 1 6.78 3.75L306.33 539V380.7a8 8 0 0 1 8-8h32a8 8 0 0 1 8 8z m248.88-209.68a8 8 0 0 1-8 8H459.13v56h128.11a8 8 0 0 1 8 8v32a8 8 0 0 1-8 8H459.13v56h136.12a8 8 0 0 1 8 8v32a8 8 0 0 1-8 8H419.1a8 8 0 0 1-8-8V379.2a8 8 0 0 1 8-8h176.15a8 8 0 0 1 8 8zM884 620.13a8 8 0 0 1-8 8H667.82a8 8 0 0 1-8-8v-240.2a8 8 0 0 1 8-8h32a8 8 0 0 1 8 8v198.71h40V396a8 8 0 0 1 8-8h32a8 8 0 0 1 8 8v182.6h40V379.93a8 8 0 0 1 8-8h32a8 8 0 0 1 8 8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MaterialBrandFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M960.41 403.8l-0.59-0.84-206.45-293.61a32 32 0 0 0-26.1-13.46H296.72a31.91 31.91 0 0 0-25.93 13.25l-0.55 0.77a0.7 0.7 0 0 0-0.06 0.09L64 403.17a32 32 0 0 0 1.9 39.47l0.51 0.57L487.8 917.05c0.21 0.25 0.43 0.49 0.65 0.73a32 32 0 0 0 46.72 0.42l0.14-0.16 1-1.15 421-473.43 0.74-0.82 0.06-0.08a32 32 0 0 0 2.28-38.76zM717.63 542.46l-199 223.72a8 8 0 0 1-11.79 0.06l-0.3-0.35L307.9 542.46a8 8 0 0 1 6-13.32h69.46a8 8 0 0 1 6 2.68l118.08 132.84a7 7 0 0 0 5.33 2.33 7.59 7.59 0 0 0 5.32-2.33l118.12-132.84a8 8 0 0 1 6-2.68h69.46a8 8 0 0 1 5.96 13.32z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class MaterialFireFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M834.1 469.55a347.49 347.49 0 0 0-82.9-115.2l-29.1-26.7a8.09 8.09 0 0 0-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8a6.25 6.25 0 0 1-4.1 2 5.52 5.52 0 0 1-4.3-1.5 5.88 5.88 0 0 1-2-4.8c3.7-60.2-14.3-128.1-53.7-202-32.6-61.4-77.9-109.3-134.5-142.7l-41.3-24.3a8 8 0 0 0-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9a285.17 285.17 0 0 1-47 81.5 295.64 295.64 0 0 1-47.5 46.1 352.61 352.61 0 0 0-100.3 121.5 347.75 347.75 0 0 0-36.2 154.3 344.21 344.21 0 0 0 27.7 136 352.36 352.36 0 0 0 324.3 213 353.6 353.6 0 0 0 136.9-27.3 351.62 351.62 0 0 0 187.4-185.6 347.32 347.32 0 0 0-2.2-276.9z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateIntersectionFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M880 112H368a32 32 0 0 0-32 32v192H144a32 32 0 0 0-32 32v512a32 32 0 0 0 32 32h512a32 32 0 0 0 32-32V688h192a32 32 0 0 0 32-32V144a32 32 0 0 0-32-32zM616 840H184V408h152v248a32 32 0 0 0 32 32h248z m224-224H688V368a32 32 0 0 0-32-32H408V184h432z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateUnionFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M880 112H368a32 32 0 0 0-32 32v192H144a32 32 0 0 0-32 32v512a32 32 0 0 0 32 32h512a32 32 0 0 0 32-32V688h192a32 32 0 0 0 32-32V144a32 32 0 0 0-32-32z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class OperateSubtractionFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M880 112H368a32 32 0 0 0-32 32v184H144a32 32 0 0 0-32 32v520a32 32 0 0 0 32 32h520a32 32 0 0 0 32-32V688h184a32 32 0 0 0 32-32V144a32 32 0 0 0-32-32zM624 840H184V400h440z"></path>
      <path d="M268.5 660h271c2.49 0 4.5-2.75 4.5-6.15v-67.7c0-3.39-2-6.15-4.5-6.15h-271c-2.49 0-4.5 2.76-4.5 6.15v67.7c0 3.4 2 6.15 4.5 6.15z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalBoothFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M952.77 112.21h-880a8 8 0 0 0-8 8v56a8 8 0 0 0 8 8h55.49v647.47c0 18 13.76 32.52 30.72 32.52h317.28v86c0 5.51 3.4 10 7.59 10h56.83c4.19 0 7.58-4.47 7.58-10v-86h317.28c17 0 30.72-14.56 30.72-32.52V184.21h56.51a8 8 0 0 0 8-8v-56a8 8 0 0 0-8-8z m-280 276v56a8 8 0 0 1-8 8h-304a8 8 0 0 1-8-8v-56a8 8 0 0 1 8-8h304a8 8 0 0 1 8 7.99z m76 200a8 8 0 0 1-8 8h-456a8 8 0 0 1-8-8v-56a8 8 0 0 1 8-8h456a8 8 0 0 1 8 8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandStableCostPromotion extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M933.22 569L830.05 195a52 52 0 0 0-44.43-37.84l-549 0.16a52 52 0 0 0-42.5 37.59L90.8 569.12a52 52 0 0 0 50.12 65.82h208.4a52 52 0 0 0 50.12-65.83L305.5 228.85h170.12v558h-216a8 8 0 0 0-8 8v64a8 8 0 0 0 8 8h504a8 8 0 0 0 8-8v-64a8 8 0 0 0-8-8h-216v-558h171.23L625 569a52 52 0 0 0 36.34 64 52.56 52.56 0 0 0 13.78 1.87h208.1a52 52 0 0 0 50-65.81z m-766.1-6.19l78.16-281.18 76.84 281.18z m534.11-0.08l78-281.06L856 562.77z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class BrandMassivePromotion extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M512 938a426.1 426.1 0 0 1-165.83-818.51A427 427 0 0 1 704.74 132a8 8 0 0 1 3.43 10.89l-26.3 49.39a8 8 0 0 1-10.67 3.37 353.45 353.45 0 1 0 183.19 225.8 8 8 0 0 1 5.51-9.73l53.78-15.47a8 8 0 0 1 9.94 5.6A425.85 425.85 0 0 1 512 938z"></path>
      <path d="M412.54 636.71a126.16 126.16 0 0 1 0-178.19c7-7 25.7-25.7 168.33-102.54 68.58-37 133.71-70 134.36-70.35l10.92-5.54c27.59-14 57 15.42 43 43L763.63 334c-0.33 0.65-33.41 65.78-70.36 134.37C616.43 611 597.76 629.68 590.73 636.71a126.14 126.14 0 0 1-178.19 0zM647 402.29a6234.87 6234.87 0 0 0-32.06 17.14c-123.61 66.6-147.17 85.73-151.45 90a54 54 0 1 0 76.37 76.37c4.28-4.28 23.4-27.83 90-151.45 5.81-10.86 11.57-21.62 17.14-32.06z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalCrowdExtend extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M579 414a200 200 0 1 0-298 56.34 292.61 292.61 0 0 0-81 57c-55.69 55.27-86.37 130.91-86.37 209.36v166.43a8 8 0 0 0 8 8H318.4a8 8 0 0 0 8-8v-56a8 8 0 0 0-8-8H185.61V734.7a220.15 220.15 0 0 1 220.15-220.15V514A199.94 199.94 0 0 0 579 414z m-173.36 28a128 128 0 1 1 111-64 127.41 127.41 0 0 1-111 64z"></path>
      <path d="M856.26 664.17h-168v-168a8 8 0 0 0-8-8h-56a8 8 0 0 0-8 8v168h-168a8 8 0 0 0-8 8v56a8 8 0 0 0 8 8h168v168a8 8 0 0 0 8 8h56a8 8 0 0 0 8-8v-168h168a8 8 0 0 0 8-8v-56a8 8 0 0 0-8-8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalCrowdCut extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M599 262.21a200 200 0 1 0-318 208.13 292.61 292.61 0 0 0-81 57c-55.69 55.27-86.37 130.91-86.37 209.36v166.43a8 8 0 0 0 8 8H318.4a8 8 0 0 0 8-8v-56a8 8 0 0 0-8-8H185.61V734.7a220.15 220.15 0 0 1 220.15-220.15V514A199.93 199.93 0 0 0 599 262.21zM516.61 378a128 128 0 1 1-46.85-174.85A127.92 127.92 0 0 1 516.61 378z"></path>
      <path d="M893.34 743.07a108.11 108.11 0 0 0-181.72 5.46l-21.07-30.08 102-145.6a8 8 0 0 0-2-11.15l-39.32-27.53a8 8 0 0 0-11.14 2l-88.6 126.49L562.81 536a8 8 0 0 0-11.15-2l-39.31 27.54a8 8 0 0 0-2 11.14l102 145.73-21.06 30.08a108.06 108.06 0 1 0-4.18 117.55l64.31-91.84 63.63 90.88c16.42 23.45 41.22 40 69.37 45.19a108 108 0 0 0 108.92-167.2z m-358.59 86.31a44 44 0 1 1-10.81-61.28 44 44 0 0 1 10.81 61.28z m294.75 10.8a44 44 0 1 1 10.81-61.28 44 44 0 0 1-10.81 61.28z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalCrowdExtendFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M530.46 470.34A200 200 0 0 0 405.78 114c-110.46 0-200 89.54-200 200a199.61 199.61 0 0 0 75.32 156.34h-0.1a292.4 292.4 0 0 0-81 57c-55.69 55.27-86.37 130.9-86.37 209.36v166.43a8 8 0 0 0 8 8h422.63a8 8 0 0 0 8-8v-95a8 8 0 0 0-8-8h-120a48 48 0 0 1-48-48v-104a48 48 0 0 1 48-48h120a8 8 0 0 0 8-8v-105.7a8 8 0 0 0-4.12-7q-8.65-4.85-17.61-9.08z"></path>
      <path d="M856.26 664.17h-168v-168a8 8 0 0 0-8-8h-56a8 8 0 0 0-8 8v168h-168a8 8 0 0 0-8 8v56a8 8 0 0 0 8 8h168v168a8 8 0 0 0 8 8h56a8 8 0 0 0 8-8v-168h168a8 8 0 0 0 8-8v-56a8 8 0 0 0-8-8z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class NormalCrowdCutFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M605.78 314c0-110.46-89.54-200-200-200A200 200 0 0 0 281.1 470.34h-0.1a292.61 292.61 0 0 0-81 57c-55.69 55.27-86.37 130.9-86.37 209.36v166.43a8 8 0 0 0 8 8h226.7a8 8 0 0 0 6.7-12.36c-0.48-0.73-0.95-1.46-1.42-2.19a172.07 172.07 0 0 1 106.17-260c0.66-0.15 1.75-0.38 3.06-0.64a8 8 0 0 0 5-12.43l-23.64-33.76a48 48 0 0 1 11.8-66.83s74.5-52.58 74.48-52.58A199.61 199.61 0 0 0 605.78 314z"></path>
      <path d="M893.34 743.07a108.11 108.11 0 0 0-181.72 5.46l-21.07-30.08 102-145.6a8 8 0 0 0-2-11.15l-39.32-27.53a8 8 0 0 0-11.14 2l-88.6 126.49L562.81 536a8 8 0 0 0-11.15-2l-39.31 27.54a8 8 0 0 0-2 11.14l102 145.73-21.06 30.08a108.06 108.06 0 1 0-4.18 117.55l64.31-91.84 63.63 90.88c16.42 23.45 41.22 40 69.37 45.19a108 108 0 0 0 108.92-167.2z m-358.59 86.31a44 44 0 1 1-10.81-61.28 44 44 0 0 1 10.81 61.28z m294.75 10.8a44 44 0 1 1 10.81-61.28 44 44 0 0 1-10.81 61.28z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
export class DirectionDemotionFill extends Component<IconBaseProps> {
  iconSvg = () => (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
      version="1.1"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M939.9 361l-69.79 495.13a32 32 0 0 1-43.68 25.2L363.05 694c-24.72-10-27.1-44-4-57.38l155.64-89.86c-30.27-59.38-78.4-149.24-114.62-195.12C316.69 246 162.66 182.68 89.15 157.14c-8.35-2.9-6.53-15.2 2.3-15.55 92.1-3.65 307.63-4 418.57 64.1 111.61 68.48 179.91 153.46 219.15 217.24l163.05-94.13c23.09-13.34 51.41 5.77 47.68 32.2z"></path>
    </svg>
  );
  render() {
    return <Icon component={this.iconSvg} {...this.props} />;
  }
}
